import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from 'react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };

function fetcher<TData, TVariables>(client: GraphQLClient, query: string, variables?: TVariables, headers?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request<TData, TVariables>(query, variables, headers);
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AWSTimestamp: any;
};

export type Query = {
  __typename?: 'Query';
  checkAppointConfrict: CheckAppointConfrictResponse;
  checkForDuplicateCardNumbers: IsDuplicate;
  checkLastUpdate?: Maybe<AppointTimestamps>;
  checkPatients: IsPatients;
  getActiveSchedule?: Maybe<IsHoliday>;
  getAppoint: Appoint;
  getAppointByIdV2: AppointV2;
  getBlock: AppointBlock;
  getClinic: Clinic;
  getClinicScheduleByClinicId?: Maybe<ClinicSchedule>;
  getComment?: Maybe<Comment>;
  getComments?: Maybe<Comments>;
  getFloor?: Maybe<Floor>;
  getForm?: Maybe<Form>;
  getFormById?: Maybe<Form>;
  getLatestClinicConfig?: Maybe<ClinicConfig>;
  getManeger: Maneger;
  getMenu: Menu;
  getNotification?: Maybe<Notification>;
  getOrg: Org;
  getPatientByIdV2?: Maybe<PatientV2>;
  getPatientNameByIdV2?: Maybe<PatientNameV2>;
  getPatients: Patient;
  getPatientsByNumber: Patient;
  getPatientsForBackOffice: Patient;
  getPHRInfo?: Maybe<PhrInfo>;
  getPHRInfoById?: Maybe<PhrInfo>;
  getRecallItem?: Maybe<Recall>;
  getRoles: Role;
  getShift: Shift;
  getSpecificDateRule?: Maybe<ClinicSchedule>;
  getTodayShift: Shifts;
  getWeeklyShift: Shifts;
  isEntry: IsEntry;
  listAppointById?: Maybe<Appoints>;
  listAppointByIdV2?: Maybe<AppointsV2>;
  listAppointDetails: Array<AppointDetails>;
  listAppointDetailsById: Array<AppointDetails>;
  listCategorys: Categorys;
  listClinicConfig: Array<Maybe<ClinicConfig>>;
  listClinics: Clinics;
  listClinicSchedulesByClinicId: ClinicSchedules;
  listFacilities: Facilities;
  listFacilitiesByFilter: Facilities;
  listFacilitiesByGroupIds: ListFacilitiesByGroupIdsReturns;
  listFacilityGroups: FacilityGroups;
  listFloors: Array<Maybe<Floor>>;
  listGroupsByFacilityIds: ListGroupsByFacilityIdsReturns;
  listManeger: Manegers;
  listMenu: Menus;
  listOrgs: Orgs;
  listPatients: Patients;
  listPatientsByIdPaginated: PatientsV2;
  listPatientsByName: Patients;
  listPatientsByNameV2?: Maybe<PatientsV2>;
  listPatientsV2: PatientsV2;
  listPeriodAppoint: Appoints;
  listPeriodAppointById: Appoints;
  listPeriodNotification?: Maybe<Notifications>;
  listPeriodPHRInfo?: Maybe<PhrInfos>;
  listPeriodPHRInfoById?: Maybe<PhrInfos>;
  listRecallItems: Array<Maybe<Recall>>;
  listRoles: Roles;
  listShift: Shifts;
  listTodayAppoint: Appoints;
  scanPeriodAppoint: Appoints;
  scanPeriodBlock: AppointBlocks;
  validateBookingRule: IsValid;
  validateScheduleRule?: Maybe<IsValid>;
};


export type QueryCheckAppointConfrictArgs = {
  inputs: AppointInput;
};


export type QueryCheckForDuplicateCardNumbersArgs = {
  inputs: CheckForDuplicateCardNumbersInput;
};


export type QueryCheckLastUpdateArgs = {
  appointId: Scalars['ID'];
  beforeUpdated_at: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
};


export type QueryCheckPatientsArgs = {
  DNumber: Scalars['Int'];
  SNumber: Scalars['Int'];
};


export type QueryGetActiveScheduleArgs = {
  clinic_id: Scalars['ID'];
  current_date: Scalars['AWSTimestamp'];
};


export type QueryGetAppointArgs = {
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
};


export type QueryGetAppointByIdV2Args = {
  clinic_id: Scalars['ID'];
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
};


export type QueryGetBlockArgs = {
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
};


export type QueryGetClinicArgs = {
  clinic_id: Scalars['ID'];
  org_id: Scalars['ID'];
};


export type QueryGetClinicScheduleByClinicIdArgs = {
  clinic_id: Scalars['String'];
  clinic_schedule_id: Scalars['ID'];
};


export type QueryGetCommentArgs = {
  id: Scalars['ID'];
};


export type QueryGetCommentsArgs = {
  clinic_id: Scalars['ID'];
  date: Scalars['AWSTimestamp'];
};


export type QueryGetFloorArgs = {
  clinic_id: Scalars['ID'];
  floor_id: Scalars['ID'];
};


export type QueryGetFormArgs = {
  access_token: Scalars['String'];
};


export type QueryGetFormByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetLatestClinicConfigArgs = {
  clinic_id: Scalars['ID'];
  config_type: Scalars['String'];
  current_date: Scalars['AWSTimestamp'];
};


export type QueryGetManegerArgs = {
  id: Scalars['ID'];
};


export type QueryGetMenuArgs = {
  SDK_ID: Scalars['ID'];
};


export type QueryGetNotificationArgs = {
  access_token: Scalars['String'];
  startTime: Scalars['AWSTimestamp'];
};


export type QueryGetOrgArgs = {
  org_id: Scalars['ID'];
};


export type QueryGetPatientByIdV2Args = {
  clinic_id: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryGetPatientNameByIdV2Args = {
  clinic_id: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryGetPatientsArgs = {
  access_token: Scalars['String'];
};


export type QueryGetPatientsByNumberArgs = {
  number: Scalars['Int'];
  type: Scalars['String'];
};


export type QueryGetPatientsForBackOfficeArgs = {
  id: Scalars['ID'];
};


export type QueryGetPhrInfoArgs = {
  access_token: Scalars['String'];
  startTime: Scalars['AWSTimestamp'];
};


export type QueryGetPhrInfoByIdArgs = {
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
};


export type QueryGetRecallItemArgs = {
  clinic_id: Scalars['String'];
  id: Scalars['ID'];
};


export type QueryGetRolesArgs = {
  id: Scalars['ID'];
};


export type QueryGetShiftArgs = {
  date: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
};


export type QueryGetSpecificDateRuleArgs = {
  clinic_id: Scalars['ID'];
  current_date: Scalars['AWSTimestamp'];
};


export type QueryGetTodayShiftArgs = {
  date: Scalars['AWSTimestamp'];
};


export type QueryGetWeeklyShiftArgs = {
  id: Scalars['ID'];
  weekEnd: Scalars['AWSTimestamp'];
  weekStart: Scalars['AWSTimestamp'];
};


export type QueryIsEntryArgs = {
  access_token?: InputMaybe<Scalars['String']>;
};


export type QueryListAppointByIdArgs = {
  id: Scalars['ID'];
};


export type QueryListAppointByIdV2Args = {
  clinic_id: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryListAppointDetailsArgs = {
  inputs: ListAppointDetailsInputs;
};


export type QueryListAppointDetailsByIdArgs = {
  inputs: ListAppointDetailsByIdInputs;
};


export type QueryListCategorysArgs = {
  clinic_id: Scalars['ID'];
};


export type QueryListClinicConfigArgs = {
  clinic_id: Scalars['ID'];
  config_type: Scalars['String'];
};


export type QueryListClinicSchedulesByClinicIdArgs = {
  clinic_id: Scalars['String'];
};


export type QueryListFacilitiesArgs = {
  clinic_id: Scalars['ID'];
};


export type QueryListFacilitiesByFilterArgs = {
  inputs: ListFacilitiesByFilterInput;
};


export type QueryListFacilitiesByGroupIdsArgs = {
  input: ListFacilitiesByGroupIdsInput;
};


export type QueryListFacilityGroupsArgs = {
  inputs: ListFacilityGroupsInput;
};


export type QueryListFloorsArgs = {
  clinic_id: Scalars['ID'];
};


export type QueryListGroupsByFacilityIdsArgs = {
  inputs: ListGroupsByFacilityIdsInput;
};


export type QueryListManegerArgs = {
  clinic_id: Scalars['ID'];
};


export type QueryListMenuArgs = {
  clinic_id: Scalars['ID'];
};


export type QueryListPatientsArgs = {
  clinic_id: Scalars['ID'];
};


export type QueryListPatientsByIdPaginatedArgs = {
  clinic_id: Scalars['ID'];
  filterOption?: InputMaybe<InputFilterOption>;
  lastEvaluatedKey?: InputMaybe<InputLastEvaluatedKey>;
  orderOption?: InputMaybe<InputOrderOption>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type QueryListPatientsByNameArgs = {
  name: Scalars['String'];
};


export type QueryListPatientsByNameV2Args = {
  clinic_id: Scalars['ID'];
  name: Scalars['String'];
};


export type QueryListPatientsV2Args = {
  clinic_id: Scalars['ID'];
};


export type QueryListPeriodAppointArgs = {
  access_token: Scalars['String'];
  endDate: Scalars['AWSTimestamp'];
  startDate: Scalars['AWSTimestamp'];
};


export type QueryListPeriodAppointByIdArgs = {
  endDate: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  startDate: Scalars['AWSTimestamp'];
};


export type QueryListPeriodNotificationArgs = {
  access_token: Scalars['String'];
  endDate: Scalars['AWSTimestamp'];
  startDate: Scalars['AWSTimestamp'];
};


export type QueryListPeriodPhrInfoArgs = {
  access_token: Scalars['String'];
  endDate: Scalars['AWSTimestamp'];
  startDate: Scalars['AWSTimestamp'];
};


export type QueryListPeriodPhrInfoByIdArgs = {
  endDate: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  startDate: Scalars['AWSTimestamp'];
};


export type QueryListRecallItemsArgs = {
  filter?: InputMaybe<RecallFilterInput>;
};


export type QueryListRolesArgs = {
  clinic_id: Scalars['ID'];
};


export type QueryListTodayAppointArgs = {
  choice?: InputMaybe<Scalars['Int']>;
  date: Scalars['AWSTimestamp'];
};


export type QueryScanPeriodAppointArgs = {
  clinic_id: Scalars['ID'];
  endDate: Scalars['AWSTimestamp'];
  startDate: Scalars['AWSTimestamp'];
};


export type QueryScanPeriodBlockArgs = {
  clinic_id: Scalars['ID'];
  endTime: Scalars['AWSTimestamp'];
  startTime: Scalars['AWSTimestamp'];
};


export type QueryValidateBookingRuleArgs = {
  clinic_id: Scalars['ID'];
  clinicEndTime: ClinicHourMinutesInput;
  clinicStartTime: ClinicHourMinutesInput;
  ruleEndDate?: InputMaybe<Scalars['AWSTimestamp']>;
  ruleStartDate: Scalars['AWSTimestamp'];
  validationType?: InputMaybe<Scalars['String']>;
};


export type QueryValidateScheduleRuleArgs = {
  clinic_id: Scalars['ID'];
  clinic_schedule_id: Scalars['ID'];
  day?: InputMaybe<Scalars['Int']>;
  day_of_week?: InputMaybe<DayOfWeek>;
  end_date?: InputMaybe<Scalars['AWSTimestamp']>;
  rule_type: ClinicScheduleType;
  service_day?: InputMaybe<Scalars['Boolean']>;
  specific_date?: InputMaybe<Scalars['AWSTimestamp']>;
  start_date: Scalars['AWSTimestamp'];
  week?: InputMaybe<Week>;
};

export type AppointInput = {
  appointId?: InputMaybe<Scalars['String']>;
  clinic_id: Scalars['String'];
  date: Scalars['AWSTimestamp'];
  endTime: Scalars['AWSTimestamp'];
  facilityId: Scalars['String'];
  id: Scalars['ID'];
  staffIds?: InputMaybe<Array<InputMaybe<StaffIdInput>>>;
  startTime: Scalars['AWSTimestamp'];
};

export type StaffIdInput = {
  id: Scalars['ID'];
  index?: InputMaybe<Scalars['Int']>;
};

export type CheckAppointConfrictResponse = {
  __typename?: 'CheckAppointConfrictResponse';
  duplicatedStaffIdsWithFacility: Array<Maybe<DuplicatedInfo>>;
  isDoubleBooking: Scalars['Boolean'];
  isNonAccepted: Scalars['Boolean'];
  isStaffDoubleBooking: Scalars['Boolean'];
  isTimeConfrict: Scalars['Boolean'];
};

export type DuplicatedInfo = {
  __typename?: 'DuplicatedInfo';
  facilityId: Scalars['String'];
  staffIds: Array<Scalars['String']>;
};

export type CheckForDuplicateCardNumbersInput = {
  cardNumber: Scalars['Int'];
  clinic_id: Scalars['ID'];
  isOptional: Scalars['Boolean'];
  patient_id: Scalars['String'];
};

export type IsDuplicate = {
  __typename?: 'isDuplicate';
  isDuplicate: Scalars['Boolean'];
};

export type AppointTimestamps = {
  __typename?: 'AppointTimestamps';
  appointId: Scalars['ID'];
  created_at?: Maybe<Scalars['AWSTimestamp']>;
  id: Scalars['ID'];
  isUpdated?: Maybe<Scalars['Boolean']>;
  startTime: Scalars['AWSTimestamp'];
  updated_at?: Maybe<Scalars['AWSTimestamp']>;
};

export type IsPatients = {
  __typename?: 'isPatients';
  isPatients: Scalars['Boolean'];
};

export type IsHoliday = {
  __typename?: 'IsHoliday';
  isBeforeDay?: Maybe<Scalars['Boolean']>;
  isHoliday?: Maybe<Scalars['Boolean']>;
};

export type Appoint = {
  __typename?: 'Appoint';
  appoint?: Maybe<Scalars['String']>;
  appointId: Scalars['ID'];
  cancel?: Maybe<Cancel>;
  cancelTime?: Maybe<Scalars['AWSTimestamp']>;
  clinic_id: Scalars['ID'];
  confirmedEndTime?: Maybe<Scalars['AWSTimestamp']>;
  confirmedTime?: Maybe<Scalars['AWSTimestamp']>;
  consultationTime?: Maybe<Scalars['AWSTimestamp']>;
  created_at?: Maybe<Scalars['AWSTimestamp']>;
  date: Scalars['AWSTimestamp'];
  dentalFormula?: Maybe<DentalFormulaResponse>;
  endTime: Scalars['AWSTimestamp'];
  facilityId: Scalars['String'];
  id: Scalars['ID'];
  isDubbleBooking?: Maybe<Scalars['Boolean']>;
  isFirstVisiting?: Maybe<Scalars['Boolean']>;
  isLate?: Maybe<Scalars['Boolean']>;
  menuId?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  receptionTime?: Maybe<Scalars['AWSTimestamp']>;
  remarks?: Maybe<Scalars['String']>;
  secondEndTime?: Maybe<Scalars['AWSTimestamp']>;
  secondStartTime?: Maybe<Scalars['AWSTimestamp']>;
  staffIds: Array<StaffId>;
  startTime: Scalars['AWSTimestamp'];
  thirdEndTime?: Maybe<Scalars['AWSTimestamp']>;
  thirdStartTime?: Maybe<Scalars['AWSTimestamp']>;
  treatmentCompletedTime?: Maybe<Scalars['AWSTimestamp']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['AWSTimestamp']>;
};

export type Cancel = {
  __typename?: 'Cancel';
  cancelReason?: Maybe<Scalars['String']>;
  isCancel?: Maybe<Scalars['Boolean']>;
  radioCancelReason?: Maybe<Scalars['Int']>;
};

export type DentalFormulaResponse = {
  __typename?: 'DentalFormulaResponse';
  baby?: Maybe<DentalFormulaArrayResponse>;
  permanent?: Maybe<DentalFormulaArrayResponse>;
};

export type DentalFormulaArrayResponse = {
  __typename?: 'DentalFormulaArrayResponse';
  leftBottom?: Maybe<Array<Maybe<ToothStatus>>>;
  leftTop?: Maybe<Array<Maybe<ToothStatus>>>;
  rightBottom?: Maybe<Array<Maybe<ToothStatus>>>;
  rightTop?: Maybe<Array<Maybe<ToothStatus>>>;
};

export enum ToothStatus {
  False = 'FALSE',
  Pontic = 'PONTIC',
  True = 'TRUE'
}

export type StaffId = {
  __typename?: 'StaffId';
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
};

export type AppointV2 = {
  __typename?: 'AppointV2';
  appoint?: Maybe<Scalars['String']>;
  appointId: Scalars['ID'];
  cancel?: Maybe<Cancel>;
  cancelTime?: Maybe<Scalars['AWSTimestamp']>;
  clinic_id: Scalars['ID'];
  confirmedEndTime?: Maybe<Scalars['AWSTimestamp']>;
  confirmedTime?: Maybe<Scalars['AWSTimestamp']>;
  consultationTime?: Maybe<Scalars['AWSTimestamp']>;
  created_at?: Maybe<Scalars['AWSTimestamp']>;
  date: Scalars['AWSTimestamp'];
  dentalFormula?: Maybe<DentalFormulaResponse>;
  endTime: Scalars['AWSTimestamp'];
  facilityId: Scalars['String'];
  facilityName: Scalars['String'];
  id: Scalars['ID'];
  isDubbleBooking?: Maybe<Scalars['Boolean']>;
  isFirstVisiting?: Maybe<Scalars['Boolean']>;
  isLate?: Maybe<Scalars['Boolean']>;
  isPeriodicCheckup?: Maybe<Scalars['Boolean']>;
  menuId?: Maybe<Scalars['String']>;
  menuName?: Maybe<Scalars['String']>;
  patientKana?: Maybe<Scalars['String']>;
  patientName?: Maybe<Scalars['String']>;
  patientRemarks?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  receptionTime?: Maybe<Scalars['AWSTimestamp']>;
  remarks?: Maybe<Scalars['String']>;
  secondEndTime?: Maybe<Scalars['AWSTimestamp']>;
  secondStartTime?: Maybe<Scalars['AWSTimestamp']>;
  staffIds: Array<StaffId>;
  staffNames: Array<StaffName>;
  startTime: Scalars['AWSTimestamp'];
  thirdEndTime?: Maybe<Scalars['AWSTimestamp']>;
  thirdStartTime?: Maybe<Scalars['AWSTimestamp']>;
  treatmentCompletedTime?: Maybe<Scalars['AWSTimestamp']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['AWSTimestamp']>;
};

export type StaffName = {
  __typename?: 'StaffName';
  color?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  name: Scalars['String'];
};

export type AppointBlock = {
  __typename?: 'AppointBlock';
  clinic_id?: Maybe<Scalars['ID']>;
  color?: Maybe<Scalars['String']>;
  endTime: Scalars['AWSTimestamp'];
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
  isDelete?: Maybe<Scalars['Boolean']>;
  isNonAccepted?: Maybe<Scalars['Boolean']>;
  remarks?: Maybe<Scalars['String']>;
  startTime: Scalars['AWSTimestamp'];
};

export type Clinic = {
  __typename?: 'Clinic';
  clinic_id: Scalars['ID'];
  clinic_label: Scalars['String'];
  clinic_name: Scalars['String'];
  created_at: Scalars['AWSTimestamp'];
  isDelete: Scalars['Boolean'];
  org_id: Scalars['ID'];
  org_label?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['AWSTimestamp']>;
};

export type ClinicSchedule = {
  __typename?: 'ClinicSchedule';
  clinic_id: Scalars['String'];
  clinic_schedule_id: Scalars['ID'];
  created_at?: Maybe<Scalars['AWSTimestamp']>;
  day?: Maybe<Scalars['Int']>;
  day_of_week?: Maybe<DayOfWeek>;
  end_date?: Maybe<Scalars['AWSTimestamp']>;
  end_time?: Maybe<Scalars['String']>;
  rule_type: ClinicScheduleType;
  service_day?: Maybe<Scalars['Boolean']>;
  specific_date?: Maybe<Scalars['AWSTimestamp']>;
  start_date: Scalars['AWSTimestamp'];
  start_time?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['AWSTimestamp']>;
  week?: Maybe<Week>;
};

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export enum ClinicScheduleType {
  MonthlyFixedDay = 'MONTHLY_FIXED_DAY',
  MonthlyNthWeek = 'MONTHLY_NTH_WEEK',
  PartialClosed = 'PARTIAL_CLOSED',
  SpecificDates = 'SPECIFIC_DATES',
  Weekly = 'WEEKLY'
}

export enum Week {
  Fifth = 'FIFTH',
  First = 'FIRST',
  Fourth = 'FOURTH',
  Last = 'LAST',
  Second = 'SECOND',
  Third = 'THIRD'
}

export type Comment = {
  __typename?: 'Comment';
  comment?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type Comments = {
  __typename?: 'Comments';
  clinic_id: Scalars['ID'];
  comment?: Maybe<Scalars['String']>;
  commentId?: Maybe<Scalars['ID']>;
  date: Scalars['AWSTimestamp'];
};

export type Floor = {
  __typename?: 'Floor';
  clinic_id: Scalars['ID'];
  floor_id: Scalars['ID'];
  floorName: Scalars['String'];
  index: Scalars['Int'];
  isDelete: Scalars['Boolean'];
};

export type Form = {
  __typename?: 'Form';
  common: Common;
  dental?: Maybe<Dental>;
  medical?: Maybe<Medical>;
  orthodontics?: Maybe<Orthodontics>;
};

export type Common = {
  __typename?: 'Common';
  Q1?: Maybe<CommonQ1>;
  Q2?: Maybe<CommonQ2>;
  Q3?: Maybe<CommonQ3>;
  Q4?: Maybe<CommonQ4>;
  Q5?: Maybe<CommonQ5>;
  Q6?: Maybe<CommonQ6>;
};

export type CommonQ1 = {
  __typename?: 'commonQ1';
  answerQ1?: Maybe<Scalars['String']>;
  diseaseQ1: Scalars['String'];
  selected_clinicQ1?: Maybe<Scalars['String']>;
  selected_medicineQ1?: Maybe<Scalars['String']>;
};

export type CommonQ2 = {
  __typename?: 'commonQ2';
  answerQ2?: Maybe<Scalars['String']>;
  commentQ2?: Maybe<Scalars['String']>;
  selectedQ2?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CommonQ3 = {
  __typename?: 'commonQ3';
  answerQ3?: Maybe<Scalars['String']>;
  selectedQ3?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CommonQ4 = {
  __typename?: 'commonQ4';
  answerQ4?: Maybe<Scalars['String']>;
  selected_optionsQ4?: Maybe<Scalars['String']>;
  selectedQ4?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CommonQ5 = {
  __typename?: 'commonQ5';
  answerQ5?: Maybe<Scalars['String']>;
};

export type CommonQ6 = {
  __typename?: 'commonQ6';
  answerQ6?: Maybe<Scalars['String']>;
  commentQ6?: Maybe<Scalars['String']>;
  dateQ6?: Maybe<Scalars['String']>;
  selectedQ6?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Dental = {
  __typename?: 'Dental';
  Q1?: Maybe<DentalQ1>;
  Q2?: Maybe<DentalQ2>;
  Q3?: Maybe<DentalQ3>;
  Q4?: Maybe<DentalQ4>;
  Q5?: Maybe<DentalQ5>;
};

export type DentalQ1 = {
  __typename?: 'dentalQ1';
  commentQ1?: Maybe<Scalars['String']>;
  dateQ1?: Maybe<Scalars['AWSTimestamp']>;
  selectedQ1?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DentalQ2 = {
  __typename?: 'dentalQ2';
  commentQ2?: Maybe<Scalars['String']>;
  selectedQ2?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DentalQ3 = {
  __typename?: 'dentalQ3';
  answerQ3?: Maybe<Scalars['String']>;
  commentQ3?: Maybe<Scalars['String']>;
  selectedQ3?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DentalQ4 = {
  __typename?: 'dentalQ4';
  selectedQ4?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DentalQ5 = {
  __typename?: 'dentalQ5';
  selectedQ5?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Medical = {
  __typename?: 'Medical';
  Q1?: Maybe<MedicalQ1>;
  Q2?: Maybe<MedicalQ2>;
  Q3?: Maybe<MedicalQ3>;
  Q4?: Maybe<MedicalQ4>;
  Q5?: Maybe<MedicalQ5>;
  Q6?: Maybe<MedicalQ6>;
};

export type MedicalQ1 = {
  __typename?: 'medicalQ1';
  commentQ1?: Maybe<Scalars['String']>;
  selectedQ1?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type MedicalQ2 = {
  __typename?: 'medicalQ2';
  bodyQ2?: Maybe<Array<Maybe<Scalars['String']>>>;
  commentQ2: Scalars['String'];
  faceQ2?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type MedicalQ3 = {
  __typename?: 'medicalQ3';
  answerQ3?: Maybe<Scalars['String']>;
  clinic_anotherQ3?: Maybe<Scalars['String']>;
  clinic_otherQ3?: Maybe<Scalars['String']>;
  clinic_salonQ3?: Maybe<Scalars['String']>;
  selected_fatDissolvingQ3?: Maybe<Scalars['String']>;
  selected_laserQ3?: Maybe<Scalars['String']>;
  selected_peelingQ3?: Maybe<Scalars['String']>;
  selectedQ3?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type MedicalQ4 = {
  __typename?: 'medicalQ4';
  commentQ4?: Maybe<Scalars['String']>;
  constipationQ4?: Maybe<Scalars['String']>;
  favoriteQ4: Scalars['String'];
  selectedQ4?: Maybe<Array<Maybe<Scalars['String']>>>;
  sleepQ4?: Maybe<Scalars['String']>;
  stomachQ4?: Maybe<Scalars['String']>;
  ultravioletRaysQ4?: Maybe<Scalars['String']>;
};

export type MedicalQ5 = {
  __typename?: 'medicalQ5';
  doctorsCosmeQ5?: Maybe<Scalars['String']>;
  selectedQ5?: Maybe<Array<Maybe<Scalars['String']>>>;
  skincareItemQ5?: Maybe<Scalars['String']>;
};

export type MedicalQ6 = {
  __typename?: 'medicalQ6';
  commentQ6?: Maybe<Scalars['String']>;
  selectedQ6?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Orthodontics = {
  __typename?: 'Orthodontics';
  Q1?: Maybe<OrthodonticsQ1>;
  Q10?: Maybe<OrthodonticsQ10>;
  Q2?: Maybe<OrthodonticsQ2>;
  Q3?: Maybe<OrthodonticsQ3>;
  Q4?: Maybe<OrthodonticsQ4>;
  Q5?: Maybe<OrthodonticsQ5>;
  Q6?: Maybe<OrthodonticsQ6>;
  Q7?: Maybe<OrthodonticsQ7>;
  Q8?: Maybe<OrthodonticsQ8>;
  Q9?: Maybe<OrthodonticsQ9>;
};

export type OrthodonticsQ1 = {
  __typename?: 'orthodonticsQ1';
  commentQ1?: Maybe<Scalars['String']>;
  selectedQ1?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type OrthodonticsQ10 = {
  __typename?: 'orthodonticsQ10';
  commentQ10?: Maybe<Scalars['String']>;
  selectedQ10?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type OrthodonticsQ2 = {
  __typename?: 'orthodonticsQ2';
  commentQ2?: Maybe<Scalars['String']>;
  selectedQ2?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type OrthodonticsQ3 = {
  __typename?: 'orthodonticsQ3';
  answerQ3?: Maybe<Scalars['String']>;
  commentQ3?: Maybe<Scalars['String']>;
  dateQ3?: Maybe<Scalars['AWSTimestamp']>;
};

export type OrthodonticsQ4 = {
  __typename?: 'orthodonticsQ4';
  answerQ4?: Maybe<Scalars['String']>;
  dateQ4?: Maybe<Scalars['AWSTimestamp']>;
};

export type OrthodonticsQ5 = {
  __typename?: 'orthodonticsQ5';
  commentQ5?: Maybe<Scalars['String']>;
  dateQ5?: Maybe<Scalars['AWSTimestamp']>;
  selectedQ5?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type OrthodonticsQ6 = {
  __typename?: 'orthodonticsQ6';
  selectedQ6?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type OrthodonticsQ7 = {
  __typename?: 'orthodonticsQ7';
  commentQ7?: Maybe<Scalars['String']>;
  selectedQ7?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type OrthodonticsQ8 = {
  __typename?: 'orthodonticsQ8';
  answerQ8?: Maybe<Scalars['String']>;
};

export type OrthodonticsQ9 = {
  __typename?: 'orthodonticsQ9';
  selectedQ9?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ClinicConfig = {
  __typename?: 'ClinicConfig';
  clinic_id: Scalars['ID'];
  config: ClinicConfigUnion;
  config_id: Scalars['ID'];
  config_type: Scalars['String'];
  created_at?: Maybe<Scalars['AWSTimestamp']>;
  endDate?: Maybe<Scalars['AWSTimestamp']>;
  startDate: Scalars['AWSTimestamp'];
  updated_at?: Maybe<Scalars['AWSTimestamp']>;
};

export type ClinicConfigUnion = CardWidthConfig | ClinicTimeConfig;

export type CardWidthConfig = {
  __typename?: 'CardWidthConfig';
  cardWidth: Scalars['Int'];
};

export type ClinicTimeConfig = {
  __typename?: 'ClinicTimeConfig';
  clinicTime?: Maybe<ClinicTime>;
};

export type ClinicTime = {
  __typename?: 'ClinicTime';
  endTime: ClinicHourMinutes;
  startTime: ClinicHourMinutes;
};

export type ClinicHourMinutes = {
  __typename?: 'ClinicHourMinutes';
  hours: Scalars['Int'];
  minutes: Scalars['Int'];
};

export type Maneger = {
  __typename?: 'Maneger';
  clinic_id?: Maybe<Scalars['ID']>;
  color?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  isDelete?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  rights: Scalars['String'];
  role: Scalars['String'];
};

export type Menu = {
  __typename?: 'Menu';
  abbreviation?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Int']>;
  checkupFrequency?: Maybe<MedicalCheckupFrequency>;
  checkupIntervalDays?: Maybe<Scalars['Int']>;
  clinic_id?: Maybe<Scalars['ID']>;
  courponId?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isDelete?: Maybe<Scalars['Boolean']>;
  isPeriodicCheckup?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  parts?: Maybe<Scalars['String']>;
  role: Scalars['String'];
  SDK_ID: Scalars['ID'];
  status: Scalars['String'];
  subCategoryId?: Maybe<Scalars['ID']>;
  time: Scalars['Int'];
  type: Scalars['String'];
};

export enum MedicalCheckupFrequency {
  Bimonthly = 'BIMONTHLY',
  Biweekly = 'BIWEEKLY',
  Custom = 'CUSTOM',
  Halfyearly = 'HALFYEARLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY'
}

export type Notification = {
  __typename?: 'Notification';
  category: Scalars['String'];
  content: Scalars['String'];
  date: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  number: Scalars['String'];
};

export type Org = {
  __typename?: 'Org';
  created_at: Scalars['AWSTimestamp'];
  isDelete: Scalars['Boolean'];
  org_id: Scalars['ID'];
  org_label: Scalars['String'];
  org_name: Scalars['String'];
  updated_at?: Maybe<Scalars['AWSTimestamp']>;
};

export type PatientV2 = {
  __typename?: 'PatientV2';
  address?: Maybe<Address>;
  age?: Maybe<Scalars['Int']>;
  birthday?: Maybe<Scalars['AWSTimestamp']>;
  clinic_id?: Maybe<Scalars['ID']>;
  clinicIdWithDeleted?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  from_p5g?: Maybe<Scalars['Boolean']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  invitationNumber?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['String']>;
  kana?: Maybe<Name>;
  kanaName?: Maybe<Scalars['String']>;
  name?: Maybe<Name>;
  notEntry?: Maybe<Scalars['Boolean']>;
  patientCardNumber?: Maybe<Scalars['Int']>;
  patientCardNumberOptional?: Maybe<Scalars['Int']>;
  remarks?: Maybe<Scalars['String']>;
  tel?: Maybe<Scalars['String']>;
};

export type Address = {
  __typename?: 'address';
  house?: Maybe<Scalars['String']>;
  post?: Maybe<Scalars['String']>;
  prefectures?: Maybe<Scalars['String']>;
};

export type Name = {
  __typename?: 'Name';
  first?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['String']>;
};

export type PatientNameV2 = {
  __typename?: 'PatientNameV2';
  displayName?: Maybe<Scalars['String']>;
};

export type Patient = {
  __typename?: 'Patient';
  access_token?: Maybe<Scalars['String']>;
  address?: Maybe<Address>;
  age?: Maybe<Scalars['Int']>;
  birthday?: Maybe<Scalars['AWSTimestamp']>;
  clinic_id?: Maybe<Scalars['ID']>;
  comment?: Maybe<Scalars['String']>;
  DNumber?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  from_p5g?: Maybe<Scalars['Boolean']>;
  gender?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invitationNumber?: Maybe<Scalars['String']>;
  kana?: Maybe<Name>;
  lineId?: Maybe<Scalars['ID']>;
  name?: Maybe<Name>;
  notEntry?: Maybe<Scalars['Boolean']>;
  remarks?: Maybe<Scalars['String']>;
  searchFull?: Maybe<Scalars['String']>;
  searchKana?: Maybe<Scalars['String']>;
  searchName?: Maybe<Scalars['String']>;
  SNumber?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Boolean']>;
  tel?: Maybe<Scalars['String']>;
  undefinedToken?: Maybe<Scalars['Boolean']>;
};

export type PhrInfo = {
  __typename?: 'PHRInfo';
  buying?: Maybe<Buying>;
  confirmed?: Maybe<Confirmed>;
  date: Scalars['AWSTimestamp'];
  expires_at?: Maybe<Scalars['AWSTimestamp']>;
  id: Scalars['ID'];
  payment?: Maybe<Payment>;
  phr?: Maybe<Phr>;
};

export type Buying = {
  __typename?: 'Buying';
  items?: Maybe<Array<Maybe<Item>>>;
};

export type Item = {
  __typename?: 'Item';
  count: Scalars['Int'];
  name: Scalars['String'];
  price: Scalars['Int'];
};

export type Confirmed = {
  __typename?: 'Confirmed';
  cancel?: Maybe<Cancel>;
  cancelTime?: Maybe<Scalars['AWSTimestamp']>;
  consultationTime?: Maybe<Scalars['AWSTimestamp']>;
  endTime: Scalars['AWSTimestamp'];
  menuId: Scalars['String'];
  parts: Scalars['String'];
  receptionTime?: Maybe<Scalars['AWSTimestamp']>;
  staffIds?: Maybe<Array<Maybe<StaffId>>>;
  startTime: Scalars['AWSTimestamp'];
  type: Scalars['String'];
};

export type Payment = {
  __typename?: 'Payment';
  courpon?: Maybe<Scalars['Int']>;
  method: Scalars['String'];
  price: Scalars['String'];
  ticket?: Maybe<Ticket>;
};

export type Ticket = {
  __typename?: 'Ticket';
  buy_at: Scalars['AWSTimestamp'];
  counts: Counts;
  expires_at: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  name: Scalars['String'];
  price: Scalars['Int'];
};

export type Counts = {
  __typename?: 'Counts';
  current: Scalars['Int'];
  max: Scalars['Int'];
};

export type Phr = {
  __typename?: 'PHR';
  complement: Scalars['String'];
  links: Array<Maybe<Link>>;
  progress: Progress;
  related: Scalars['String'];
};

export type Link = {
  __typename?: 'Link';
  name: Scalars['String'];
  url: Scalars['String'];
};

export type Progress = {
  __typename?: 'Progress';
  count: Scalars['Int'];
  text: Scalars['String'];
};

export type Recall = {
  __typename?: 'Recall';
  appointId: Scalars['String'];
  clinic_id: Scalars['String'];
  createdAt: Scalars['AWSTimestamp'];
  daysUntilDue: Scalars['Int'];
  id: Scalars['ID'];
  lastTreatmentDate: Scalars['AWSTimestamp'];
  medicalMenu?: Maybe<MedicalMenu>;
  medicalMenuId: Scalars['String'];
  nextDueDate: Scalars['AWSTimestamp'];
  patient?: Maybe<Patient>;
  patientId: Scalars['String'];
  status: RecallStatus;
  updatedAt: Scalars['AWSTimestamp'];
};

export type MedicalMenu = {
  __typename?: 'MedicalMenu';
  name: Scalars['String'];
  SDK_ID: Scalars['String'];
};

export enum RecallStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Scheduled = 'SCHEDULED'
}

export type Role = {
  __typename?: 'Role';
  clinic_id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  status?: Maybe<Scalars['Boolean']>;
};

export type Shift = {
  __typename?: 'Shift';
  date: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  name: Scalars['String'];
  shifts: Array<Scalars['Boolean']>;
  workingTimes: WorkingTimesType;
};

export type WorkingTimesType = {
  __typename?: 'workingTimesType';
  am: Array<Maybe<Scalars['String']>>;
  pm: Array<Maybe<Scalars['String']>>;
};

export type Shifts = {
  __typename?: 'Shifts';
  Shifts: Array<Maybe<Shift>>;
};

export type IsEntry = {
  __typename?: 'isEntry';
  isEntry: Scalars['Boolean'];
};

export type Appoints = {
  __typename?: 'Appoints';
  Appoints: Array<Maybe<Appoint>>;
};

export type AppointsV2 = {
  __typename?: 'AppointsV2';
  Appoints: Array<Maybe<AppointV2>>;
};

export type ListAppointDetailsInputs = {
  clinic_id: Scalars['ID'];
  date?: InputMaybe<AppointDetailsDateInputType>;
};

export type AppointDetailsDateInputType = {
  endTime: Scalars['AWSTimestamp'];
  startTime: Scalars['AWSTimestamp'];
};

export type AppointDetails = {
  __typename?: 'AppointDetails';
  appoint: Scalars['String'];
  appointId: Scalars['ID'];
  cancel?: Maybe<Cancel>;
  cancelTime?: Maybe<Scalars['AWSTimestamp']>;
  clinic_id: Scalars['ID'];
  created_at?: Maybe<Scalars['AWSTimestamp']>;
  date: Scalars['AWSTimestamp'];
  dentalFormula?: Maybe<DentalFormulaResponse>;
  endTime: Scalars['AWSTimestamp'];
  facilityId: Scalars['String'];
  facilityName: Scalars['String'];
  id: Scalars['ID'];
  isDubbleBooking?: Maybe<Scalars['Boolean']>;
  isFirstVisiting?: Maybe<Scalars['Boolean']>;
  isLate?: Maybe<Scalars['Boolean']>;
  menuAbbreviation?: Maybe<Scalars['String']>;
  menuName?: Maybe<Scalars['String']>;
  patientCardNumber?: Maybe<Scalars['String']>;
  patientCardNumberOptional?: Maybe<Scalars['String']>;
  patientKana?: Maybe<Scalars['String']>;
  patientName?: Maybe<Scalars['String']>;
  receptionTime?: Maybe<Scalars['AWSTimestamp']>;
  remarks?: Maybe<Scalars['String']>;
  staffNames: Array<StaffName>;
  startTime: Scalars['AWSTimestamp'];
  treatmentCompletedTime?: Maybe<Scalars['AWSTimestamp']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['AWSTimestamp']>;
};

export type ListAppointDetailsByIdInputs = {
  clinic_id: Scalars['ID'];
  date?: InputMaybe<AppointDetailsDateInputType>;
  id: Scalars['ID'];
};

export type Categorys = {
  __typename?: 'Categorys';
  Categorys: Array<Maybe<Category>>;
};

export type Category = {
  __typename?: 'Category';
  clinic_id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  isDelete: Scalars['Boolean'];
  mainCategory: Scalars['String'];
  name: Scalars['String'];
};

export type Clinics = {
  __typename?: 'Clinics';
  clinics: Array<Clinic>;
};

export type ClinicSchedules = {
  __typename?: 'ClinicSchedules';
  clinic_schedules: Array<ClinicSchedule>;
};

export type Facilities = {
  __typename?: 'Facilities';
  Facilities: Array<Facility>;
};

export type Facility = {
  __typename?: 'facility';
  clinic_id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  isDelete?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  status?: Maybe<Scalars['Boolean']>;
};

export type ListFacilitiesByFilterInput = {
  clinic_id: Scalars['ID'];
  filterType: Scalars['String'];
  group_id: Scalars['ID'];
};

export type ListFacilitiesByGroupIdsInput = {
  clinic_id: Scalars['ID'];
  group_ids: Array<Scalars['ID']>;
};

export type ListFacilitiesByGroupIdsReturns = {
  __typename?: 'ListFacilitiesByGroupIdsReturns';
  ListFacilitiesByGroupIdsReturns?: Maybe<Array<Maybe<ListFacilitiesByGroupIdsReturn>>>;
};

export type ListFacilitiesByGroupIdsReturn = {
  __typename?: 'ListFacilitiesByGroupIdsReturn';
  facilities?: Maybe<Array<Maybe<Facility>>>;
  group_id: Scalars['ID'];
};

export type ListFacilityGroupsInput = {
  clinic_id: Scalars['ID'];
};

export type FacilityGroups = {
  __typename?: 'FacilityGroups';
  FacilityGroups?: Maybe<Array<Maybe<FacilityGroup>>>;
};

export type FacilityGroup = {
  __typename?: 'FacilityGroup';
  clinic_id: Scalars['ID'];
  created_at?: Maybe<Scalars['AWSTimestamp']>;
  facilityIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  group_id: Scalars['ID'];
  index: Scalars['Int'];
  isDelete?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updated_at?: Maybe<Scalars['AWSTimestamp']>;
};

export type ListGroupsByFacilityIdsInput = {
  clinic_id: Scalars['ID'];
  facilityIds: Array<Scalars['ID']>;
};

export type ListGroupsByFacilityIdsReturns = {
  __typename?: 'ListGroupsByFacilityIdsReturns';
  listGroupsByFacilityIdsReturns?: Maybe<Array<Maybe<ListGroupsByFacilityIdsReturn>>>;
};

export type ListGroupsByFacilityIdsReturn = {
  __typename?: 'ListGroupsByFacilityIdsReturn';
  facility_id: Scalars['ID'];
  groups?: Maybe<Array<Maybe<FacilityGroup>>>;
};

export type Manegers = {
  __typename?: 'Manegers';
  Manegers: Array<Maneger>;
};

export type Menus = {
  __typename?: 'Menus';
  Menus: Array<Menu>;
};

export type Orgs = {
  __typename?: 'Orgs';
  orgs: Array<Org>;
};

export type Patients = {
  __typename?: 'Patients';
  Patients: Array<Patient>;
};

export type InputFilterOption = {
  filterType?: InputMaybe<FilterType>;
  filterValue?: InputMaybe<Scalars['String']>;
};

export enum FilterType {
  CardNumber = 'CardNumber',
  Name = 'Name',
  PhoneNumber = 'PhoneNumber'
}

export type InputLastEvaluatedKey = {
  clinic_id?: InputMaybe<Scalars['String']>;
  clinicIdWithDeleted?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  kanaName?: InputMaybe<Scalars['String']>;
  patientCardNumber?: InputMaybe<Scalars['Int']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type InputOrderOption = {
  orderAsc?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<OrderBy>;
};

export enum OrderBy {
  KanaName = 'KanaName',
  PatientCardNumber = 'PatientCardNumber',
  PhoneNumber = 'PhoneNumber'
}

export type PatientsV2 = {
  __typename?: 'PatientsV2';
  lastEvaluatedKey?: Maybe<LastEvaluatedKey>;
  Patients: Array<PatientV2>;
};

export type LastEvaluatedKey = {
  __typename?: 'LastEvaluatedKey';
  clinic_id?: Maybe<Scalars['String']>;
  clinicIdWithDeleted?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  kanaName?: Maybe<Scalars['String']>;
  patientCardNumber?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type Notifications = {
  __typename?: 'Notifications';
  Notifications: Array<Maybe<Notification>>;
};

export type PhrInfos = {
  __typename?: 'PHRInfos';
  PHRInfos: Array<Maybe<PhrInfo>>;
};

export type RecallFilterInput = {
  appointId?: InputMaybe<Scalars['String']>;
  clinic_id?: InputMaybe<Scalars['String']>;
  daysUntilDue?: InputMaybe<Scalars['Int']>;
  lastTreatmentDate?: InputMaybe<Scalars['AWSTimestamp']>;
  medicalMenuId?: InputMaybe<Scalars['String']>;
  nextDueDate?: InputMaybe<Scalars['AWSTimestamp']>;
  patientId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<RecallStatus>;
};

export type Roles = {
  __typename?: 'Roles';
  Roles: Array<Role>;
};

export type AppointBlocks = {
  __typename?: 'AppointBlocks';
  AppointBlocks?: Maybe<Array<Maybe<AppointBlock>>>;
};

export type ClinicHourMinutesInput = {
  hours: Scalars['Int'];
  minutes: Scalars['Int'];
};

export type IsValid = {
  __typename?: 'IsValid';
  isValid: Scalars['Boolean'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addAppoint: Appoint;
  addBlock: AppointBlock;
  addCardWidthConfig?: Maybe<ClinicConfig>;
  addCategory: Category;
  addClinic: Clinic;
  addClinicSchedule?: Maybe<ClinicSchedule>;
  addClinicTimeConfig?: Maybe<ClinicConfig>;
  addComment?: Maybe<Comment>;
  addComments?: Maybe<Comments>;
  addFacility: Facility;
  addFacilityGroup: FacilityGroup;
  addFloor: Floor;
  addForm: Form;
  addFormById: Form;
  addManeger: Maneger;
  addMenu: Menu;
  addOrg: Org;
  addPatientByIdV2?: Maybe<PatientV2>;
  addPatients?: Maybe<Patient>;
  addPatientsById?: Maybe<Patient>;
  addPatientsByQR?: Maybe<Patient>;
  addPatientsFromCsv?: Maybe<Scalars['String']>;
  addPHRInfo?: Maybe<PhrInfo>;
  addRecall: Recall;
  addRoles: Role;
  addShift: Shift;
  batchDeleteMenu?: Maybe<Menu>;
  batchWriteShift?: Maybe<Shift>;
  changeStatus?: Maybe<AppointCustom>;
  checkDubbleBooking: IsDubbleBooking;
  checkNotAccepted: IsNonAccepted;
  deleteAppoint: Appoint;
  deleteBlock: AppointBlock;
  deleteCategory: Category;
  deleteClinic: Clinic;
  deleteClinicConfig?: Maybe<ClinicConfig>;
  deleteClinicSchedule: Scalars['ID'];
  deleteFacility: Facility;
  deleteFacilityGroup: FacilityGroup;
  deleteFloor: Scalars['Boolean'];
  deleteForm?: Maybe<Form>;
  deleteFormById?: Maybe<Form>;
  deleteManeger: Maneger;
  deleteMenu: Menu;
  deleteOrg: Org;
  deletePatientByIdV2: PatientV2;
  deletePatients: Patient;
  deletePatientsById: Patient;
  deletePHRInfoConfirmed?: Maybe<PhrInfo>;
  deleteRecall: Scalars['Boolean'];
  deleteRoles: Role;
  deleteShift: Shift;
  getMenu: Menu;
  transactDeleteCategorys: TransactReturn;
  transactDeleteGroups: TransactReturn;
  transactDeleteMenus?: Maybe<TransactReturn>;
  transactIndexMenus?: Maybe<TransactReturn>;
  updateAppoint: Appoint;
  updateAppointInfo: Appoint;
  updateBlock: AppointBlockCustom;
  updateBlockStatus: AppointBlockCustom;
  updateCardWidthConfig?: Maybe<ClinicConfig>;
  updateCategory: Category;
  updateClinic: Clinic;
  updateClinicSchedule?: Maybe<ClinicSchedule>;
  updateClinicTimeConfig?: Maybe<ClinicConfig>;
  updateCommentAttrs?: Maybe<ReturnBoolean>;
  updateFacility: Facility;
  updateFacilityGroup: FacilityGroup;
  updateFacilityIdx: Scalars['Boolean'];
  updateFloor: Floor;
  updateFloorIdx: Scalars['Boolean'];
  updateForm: Form;
  updateFormById: Form;
  updateManeger: Maneger;
  updateMenu: Menu;
  updateOrg: Org;
  updatePatientByIdV2?: Maybe<PatientV2>;
  updatePatients?: Maybe<Patient>;
  updatePatientsById?: Maybe<Patient>;
  updatePatientsSearch?: Maybe<Scalars['Boolean']>;
  updateRecallStatus: UpdatedRecall;
  updateRoles: Role;
  updateShift: Shift;
};


export type MutationAddAppointArgs = {
  appoint?: InputMaybe<Scalars['String']>;
  appointId?: InputMaybe<Scalars['ID']>;
  cancel?: InputMaybe<CancelInput>;
  cancelTime?: InputMaybe<Scalars['AWSTimestamp']>;
  clinic_id: Scalars['ID'];
  confirmedEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  confirmedTime?: InputMaybe<Scalars['AWSTimestamp']>;
  consultationTime?: InputMaybe<Scalars['AWSTimestamp']>;
  created_at?: InputMaybe<Scalars['AWSTimestamp']>;
  date: Scalars['AWSTimestamp'];
  dentalFormula?: InputMaybe<DentalFormulaInput>;
  endTime: Scalars['AWSTimestamp'];
  facilityId: Scalars['String'];
  id: Scalars['ID'];
  isFirstVisiting?: InputMaybe<Scalars['Boolean']>;
  isLate?: InputMaybe<Scalars['Boolean']>;
  menuId: Scalars['String'];
  price: Scalars['Int'];
  receptionTime?: InputMaybe<Scalars['AWSTimestamp']>;
  remarks?: InputMaybe<Scalars['String']>;
  secondEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  secondStartTime?: InputMaybe<Scalars['AWSTimestamp']>;
  staffIds: Array<StaffIdInput>;
  startTime: Scalars['AWSTimestamp'];
  thirdEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  thirdStartTime?: InputMaybe<Scalars['AWSTimestamp']>;
  type: Scalars['String'];
  updated_at?: InputMaybe<Scalars['AWSTimestamp']>;
};


export type MutationAddBlockArgs = {
  clinic_id: Scalars['ID'];
  color?: InputMaybe<Scalars['String']>;
  endTime: Scalars['AWSTimestamp'];
  facilityId: Scalars['ID'];
  remarks?: InputMaybe<Scalars['String']>;
  startTime: Scalars['AWSTimestamp'];
};


export type MutationAddCardWidthConfigArgs = {
  clinic_id: Scalars['ID'];
  config: CardWidthConfigInput;
  config_type: Scalars['String'];
  endDate?: InputMaybe<Scalars['AWSTimestamp']>;
  startDate: Scalars['AWSTimestamp'];
};


export type MutationAddCategoryArgs = {
  clinic_id: Scalars['ID'];
  mainCategory: Scalars['String'];
  name: Scalars['String'];
};


export type MutationAddClinicArgs = {
  clinic_label: Scalars['String'];
  clinic_name: Scalars['String'];
  org_id: Scalars['ID'];
};


export type MutationAddClinicScheduleArgs = {
  input: ClinicScheduleInput;
};


export type MutationAddClinicTimeConfigArgs = {
  clinic_id: Scalars['ID'];
  config: ClinicTimeConfigInput;
  config_type: Scalars['String'];
  endDate?: InputMaybe<Scalars['AWSTimestamp']>;
  startDate: Scalars['AWSTimestamp'];
};


export type MutationAddCommentArgs = {
  comment: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationAddCommentsArgs = {
  clinic_id: Scalars['ID'];
  comment: Scalars['String'];
  date: Scalars['AWSTimestamp'];
};


export type MutationAddFacilityArgs = {
  clinic_id: Scalars['ID'];
  group_ids?: InputMaybe<Array<Scalars['ID']>>;
  index?: InputMaybe<Scalars['Int']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  status: Scalars['Boolean'];
};


export type MutationAddFacilityGroupArgs = {
  inputs: AddFacilityGroupInput;
};


export type MutationAddFloorArgs = {
  clinic_id: Scalars['ID'];
  floorName: Scalars['String'];
};


export type MutationAddFormArgs = {
  access_token: Scalars['String'];
  common?: InputMaybe<CommonInput>;
  dental?: InputMaybe<DentalInput>;
  medical?: InputMaybe<MedicalInput>;
  orthodontics?: InputMaybe<OrthodonticsInput>;
};


export type MutationAddFormByIdArgs = {
  common?: InputMaybe<CommonInput>;
  dental?: InputMaybe<DentalInput>;
  id: Scalars['ID'];
  medical?: InputMaybe<MedicalInput>;
  orthodontics?: InputMaybe<OrthodonticsInput>;
};


export type MutationAddManegerArgs = {
  clinic_id: Scalars['ID'];
  color?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  index?: InputMaybe<Scalars['Int']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  rights: Scalars['String'];
  role: Scalars['String'];
};


export type MutationAddMenuArgs = {
  abbreviation?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['Int']>;
  checkupFrequency?: InputMaybe<MedicalCheckupFrequency>;
  checkupIntervalDays?: InputMaybe<Scalars['Int']>;
  clinic_id: Scalars['ID'];
  index?: InputMaybe<Scalars['Int']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  isPeriodicCheckup?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  parts?: InputMaybe<Scalars['String']>;
  role: Scalars['String'];
  status: Scalars['String'];
  subCategoryId: Scalars['ID'];
  time?: InputMaybe<Scalars['Int']>;
  type: Scalars['String'];
};


export type MutationAddOrgArgs = {
  AddOrgInput: AddOrgInput;
};


export type MutationAddPatientByIdV2Args = {
  input: PatientInputV2;
};


export type MutationAddPatientsArgs = {
  access_token: Scalars['String'];
  address: AddressInput;
  age?: InputMaybe<Scalars['Int']>;
  birthday: Scalars['AWSTimestamp'];
  clinic_id: Scalars['ID'];
  comment?: InputMaybe<Scalars['String']>;
  DNumber?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  gender: Scalars['String'];
  group?: InputMaybe<Scalars['String']>;
  invitationNumber?: InputMaybe<Scalars['String']>;
  kana: NameInput;
  name: NameInput;
  remarks?: InputMaybe<Scalars['String']>;
  searchFull: Scalars['String'];
  searchKana: Scalars['String'];
  SNumber?: InputMaybe<Scalars['Int']>;
  tel: Scalars['String'];
};


export type MutationAddPatientsByIdArgs = {
  address?: InputMaybe<AddressUpdateInput>;
  age?: InputMaybe<Scalars['Int']>;
  birthday?: InputMaybe<Scalars['AWSTimestamp']>;
  clinic_id: Scalars['ID'];
  comment?: InputMaybe<Scalars['String']>;
  DNumber?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  invitationNumber?: InputMaybe<Scalars['String']>;
  kana: NameInput;
  lineId?: InputMaybe<Scalars['ID']>;
  name: NameInput;
  remarks?: InputMaybe<Scalars['String']>;
  searchFull: Scalars['String'];
  searchKana: Scalars['String'];
  SNumber?: InputMaybe<Scalars['Int']>;
  tel?: InputMaybe<Scalars['String']>;
};


export type MutationAddPatientsByQrArgs = {
  access_token: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationAddPatientsFromCsvArgs = {
  clinic_id: Scalars['ID'];
  csv: Scalars['String'];
};


export type MutationAddPhrInfoArgs = {
  PHRInfoInput: PhrInfoInput;
};


export type MutationAddRecallArgs = {
  input: CreateRecallInput;
};


export type MutationAddRolesArgs = {
  clinic_id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddShiftArgs = {
  date: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  name: Scalars['String'];
  shifts: Array<Scalars['Boolean']>;
  workingTimes: WorkingTimesInput;
};


export type MutationBatchDeleteMenuArgs = {
  SDK_IDs: Array<Scalars['ID']>;
};


export type MutationBatchWriteShiftArgs = {
  dates: Array<Scalars['AWSTimestamp']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  shifts: Array<Scalars['Boolean']>;
  workingTimes: WorkingTimesInput;
};


export type MutationChangeStatusArgs = {
  appoint: Scalars['String'];
  cancel?: InputMaybe<CancelInput>;
  cancelTime?: InputMaybe<Scalars['AWSTimestamp']>;
  consultationTime?: InputMaybe<Scalars['AWSTimestamp']>;
  created_at?: InputMaybe<Scalars['AWSTimestamp']>;
  id: Scalars['ID'];
  isLate?: InputMaybe<Scalars['Boolean']>;
  receptionTime?: InputMaybe<Scalars['AWSTimestamp']>;
  startTime: Scalars['AWSTimestamp'];
  updated_at?: InputMaybe<Scalars['AWSTimestamp']>;
};


export type MutationCheckDubbleBookingArgs = {
  date: Scalars['AWSTimestamp'];
  endTime: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
};


export type MutationCheckNotAcceptedArgs = {
  date: Scalars['AWSTimestamp'];
  endTime: Scalars['AWSTimestamp'];
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
};


export type MutationDeleteAppointArgs = {
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
};


export type MutationDeleteBlockArgs = {
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
};


export type MutationDeleteCategoryArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteClinicArgs = {
  clinic_id: Scalars['ID'];
  org_id: Scalars['ID'];
};


export type MutationDeleteClinicConfigArgs = {
  clinic_id: Scalars['ID'];
  config_id: Scalars['ID'];
  config_type: Scalars['String'];
};


export type MutationDeleteClinicScheduleArgs = {
  clinic_id: Scalars['String'];
  clinic_schedule_id: Scalars['ID'];
};


export type MutationDeleteFacilityArgs = {
  clinic_id: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDeleteFacilityGroupArgs = {
  inputs: DeleteFacilityGroupInput;
};


export type MutationDeleteFloorArgs = {
  clinic_id: Scalars['ID'];
  floor_id: Scalars['ID'];
};


export type MutationDeleteFormArgs = {
  access_token: Scalars['String'];
};


export type MutationDeleteFormByIdArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteManegerArgs = {
  clinic_id: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDeleteMenuArgs = {
  SDK_ID: Scalars['ID'];
};


export type MutationDeleteOrgArgs = {
  org_id: Scalars['ID'];
};


export type MutationDeletePatientByIdV2Args = {
  clinic_id: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDeletePatientsArgs = {
  access_token: Scalars['String'];
};


export type MutationDeletePatientsByIdArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePhrInfoConfirmedArgs = {
  date: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
};


export type MutationDeleteRecallArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteRolesArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteShiftArgs = {
  date: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
};


export type MutationGetMenuArgs = {
  SDK_ID: Scalars['ID'];
};


export type MutationTransactDeleteCategorysArgs = {
  SDK_IDs: Array<Scalars['ID']>;
};


export type MutationTransactDeleteGroupsArgs = {
  inputs: TransactDeleteGroupsInput;
};


export type MutationTransactDeleteMenusArgs = {
  SDK_IDs: Array<Scalars['ID']>;
};


export type MutationTransactIndexMenusArgs = {
  ModifyIndexMenus: Array<ModifyIndexMenus>;
};


export type MutationUpdateAppointArgs = {
  appoint?: InputMaybe<Scalars['String']>;
  appointId: Scalars['ID'];
  baseId: Scalars['ID'];
  baseStartTime: Scalars['AWSTimestamp'];
  cancel?: InputMaybe<CancelInput>;
  cancelTime?: InputMaybe<Scalars['AWSTimestamp']>;
  clinic_id: Scalars['ID'];
  confirmedEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  confirmedTime?: InputMaybe<Scalars['AWSTimestamp']>;
  consultationTime?: InputMaybe<Scalars['AWSTimestamp']>;
  created_at?: InputMaybe<Scalars['AWSTimestamp']>;
  date?: InputMaybe<Scalars['AWSTimestamp']>;
  dentalFormula?: InputMaybe<DentalFormulaInput>;
  endTime?: InputMaybe<Scalars['AWSTimestamp']>;
  facilityId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isFirstVisiting?: InputMaybe<Scalars['Boolean']>;
  isLate?: InputMaybe<Scalars['Boolean']>;
  menuId?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  receptionTime?: InputMaybe<Scalars['AWSTimestamp']>;
  remarks?: InputMaybe<Scalars['String']>;
  secondEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  secondStartTime?: InputMaybe<Scalars['AWSTimestamp']>;
  staffIds?: InputMaybe<Array<InputMaybe<StaffIdInput>>>;
  startTime: Scalars['AWSTimestamp'];
  thirdEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  thirdStartTime?: InputMaybe<Scalars['AWSTimestamp']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['AWSTimestamp']>;
};


export type MutationUpdateAppointInfoArgs = {
  appoint?: InputMaybe<Scalars['String']>;
  appointId: Scalars['ID'];
  cancel?: InputMaybe<CancelInput>;
  cancelTime?: InputMaybe<Scalars['AWSTimestamp']>;
  clinic_id: Scalars['ID'];
  confirmedEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  confirmedTime?: InputMaybe<Scalars['AWSTimestamp']>;
  consultationTime?: InputMaybe<Scalars['AWSTimestamp']>;
  created_at?: InputMaybe<Scalars['AWSTimestamp']>;
  date?: InputMaybe<Scalars['AWSTimestamp']>;
  dentalFormula?: InputMaybe<DentalFormulaInput>;
  endTime?: InputMaybe<Scalars['AWSTimestamp']>;
  facilityId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isFirstVisiting?: InputMaybe<Scalars['Boolean']>;
  isLate?: InputMaybe<Scalars['Boolean']>;
  menuId?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  receptionTime?: InputMaybe<Scalars['AWSTimestamp']>;
  remarks: Scalars['String'];
  secondEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  secondStartTime?: InputMaybe<Scalars['AWSTimestamp']>;
  staffIds?: InputMaybe<Array<InputMaybe<StaffIdInput>>>;
  startTime: Scalars['AWSTimestamp'];
  thirdEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  thirdStartTime?: InputMaybe<Scalars['AWSTimestamp']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['AWSTimestamp']>;
};


export type MutationUpdateBlockArgs = {
  baseId: Scalars['ID'];
  baseStartTime: Scalars['AWSTimestamp'];
  clinic_id: Scalars['ID'];
  color?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['AWSTimestamp']>;
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
  remarks?: InputMaybe<Scalars['String']>;
  startTime: Scalars['AWSTimestamp'];
};


export type MutationUpdateBlockStatusArgs = {
  clinic_id: Scalars['ID'];
  color?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['AWSTimestamp']>;
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
  remarks?: InputMaybe<Scalars['String']>;
  startTime: Scalars['AWSTimestamp'];
};


export type MutationUpdateCardWidthConfigArgs = {
  clinic_id: Scalars['ID'];
  config: CardWidthConfigInput;
  config_id: Scalars['ID'];
  config_type: Scalars['String'];
  endDate?: InputMaybe<Scalars['AWSTimestamp']>;
  startDate: Scalars['AWSTimestamp'];
};


export type MutationUpdateCategoryArgs = {
  id: Scalars['ID'];
  mainCategory?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateClinicArgs = {
  clinic_id: Scalars['ID'];
  clinic_label?: InputMaybe<Scalars['String']>;
  clinic_name?: InputMaybe<Scalars['String']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  org_id: Scalars['ID'];
};


export type MutationUpdateClinicScheduleArgs = {
  clinic_schedule_id: Scalars['ID'];
  input: ClinicScheduleInput;
};


export type MutationUpdateClinicTimeConfigArgs = {
  clinic_id: Scalars['ID'];
  config: ClinicTimeConfigInput;
  config_id: Scalars['ID'];
  config_type: Scalars['String'];
  endDate?: InputMaybe<Scalars['AWSTimestamp']>;
  startDate: Scalars['AWSTimestamp'];
};


export type MutationUpdateCommentAttrsArgs = {
  clinic_id: Scalars['ID'];
};


export type MutationUpdateFacilityArgs = {
  clinic_id: Scalars['ID'];
  floor_id?: InputMaybe<Scalars['ID']>;
  group_ids?: InputMaybe<Array<Scalars['ID']>>;
  id: Scalars['ID'];
  index?: InputMaybe<Scalars['Int']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateFacilityGroupArgs = {
  inputs: UpdateFacilityGroupInput;
};


export type MutationUpdateFacilityIdxArgs = {
  inputs: UpdateFacilityIdxInput;
};


export type MutationUpdateFloorArgs = {
  clinic_id: Scalars['ID'];
  floor_id: Scalars['ID'];
  floorName?: InputMaybe<Scalars['String']>;
  index?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateFloorIdxArgs = {
  clinic_id: Scalars['ID'];
  direction: Scalars['Int'];
  floor_id: Scalars['ID'];
};


export type MutationUpdateFormArgs = {
  access_token: Scalars['String'];
  common?: InputMaybe<CommonInput>;
  dental?: InputMaybe<DentalInput>;
  medical?: InputMaybe<MedicalInput>;
  orthodontics?: InputMaybe<OrthodonticsInput>;
};


export type MutationUpdateFormByIdArgs = {
  common?: InputMaybe<CommonInput>;
  dental?: InputMaybe<DentalInput>;
  id: Scalars['ID'];
  medical?: InputMaybe<MedicalInput>;
  orthodontics?: InputMaybe<OrthodonticsInput>;
};


export type MutationUpdateManegerArgs = {
  color?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  index?: InputMaybe<Scalars['Int']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  rights?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateMenuArgs = {
  abbreviation?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['Int']>;
  checkupFrequency?: InputMaybe<MedicalCheckupFrequency>;
  checkupIntervalDays?: InputMaybe<Scalars['Int']>;
  index?: InputMaybe<Scalars['Int']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  isPeriodicCheckup?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  SDK_ID: Scalars['ID'];
  status?: InputMaybe<Scalars['String']>;
  subCategoryId?: InputMaybe<Scalars['ID']>;
  time?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateOrgArgs = {
  UpdateOrgInput: UpdateOrgInput;
};


export type MutationUpdatePatientByIdV2Args = {
  id: Scalars['ID'];
  input: PatientInputV2;
};


export type MutationUpdatePatientsArgs = {
  access_token: Scalars['String'];
  address?: InputMaybe<AddressUpdateInput>;
  age?: InputMaybe<Scalars['Int']>;
  birthday?: InputMaybe<Scalars['AWSTimestamp']>;
  comment?: InputMaybe<Scalars['String']>;
  DNumber?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  invitationNumber?: InputMaybe<Scalars['String']>;
  kana?: InputMaybe<NameUpdateInput>;
  name?: InputMaybe<NameUpdateInput>;
  remarks?: InputMaybe<Scalars['String']>;
  searchFull?: InputMaybe<Scalars['String']>;
  searchKana?: InputMaybe<Scalars['String']>;
  SNumber?: InputMaybe<Scalars['Int']>;
  tel?: InputMaybe<Scalars['String']>;
};


export type MutationUpdatePatientsByIdArgs = {
  address?: InputMaybe<AddressUpdateInput>;
  age?: InputMaybe<Scalars['Int']>;
  birthday?: InputMaybe<Scalars['AWSTimestamp']>;
  comment?: InputMaybe<Scalars['String']>;
  DNumber?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  from_p5g?: InputMaybe<Scalars['Boolean']>;
  gender?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  invitationNumber?: InputMaybe<Scalars['String']>;
  kana?: InputMaybe<NameUpdateInput>;
  name?: InputMaybe<NameUpdateInput>;
  remarks?: InputMaybe<Scalars['String']>;
  searchFull?: InputMaybe<Scalars['String']>;
  searchKana?: InputMaybe<Scalars['String']>;
  SNumber?: InputMaybe<Scalars['Int']>;
  tel?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateRecallStatusArgs = {
  clinic_id: Scalars['String'];
  id: Scalars['ID'];
  status: RecallStatus;
};


export type MutationUpdateRolesArgs = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateShiftArgs = {
  date: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  shifts?: InputMaybe<Array<Scalars['Boolean']>>;
  workingTimes?: InputMaybe<WorkingTimesInput>;
};

export type CancelInput = {
  cancelReason?: InputMaybe<Scalars['String']>;
  isCancel?: InputMaybe<Scalars['Boolean']>;
  radioCancelReason?: InputMaybe<Scalars['Int']>;
};

export type DentalFormulaInput = {
  baby?: InputMaybe<DentalFormulaArrayInput>;
  permanent?: InputMaybe<DentalFormulaArrayInput>;
};

export type DentalFormulaArrayInput = {
  leftBottom?: InputMaybe<Array<InputMaybe<ToothStatus>>>;
  leftTop?: InputMaybe<Array<InputMaybe<ToothStatus>>>;
  rightBottom?: InputMaybe<Array<InputMaybe<ToothStatus>>>;
  rightTop?: InputMaybe<Array<InputMaybe<ToothStatus>>>;
};

export type CardWidthConfigInput = {
  cardWidth: Scalars['Int'];
};

export type ClinicScheduleInput = {
  clinic_id: Scalars['String'];
  day?: InputMaybe<Scalars['Int']>;
  day_of_week?: InputMaybe<DayOfWeek>;
  end_date?: InputMaybe<Scalars['AWSTimestamp']>;
  end_time?: InputMaybe<Scalars['String']>;
  rule_type: ClinicScheduleType;
  service_day?: InputMaybe<Scalars['Boolean']>;
  specific_date?: InputMaybe<Scalars['AWSTimestamp']>;
  start_date: Scalars['AWSTimestamp'];
  start_time?: InputMaybe<Scalars['String']>;
  week?: InputMaybe<Week>;
};

export type ClinicTimeConfigInput = {
  clinicTime: ClinicTimeInput;
};

export type ClinicTimeInput = {
  endTime: ClinicHourMinutesInput;
  startTime: ClinicHourMinutesInput;
};

export type AddFacilityGroupInput = {
  clinic_id: Scalars['ID'];
  name: Scalars['String'];
};

export type CommonInput = {
  Q1: CommonQ1Input;
  Q2: CommonQ2Input;
  Q3: CommonQ3Input;
  Q4: CommonQ4Input;
  Q5: CommonQ5Input;
  Q6: CommonQ6Input;
};

export type CommonQ1Input = {
  answerQ1?: InputMaybe<Scalars['String']>;
  diseaseQ1: Scalars['String'];
  selected_clinicQ1?: InputMaybe<Scalars['String']>;
  selected_medicineQ1?: InputMaybe<Scalars['String']>;
};

export type CommonQ2Input = {
  answerQ2?: InputMaybe<Scalars['String']>;
  commentQ2?: InputMaybe<Scalars['String']>;
  selectedQ2?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CommonQ3Input = {
  answerQ3: Scalars['String'];
  selectedQ3?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CommonQ4Input = {
  answerQ4?: InputMaybe<Scalars['String']>;
  selected_optionsQ4?: InputMaybe<Scalars['String']>;
  selectedQ4?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CommonQ5Input = {
  answerQ5: Scalars['String'];
};

export type CommonQ6Input = {
  answerQ6: Scalars['String'];
  commentQ6?: InputMaybe<Scalars['String']>;
  dateQ6?: InputMaybe<Scalars['AWSTimestamp']>;
  selectedQ6?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type DentalInput = {
  Q1: DentalQ1Input;
  Q2: DentalQ2Input;
  Q3: DentalQ3Input;
  Q4: DentalQ4Input;
  Q5: DentalQ5Input;
};

export type DentalQ1Input = {
  commentQ1?: InputMaybe<Scalars['String']>;
  dateQ1?: InputMaybe<Scalars['AWSTimestamp']>;
  selectedQ1?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type DentalQ2Input = {
  commentQ2?: InputMaybe<Scalars['String']>;
  selectedQ2?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type DentalQ3Input = {
  answerQ3?: InputMaybe<Scalars['String']>;
  commentQ3?: InputMaybe<Scalars['String']>;
  selectedQ3?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type DentalQ4Input = {
  selectedQ4?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type DentalQ5Input = {
  selectedQ5?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MedicalInput = {
  Q1: MedicalQ1Input;
  Q2: MedicalQ2Input;
  Q3: MedicalQ3Input;
  Q4: MedicalQ4Input;
  Q5: MedicalQ5Input;
  Q6: MedicalQ6Input;
};

export type MedicalQ1Input = {
  commentQ1?: InputMaybe<Scalars['String']>;
  selectedQ1?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MedicalQ2Input = {
  bodyQ2: Array<InputMaybe<Scalars['String']>>;
  commentQ2: Scalars['String'];
  faceQ2: Array<InputMaybe<Scalars['String']>>;
};

export type MedicalQ3Input = {
  answerQ3?: InputMaybe<Scalars['String']>;
  clinic_anotherQ3?: InputMaybe<Scalars['String']>;
  clinic_otherQ3?: InputMaybe<Scalars['String']>;
  clinic_salonQ3?: InputMaybe<Scalars['String']>;
  selected_fatDissolvingQ3?: InputMaybe<Scalars['String']>;
  selected_laserQ3?: InputMaybe<Scalars['String']>;
  selected_peelingQ3?: InputMaybe<Scalars['String']>;
  selectedQ3?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MedicalQ4Input = {
  commentQ4?: InputMaybe<Scalars['String']>;
  constipationQ4?: InputMaybe<Scalars['String']>;
  favoriteQ4: Scalars['String'];
  selectedQ4?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sleepQ4?: InputMaybe<Scalars['String']>;
  stomachQ4?: InputMaybe<Scalars['String']>;
  ultravioletRaysQ4?: InputMaybe<Scalars['String']>;
};

export type MedicalQ5Input = {
  doctorsCosmeQ5?: InputMaybe<Scalars['String']>;
  selectedQ5?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skincareItemQ5?: InputMaybe<Scalars['String']>;
};

export type MedicalQ6Input = {
  commentQ6?: InputMaybe<Scalars['String']>;
  selectedQ6?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OrthodonticsInput = {
  Q1: OrthodonticsQ1Input;
  Q10: OrthodonticsQ10Input;
  Q2: OrthodonticsQ2Input;
  Q3: OrthodonticsQ3Input;
  Q4: OrthodonticsQ4Input;
  Q5: OrthodonticsQ5Input;
  Q6: OrthodonticsQ6Input;
  Q7: OrthodonticsQ7Input;
  Q8: OrthodonticsQ8Input;
  Q9: OrthodonticsQ9Input;
};

export type OrthodonticsQ1Input = {
  commentQ1?: InputMaybe<Scalars['String']>;
  selectedQ1?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OrthodonticsQ10Input = {
  commentQ10?: InputMaybe<Scalars['String']>;
  selectedQ10?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OrthodonticsQ2Input = {
  commentQ2?: InputMaybe<Scalars['String']>;
  selectedQ2?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OrthodonticsQ3Input = {
  answerQ3?: InputMaybe<Scalars['String']>;
  commentQ3?: InputMaybe<Scalars['String']>;
  dateQ3?: InputMaybe<Scalars['AWSTimestamp']>;
};

export type OrthodonticsQ4Input = {
  answerQ4?: InputMaybe<Scalars['String']>;
  dateQ4?: InputMaybe<Scalars['AWSTimestamp']>;
};

export type OrthodonticsQ5Input = {
  commentQ5?: InputMaybe<Scalars['String']>;
  dateQ5?: InputMaybe<Scalars['AWSTimestamp']>;
  selectedQ5?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OrthodonticsQ6Input = {
  selectedQ6?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OrthodonticsQ7Input = {
  commentQ7?: InputMaybe<Scalars['String']>;
  selectedQ7?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OrthodonticsQ8Input = {
  answerQ8?: InputMaybe<Scalars['String']>;
};

export type OrthodonticsQ9Input = {
  selectedQ9?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AddOrgInput = {
  org_label: Scalars['String'];
  org_name: Scalars['String'];
};

export type PatientInputV2 = {
  address?: InputMaybe<AddressUpdateInput>;
  age?: InputMaybe<Scalars['Int']>;
  birthday?: InputMaybe<Scalars['AWSTimestamp']>;
  clinic_id: Scalars['ID'];
  comment?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  from_p5g?: InputMaybe<Scalars['Boolean']>;
  fullName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  invitationNumber?: InputMaybe<Scalars['String']>;
  kana?: InputMaybe<NameInput>;
  kanaName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<NameInput>;
  patientCardNumber?: InputMaybe<Scalars['Int']>;
  patientCardNumberOptional?: InputMaybe<Scalars['Int']>;
  remarks?: InputMaybe<Scalars['String']>;
  tel?: InputMaybe<Scalars['String']>;
};

export type AddressUpdateInput = {
  house?: InputMaybe<Scalars['String']>;
  post?: InputMaybe<Scalars['String']>;
  prefectures?: InputMaybe<Scalars['String']>;
};

export type NameInput = {
  first: Scalars['String'];
  last: Scalars['String'];
};

export type AddressInput = {
  house: Scalars['String'];
  post: Scalars['String'];
  prefectures: Scalars['String'];
};

export type PhrInfoInput = {
  buying?: InputMaybe<BuyingInput>;
  confirmed?: InputMaybe<ConfirmedInput>;
  date: Scalars['AWSTimestamp'];
  expires_at?: InputMaybe<Scalars['AWSTimestamp']>;
  id: Scalars['ID'];
  payment?: InputMaybe<PaymentInput>;
  phr?: InputMaybe<PhrInput>;
};

export type BuyingInput = {
  items?: InputMaybe<Array<InputMaybe<ItemInput>>>;
};

export type ItemInput = {
  count: Scalars['Int'];
  name: Scalars['String'];
  price: Scalars['Int'];
};

export type ConfirmedInput = {
  cancel?: InputMaybe<CancelInput>;
  cancelTime?: InputMaybe<Scalars['AWSTimestamp']>;
  consultationTime?: InputMaybe<Scalars['AWSTimestamp']>;
  endTime: Scalars['AWSTimestamp'];
  menuId: Scalars['String'];
  parts: Scalars['String'];
  receptionTime?: InputMaybe<Scalars['AWSTimestamp']>;
  staffIds?: InputMaybe<Array<InputMaybe<StaffIdInput>>>;
  startTime: Scalars['AWSTimestamp'];
  type: Scalars['String'];
};

export type PaymentInput = {
  courpon?: InputMaybe<Scalars['Int']>;
  method: Scalars['String'];
  price: Scalars['String'];
  ticket?: InputMaybe<TicketInput>;
};

export type TicketInput = {
  buy_at: Scalars['AWSTimestamp'];
  counts: CountsInput;
  expires_at: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  name: Scalars['String'];
  price: Scalars['Int'];
};

export type CountsInput = {
  current: Scalars['Int'];
  max: Scalars['Int'];
};

export type PhrInput = {
  complement: Scalars['String'];
  links: Array<InputMaybe<LinkInput>>;
  progress: ProgressInput;
  related: Scalars['String'];
};

export type LinkInput = {
  name: Scalars['String'];
  url: Scalars['String'];
};

export type ProgressInput = {
  count: Scalars['Int'];
  text: Scalars['String'];
};

export type CreateRecallInput = {
  appointId: Scalars['String'];
  clinic_id: Scalars['String'];
  lastTreatmentDate: Scalars['AWSTimestamp'];
  medicalMenuId: Scalars['String'];
  nextDueDate: Scalars['AWSTimestamp'];
  patientId: Scalars['String'];
};

export type WorkingTimesInput = {
  am: Array<InputMaybe<Scalars['String']>>;
  pm: Array<InputMaybe<Scalars['String']>>;
};

export type AppointCustom = {
  __typename?: 'AppointCustom';
  appoint?: Maybe<Scalars['String']>;
  appointId?: Maybe<Scalars['ID']>;
  cancel?: Maybe<Cancel>;
  cancelTime?: Maybe<Scalars['AWSTimestamp']>;
  confirmedEndTime?: Maybe<Scalars['AWSTimestamp']>;
  confirmedTime?: Maybe<Scalars['AWSTimestamp']>;
  consultationTime?: Maybe<Scalars['AWSTimestamp']>;
  created_at?: Maybe<Scalars['AWSTimestamp']>;
  date?: Maybe<Scalars['AWSTimestamp']>;
  endTime?: Maybe<Scalars['AWSTimestamp']>;
  facilityId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isFirstVisiting?: Maybe<Scalars['Boolean']>;
  isLate?: Maybe<Scalars['Boolean']>;
  menuId?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  receptionTime?: Maybe<Scalars['AWSTimestamp']>;
  remarks?: Maybe<Scalars['String']>;
  secondEndTime?: Maybe<Scalars['AWSTimestamp']>;
  secondStartTime?: Maybe<Scalars['AWSTimestamp']>;
  staffIds?: Maybe<Array<Maybe<StaffIdCustom>>>;
  startTime?: Maybe<Scalars['AWSTimestamp']>;
  thirdEndTime?: Maybe<Scalars['AWSTimestamp']>;
  thirdStartTime?: Maybe<Scalars['AWSTimestamp']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['AWSTimestamp']>;
};

export type StaffIdCustom = {
  __typename?: 'StaffIdCustom';
  id?: Maybe<Scalars['ID']>;
  index?: Maybe<Scalars['Int']>;
};

export type IsDubbleBooking = {
  __typename?: 'isDubbleBooking';
  isDubbleBooking: Scalars['Boolean'];
};

export type IsNonAccepted = {
  __typename?: 'isNonAccepted';
  isNonAccepted: Scalars['Boolean'];
};

export type DeleteFacilityGroupInput = {
  clinic_id: Scalars['ID'];
  group_id: Scalars['ID'];
};

export type TransactReturn = {
  __typename?: 'TransactReturn';
  TransactReturn?: Maybe<Scalars['Boolean']>;
};

export type TransactDeleteGroupsInput = {
  clinic_id: Scalars['ID'];
  group_ids: Array<Scalars['ID']>;
};

export type ModifyIndexMenus = {
  index: Scalars['Int'];
  SDK_ID: Scalars['ID'];
};

export type AppointBlockCustom = {
  __typename?: 'AppointBlockCustom';
  clinic_id?: Maybe<Scalars['ID']>;
  color?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['AWSTimestamp']>;
  facilityId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  isDelete?: Maybe<Scalars['Boolean']>;
  isNonAccepted?: Maybe<Scalars['Boolean']>;
  remarks?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['AWSTimestamp']>;
};

export type ReturnBoolean = {
  __typename?: 'ReturnBoolean';
  boolean?: Maybe<Scalars['Boolean']>;
};

export type UpdateFacilityGroupInput = {
  clinic_id: Scalars['ID'];
  facilityIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  group_id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateFacilityIdxInput = {
  clinic_id: Scalars['ID'];
  direction: Scalars['Int'];
  facility_id: Scalars['ID'];
};

export type UpdateOrgInput = {
  isDelete?: InputMaybe<Scalars['Boolean']>;
  org_id?: InputMaybe<Scalars['ID']>;
  org_label?: InputMaybe<Scalars['String']>;
  org_name?: InputMaybe<Scalars['String']>;
};

export type NameUpdateInput = {
  first?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['String']>;
};

export type UpdatedRecall = {
  __typename?: 'UpdatedRecall';
  id: Scalars['ID'];
  status: RecallStatus;
  updatedAt: Scalars['AWSTimestamp'];
};

export type AddClinicInput = {
  clinic_id: Scalars['ID'];
  clinic_label: Scalars['String'];
  clinic_name: Scalars['String'];
  isDelete: Scalars['Boolean'];
  org_id: Scalars['ID'];
  org_label: Scalars['String'];
};

export type FacilityProp_FacilityGroup_Ids = {
  __typename?: 'FacilityProp_FacilityGroup_ids';
  clinic_id: Scalars['ID'];
  facilityGroupId: Scalars['ID'];
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
};

export type Forms = {
  __typename?: 'Forms';
  Forms: Array<Form>;
};

export type Res = Patient | PatientV2 | Undefined;

export type Undefined = {
  __typename?: 'Undefined';
  undefinedToken?: Maybe<Scalars['Boolean']>;
};

export type StaffData = {
  __typename?: 'StaffData';
  id?: Maybe<Scalars['ID']>;
  index?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type StaffDataInput = {
  id: Scalars['ID'];
  index?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateClinicInput = {
  clinic_id: Scalars['ID'];
  clinic_label: Scalars['String'];
  clinic_name: Scalars['String'];
  isDelete: Scalars['Boolean'];
  org_id: Scalars['ID'];
  org_label: Scalars['String'];
};

export type GetPhrInfoQueryVariables = Exact<{
  access_token: Scalars['String'];
  startTime: Scalars['AWSTimestamp'];
}>;


export type GetPhrInfoQuery = { __typename?: 'Query', getPHRInfo?: { __typename?: 'PHRInfo', date: any, expires_at?: any | null, buying?: { __typename?: 'Buying', items?: Array<{ __typename?: 'Item', count: number, name: string, price: number } | null> | null } | null, confirmed?: { __typename?: 'Confirmed', cancelTime?: any | null, consultationTime?: any | null, endTime: any, menuId: string, parts: string, receptionTime?: any | null, startTime: any, type: string, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds?: Array<{ __typename?: 'StaffId', id: string, index?: number | null } | null> | null } | null, payment?: { __typename?: 'Payment', courpon?: number | null, method: string, price: string, ticket?: { __typename?: 'Ticket', buy_at: any, expires_at: any, id: string, name: string, price: number, counts: { __typename?: 'Counts', current: number, max: number } } | null } | null, phr?: { __typename?: 'PHR', complement: string, related: string, links: Array<{ __typename?: 'Link', name: string, url: string } | null>, progress: { __typename?: 'Progress', count: number, text: string } } | null } | null };

export type GetPhrInfoByIdQueryVariables = Exact<{
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
}>;


export type GetPhrInfoByIdQuery = { __typename?: 'Query', getPHRInfoById?: { __typename?: 'PHRInfo', date: any, id: string, confirmed?: { __typename?: 'Confirmed', cancelTime?: any | null, consultationTime?: any | null, endTime: any, menuId: string, parts: string, receptionTime?: any | null, startTime: any, type: string, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds?: Array<{ __typename?: 'StaffId', id: string, index?: number | null } | null> | null } | null, phr?: { __typename?: 'PHR', complement: string, related: string, links: Array<{ __typename?: 'Link', name: string, url: string } | null>, progress: { __typename?: 'Progress', count: number, text: string } } | null, payment?: { __typename?: 'Payment', courpon?: number | null, method: string, price: string } | null } | null };

export type ListPeriodPhrInfoQueryVariables = Exact<{
  access_token: Scalars['String'];
  startDate: Scalars['AWSTimestamp'];
  endDate: Scalars['AWSTimestamp'];
}>;


export type ListPeriodPhrInfoQuery = { __typename?: 'Query', listPeriodPHRInfo?: { __typename?: 'PHRInfos', PHRInfos: Array<{ __typename?: 'PHRInfo', date: any, expires_at?: any | null, id: string, buying?: { __typename?: 'Buying', items?: Array<{ __typename?: 'Item', count: number, name: string, price: number } | null> | null } | null, confirmed?: { __typename?: 'Confirmed', cancelTime?: any | null, consultationTime?: any | null, endTime: any, menuId: string, parts: string, receptionTime?: any | null, startTime: any, type: string, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds?: Array<{ __typename?: 'StaffId', id: string, index?: number | null } | null> | null } | null, payment?: { __typename?: 'Payment', courpon?: number | null, method: string, price: string, ticket?: { __typename?: 'Ticket', buy_at: any, expires_at: any, id: string, name: string, price: number, counts: { __typename?: 'Counts', current: number, max: number } } | null } | null, phr?: { __typename?: 'PHR', complement: string, related: string, links: Array<{ __typename?: 'Link', name: string, url: string } | null>, progress: { __typename?: 'Progress', count: number, text: string } } | null } | null> } | null };

export type ListPeriodPhrInfoByIdQueryVariables = Exact<{
  id: Scalars['ID'];
  startDate: Scalars['AWSTimestamp'];
  endDate: Scalars['AWSTimestamp'];
}>;


export type ListPeriodPhrInfoByIdQuery = { __typename?: 'Query', listPeriodPHRInfoById?: { __typename?: 'PHRInfos', PHRInfos: Array<{ __typename?: 'PHRInfo', confirmed?: { __typename?: 'Confirmed', cancelTime?: any | null, consultationTime?: any | null, endTime: any, menuId: string, parts: string, receptionTime?: any | null, startTime: any, type: string, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds?: Array<{ __typename?: 'StaffId', id: string, index?: number | null } | null> | null } | null, phr?: { __typename?: 'PHR', progress: { __typename?: 'Progress', count: number } } | null } | null> } | null };

export type ListPeriodPhrInfoConfirmedQueryVariables = Exact<{
  access_token: Scalars['String'];
  startDate: Scalars['AWSTimestamp'];
  endDate: Scalars['AWSTimestamp'];
}>;


export type ListPeriodPhrInfoConfirmedQuery = { __typename?: 'Query', listPeriodPHRInfo?: { __typename?: 'PHRInfos', PHRInfos: Array<{ __typename?: 'PHRInfo', id: string, confirmed?: { __typename?: 'Confirmed', cancelTime?: any | null, consultationTime?: any | null, endTime: any, menuId: string, parts: string, receptionTime?: any | null, startTime: any, type: string, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds?: Array<{ __typename?: 'StaffId', id: string, index?: number | null } | null> | null } | null } | null> } | null };

export type AddPhrInfoMutationVariables = Exact<{
  PHRInfoInput: PhrInfoInput;
}>;


export type AddPhrInfoMutation = { __typename?: 'Mutation', addPHRInfo?: { __typename?: 'PHRInfo', date: any, expires_at?: any | null, id: string, buying?: { __typename?: 'Buying', items?: Array<{ __typename?: 'Item', count: number, name: string, price: number } | null> | null } | null, confirmed?: { __typename?: 'Confirmed', cancelTime?: any | null, consultationTime?: any | null, endTime: any, menuId: string, parts: string, receptionTime?: any | null, startTime: any, type: string, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds?: Array<{ __typename?: 'StaffId', id: string, index?: number | null } | null> | null } | null, payment?: { __typename?: 'Payment', courpon?: number | null, method: string, price: string, ticket?: { __typename?: 'Ticket', buy_at: any, expires_at: any, id: string, name: string, price: number, counts: { __typename?: 'Counts', current: number, max: number } } | null } | null, phr?: { __typename?: 'PHR', complement: string, related: string, links: Array<{ __typename?: 'Link', name: string, url: string } | null>, progress: { __typename?: 'Progress', count: number, text: string } } | null } | null };

export type GetPhrInfoConfirmedQueryVariables = Exact<{
  access_token: Scalars['String'];
  date: Scalars['AWSTimestamp'];
}>;


export type GetPhrInfoConfirmedQuery = { __typename?: 'Query', getPHRInfo?: { __typename?: 'PHRInfo', confirmed?: { __typename?: 'Confirmed', cancelTime?: any | null, consultationTime?: any | null, endTime: any, menuId: string, parts: string, receptionTime?: any | null, startTime: any, type: string, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds?: Array<{ __typename?: 'StaffId', id: string, index?: number | null } | null> | null } | null } | null };

export type DeletePhrInfoConfirmedMutationVariables = Exact<{
  id: Scalars['ID'];
  date: Scalars['AWSTimestamp'];
}>;


export type DeletePhrInfoConfirmedMutation = { __typename?: 'Mutation', deletePHRInfoConfirmed?: { __typename?: 'PHRInfo', confirmed?: { __typename?: 'Confirmed', cancelTime?: any | null, consultationTime?: any | null, endTime: any, menuId: string, parts: string, receptionTime?: any | null, startTime: any, type: string, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds?: Array<{ __typename?: 'StaffId', id: string, index?: number | null } | null> | null } | null } | null };

export type ScanPeriodBlockQueryVariables = Exact<{
  startTime: Scalars['AWSTimestamp'];
  endTime: Scalars['AWSTimestamp'];
  clinic_id: Scalars['ID'];
}>;


export type ScanPeriodBlockQuery = { __typename?: 'Query', scanPeriodBlock: { __typename?: 'AppointBlocks', AppointBlocks?: Array<{ __typename?: 'AppointBlock', id: string, startTime: any, endTime: any, facilityId: string, remarks?: string | null, color?: string | null, isNonAccepted?: boolean | null, isDelete?: boolean | null, clinic_id?: string | null } | null> | null } };

export type AddBlockMutationVariables = Exact<{
  startTime: Scalars['AWSTimestamp'];
  endTime: Scalars['AWSTimestamp'];
  facilityId: Scalars['ID'];
  remarks?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  clinic_id: Scalars['ID'];
}>;


export type AddBlockMutation = { __typename?: 'Mutation', addBlock: { __typename?: 'AppointBlock', id: string, startTime: any, endTime: any, facilityId: string, remarks?: string | null, isNonAccepted?: boolean | null, isDelete?: boolean | null, clinic_id?: string | null } };

export type UpdateBlockMutationVariables = Exact<{
  baseId: Scalars['ID'];
  baseStartTime: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
  endTime: Scalars['AWSTimestamp'];
  facilityId: Scalars['ID'];
  remarks?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  clinic_id: Scalars['ID'];
}>;


export type UpdateBlockMutation = { __typename?: 'Mutation', updateBlock: { __typename?: 'AppointBlockCustom', id: string, startTime?: any | null, endTime?: any | null, facilityId?: string | null, remarks?: string | null, isNonAccepted?: boolean | null, isDelete?: boolean | null, clinic_id?: string | null } };

export type UpdateBlockStatusMutationVariables = Exact<{
  clinic_id: Scalars['ID'];
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
  endTime: Scalars['AWSTimestamp'];
  facilityId: Scalars['ID'];
  remarks?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
}>;


export type UpdateBlockStatusMutation = { __typename?: 'Mutation', updateBlockStatus: { __typename?: 'AppointBlockCustom', clinic_id?: string | null, id: string, startTime?: any | null, endTime?: any | null, facilityId?: string | null, remarks?: string | null, isNonAccepted?: boolean | null, isDelete?: boolean | null } };

export type DeleteBlockMutationVariables = Exact<{
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
}>;


export type DeleteBlockMutation = { __typename?: 'Mutation', deleteBlock: { __typename?: 'AppointBlock', id: string, startTime: any, endTime: any, facilityId: string, remarks?: string | null, color?: string | null, isNonAccepted?: boolean | null, isDelete?: boolean | null } };

export type GetBlockQueryVariables = Exact<{
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
}>;


export type GetBlockQuery = { __typename?: 'Query', getBlock: { __typename?: 'AppointBlock', id: string, startTime: any, endTime: any, facilityId: string, remarks?: string | null, color?: string | null, isNonAccepted?: boolean | null, isDelete?: boolean | null } };

export type CheckDubbleBookingMutationVariables = Exact<{
  id: Scalars['ID'];
  date: Scalars['AWSTimestamp'];
  startTime: Scalars['AWSTimestamp'];
  endTime: Scalars['AWSTimestamp'];
}>;


export type CheckDubbleBookingMutation = { __typename?: 'Mutation', checkDubbleBooking: { __typename?: 'isDubbleBooking', isDubbleBooking: boolean } };

export type ChangeStatusMutationVariables = Exact<{
  appoint: Scalars['String'];
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
  receptionTime?: InputMaybe<Scalars['AWSTimestamp']>;
  cancelTime?: InputMaybe<Scalars['AWSTimestamp']>;
  consultationTime?: InputMaybe<Scalars['AWSTimestamp']>;
  cancel?: InputMaybe<CancelInput>;
  isLate?: InputMaybe<Scalars['Boolean']>;
}>;


export type ChangeStatusMutation = { __typename?: 'Mutation', changeStatus?: { __typename?: 'AppointCustom', appoint?: string | null, id?: string | null, startTime?: any | null, receptionTime?: any | null, consultationTime?: any | null, cancelTime?: any | null, created_at?: any | null, updated_at?: any | null, isLate?: boolean | null, cancel?: { __typename?: 'Cancel', isCancel?: boolean | null, cancelReason?: string | null, radioCancelReason?: number | null } | null } | null };

export type AddAppointMutationVariables = Exact<{
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
  endTime: Scalars['AWSTimestamp'];
  date: Scalars['AWSTimestamp'];
  appoint?: InputMaybe<Scalars['String']>;
  appointId?: InputMaybe<Scalars['ID']>;
  type: Scalars['String'];
  menuId: Scalars['String'];
  facilityId: Scalars['String'];
  price: Scalars['Int'];
  staffIds: Array<StaffIdInput> | StaffIdInput;
  secondStartTime?: InputMaybe<Scalars['AWSTimestamp']>;
  secondEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  thirdStartTime?: InputMaybe<Scalars['AWSTimestamp']>;
  thirdEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  confirmedTime?: InputMaybe<Scalars['AWSTimestamp']>;
  confirmedEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  remarks?: InputMaybe<Scalars['String']>;
  isFirstVisiting?: InputMaybe<Scalars['Boolean']>;
  clinic_id: Scalars['ID'];
  isLate?: InputMaybe<Scalars['Boolean']>;
  dentalFormula?: InputMaybe<DentalFormulaInput>;
}>;


export type AddAppointMutation = { __typename?: 'Mutation', addAppoint: { __typename?: 'Appoint', appoint?: string | null, appointId: string, cancelTime?: any | null, confirmedEndTime?: any | null, confirmedTime?: any | null, consultationTime?: any | null, date: any, endTime: any, facilityId: string, id: string, isFirstVisiting?: boolean | null, menuId?: string | null, price?: number | null, receptionTime?: any | null, remarks?: string | null, secondEndTime?: any | null, secondStartTime?: any | null, startTime: any, thirdEndTime?: any | null, thirdStartTime?: any | null, type?: string | null, isDubbleBooking?: boolean | null, created_at?: any | null, updated_at?: any | null, clinic_id: string, isLate?: boolean | null, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds: Array<{ __typename?: 'StaffId', id: string, index?: number | null }>, dentalFormula?: { __typename?: 'DentalFormulaResponse', permanent?: { __typename?: 'DentalFormulaArrayResponse', leftTop?: Array<ToothStatus | null> | null, rightTop?: Array<ToothStatus | null> | null, leftBottom?: Array<ToothStatus | null> | null, rightBottom?: Array<ToothStatus | null> | null } | null, baby?: { __typename?: 'DentalFormulaArrayResponse', leftTop?: Array<ToothStatus | null> | null, rightTop?: Array<ToothStatus | null> | null, leftBottom?: Array<ToothStatus | null> | null, rightBottom?: Array<ToothStatus | null> | null } | null } | null } };

export type DeleteAppointMutationVariables = Exact<{
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
}>;


export type DeleteAppointMutation = { __typename?: 'Mutation', deleteAppoint: { __typename?: 'Appoint', appoint?: string | null, appointId: string, cancelTime?: any | null, confirmedEndTime?: any | null, confirmedTime?: any | null, consultationTime?: any | null, date: any, endTime: any, facilityId: string, id: string, isFirstVisiting?: boolean | null, menuId?: string | null, price?: number | null, receptionTime?: any | null, remarks?: string | null, secondEndTime?: any | null, secondStartTime?: any | null, startTime: any, thirdEndTime?: any | null, thirdStartTime?: any | null, type?: string | null, created_at?: any | null, updated_at?: any | null, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds: Array<{ __typename?: 'StaffId', id: string, index?: number | null }> } };

export type UpdateAppointMutationVariables = Exact<{
  baseId: Scalars['ID'];
  baseStartTime: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
  endTime?: InputMaybe<Scalars['AWSTimestamp']>;
  appoint?: InputMaybe<Scalars['String']>;
  appointId: Scalars['ID'];
  type?: InputMaybe<Scalars['String']>;
  staffIds?: InputMaybe<Array<InputMaybe<StaffIdInput>> | InputMaybe<StaffIdInput>>;
  menuId?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  secondStartTime?: InputMaybe<Scalars['AWSTimestamp']>;
  secondEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  thirdStartTime?: InputMaybe<Scalars['AWSTimestamp']>;
  thirdEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  confirmedTime?: InputMaybe<Scalars['AWSTimestamp']>;
  confirmedEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  remarks?: InputMaybe<Scalars['String']>;
  isFirstVisiting?: InputMaybe<Scalars['Boolean']>;
  date: Scalars['AWSTimestamp'];
  clinic_id: Scalars['ID'];
  isLate?: InputMaybe<Scalars['Boolean']>;
  dentalFormula?: InputMaybe<DentalFormulaInput>;
}>;


export type UpdateAppointMutation = { __typename?: 'Mutation', updateAppoint: { __typename?: 'Appoint', appoint?: string | null, appointId: string, cancelTime?: any | null, confirmedEndTime?: any | null, confirmedTime?: any | null, consultationTime?: any | null, date: any, endTime: any, facilityId: string, id: string, isFirstVisiting?: boolean | null, menuId?: string | null, price?: number | null, receptionTime?: any | null, remarks?: string | null, secondEndTime?: any | null, secondStartTime?: any | null, startTime: any, thirdEndTime?: any | null, thirdStartTime?: any | null, type?: string | null, isDubbleBooking?: boolean | null, created_at?: any | null, updated_at?: any | null, clinic_id: string, isLate?: boolean | null, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds: Array<{ __typename?: 'StaffId', id: string, index?: number | null }>, dentalFormula?: { __typename?: 'DentalFormulaResponse', permanent?: { __typename?: 'DentalFormulaArrayResponse', leftTop?: Array<ToothStatus | null> | null, rightTop?: Array<ToothStatus | null> | null, leftBottom?: Array<ToothStatus | null> | null, rightBottom?: Array<ToothStatus | null> | null } | null, baby?: { __typename?: 'DentalFormulaArrayResponse', leftTop?: Array<ToothStatus | null> | null, rightTop?: Array<ToothStatus | null> | null, leftBottom?: Array<ToothStatus | null> | null, rightBottom?: Array<ToothStatus | null> | null } | null } | null } };

export type UpdateAppointInfoMutationVariables = Exact<{
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
  endTime?: InputMaybe<Scalars['AWSTimestamp']>;
  appoint?: InputMaybe<Scalars['String']>;
  appointId: Scalars['ID'];
  type?: InputMaybe<Scalars['String']>;
  staffIds?: InputMaybe<Array<InputMaybe<StaffIdInput>> | InputMaybe<StaffIdInput>>;
  menuId?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  secondStartTime?: InputMaybe<Scalars['AWSTimestamp']>;
  secondEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  thirdStartTime?: InputMaybe<Scalars['AWSTimestamp']>;
  thirdEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  confirmedTime?: InputMaybe<Scalars['AWSTimestamp']>;
  confirmedEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  remarks: Scalars['String'];
  isFirstVisiting?: InputMaybe<Scalars['Boolean']>;
  date: Scalars['AWSTimestamp'];
  clinic_id: Scalars['ID'];
  isLate?: InputMaybe<Scalars['Boolean']>;
  dentalFormula?: InputMaybe<DentalFormulaInput>;
}>;


export type UpdateAppointInfoMutation = { __typename?: 'Mutation', updateAppointInfo: { __typename?: 'Appoint', isDubbleBooking?: boolean | null, clinic_id: string, appoint?: string | null, appointId: string, cancelTime?: any | null, confirmedEndTime?: any | null, confirmedTime?: any | null, consultationTime?: any | null, date: any, endTime: any, facilityId: string, id: string, isFirstVisiting?: boolean | null, menuId?: string | null, price?: number | null, receptionTime?: any | null, remarks?: string | null, secondEndTime?: any | null, secondStartTime?: any | null, startTime: any, thirdEndTime?: any | null, thirdStartTime?: any | null, type?: string | null, created_at?: any | null, updated_at?: any | null, isLate?: boolean | null, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null } | null, staffIds: Array<{ __typename?: 'StaffId', id: string, index?: number | null }>, dentalFormula?: { __typename?: 'DentalFormulaResponse', permanent?: { __typename?: 'DentalFormulaArrayResponse', leftTop?: Array<ToothStatus | null> | null, rightTop?: Array<ToothStatus | null> | null, leftBottom?: Array<ToothStatus | null> | null, rightBottom?: Array<ToothStatus | null> | null } | null, baby?: { __typename?: 'DentalFormulaArrayResponse', leftTop?: Array<ToothStatus | null> | null, rightTop?: Array<ToothStatus | null> | null, leftBottom?: Array<ToothStatus | null> | null, rightBottom?: Array<ToothStatus | null> | null } | null } | null } };

export type GetAppointQueryVariables = Exact<{
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
}>;


export type GetAppointQuery = { __typename?: 'Query', getAppoint: { __typename?: 'Appoint', appoint?: string | null, appointId: string, cancelTime?: any | null, confirmedEndTime?: any | null, confirmedTime?: any | null, consultationTime?: any | null, date: any, endTime: any, facilityId: string, id: string, isFirstVisiting?: boolean | null, menuId?: string | null, price?: number | null, receptionTime?: any | null, remarks?: string | null, secondEndTime?: any | null, secondStartTime?: any | null, startTime: any, thirdEndTime?: any | null, thirdStartTime?: any | null, type?: string | null, created_at?: any | null, updated_at?: any | null, isLate?: boolean | null, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds: Array<{ __typename?: 'StaffId', id: string, index?: number | null }> } };

export type ListPeriodAppointQueryVariables = Exact<{
  access_token: Scalars['String'];
  startDate: Scalars['AWSTimestamp'];
  endDate: Scalars['AWSTimestamp'];
}>;


export type ListPeriodAppointQuery = { __typename?: 'Query', listPeriodAppoint: { __typename?: 'Appoints', Appoints: Array<{ __typename?: 'Appoint', appointId: string, appoint?: string | null, cancelTime?: any | null, confirmedEndTime?: any | null, confirmedTime?: any | null, consultationTime?: any | null, date: any, endTime: any, facilityId: string, id: string, isFirstVisiting?: boolean | null, menuId?: string | null, price?: number | null, receptionTime?: any | null, remarks?: string | null, secondEndTime?: any | null, secondStartTime?: any | null, startTime: any, thirdEndTime?: any | null, thirdStartTime?: any | null, type?: string | null, created_at?: any | null, updated_at?: any | null, isLate?: boolean | null, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds: Array<{ __typename?: 'StaffId', id: string, index?: number | null }> } | null> } };

export type ListPeriodAppointByIdQueryVariables = Exact<{
  id: Scalars['ID'];
  startDate: Scalars['AWSTimestamp'];
  endDate: Scalars['AWSTimestamp'];
}>;


export type ListPeriodAppointByIdQuery = { __typename?: 'Query', listPeriodAppointById: { __typename?: 'Appoints', Appoints: Array<{ __typename?: 'Appoint', appoint?: string | null, appointId: string, cancelTime?: any | null, confirmedEndTime?: any | null, confirmedTime?: any | null, consultationTime?: any | null, date: any, endTime: any, facilityId: string, id: string, isFirstVisiting?: boolean | null, menuId?: string | null, price?: number | null, receptionTime?: any | null, remarks?: string | null, secondEndTime?: any | null, secondStartTime?: any | null, startTime: any, thirdEndTime?: any | null, thirdStartTime?: any | null, type?: string | null, created_at?: any | null, updated_at?: any | null, isLate?: boolean | null, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds: Array<{ __typename?: 'StaffId', id: string, index?: number | null }> } | null> } };

export type ListAppointByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ListAppointByIdQuery = { __typename?: 'Query', listAppointById?: { __typename?: 'Appoints', Appoints: Array<{ __typename?: 'Appoint', appoint?: string | null, appointId: string, cancelTime?: any | null, confirmedEndTime?: any | null, confirmedTime?: any | null, consultationTime?: any | null, date: any, endTime: any, facilityId: string, id: string, isFirstVisiting?: boolean | null, menuId?: string | null, price?: number | null, receptionTime?: any | null, remarks?: string | null, secondEndTime?: any | null, secondStartTime?: any | null, startTime: any, thirdEndTime?: any | null, thirdStartTime?: any | null, type?: string | null, created_at?: any | null, updated_at?: any | null, isLate?: boolean | null, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds: Array<{ __typename?: 'StaffId', id: string, index?: number | null }> } | null> } | null };

export type ListTodayAppointQueryVariables = Exact<{
  date: Scalars['AWSTimestamp'];
  choice?: InputMaybe<Scalars['Int']>;
}>;


export type ListTodayAppointQuery = { __typename?: 'Query', listTodayAppoint: { __typename?: 'Appoints', Appoints: Array<{ __typename?: 'Appoint', appoint?: string | null, appointId: string, cancelTime?: any | null, confirmedEndTime?: any | null, confirmedTime?: any | null, consultationTime?: any | null, date: any, endTime: any, facilityId: string, id: string, isFirstVisiting?: boolean | null, menuId?: string | null, price?: number | null, receptionTime?: any | null, remarks?: string | null, secondEndTime?: any | null, secondStartTime?: any | null, startTime: any, thirdEndTime?: any | null, thirdStartTime?: any | null, type?: string | null, created_at?: any | null, updated_at?: any | null, isLate?: boolean | null, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds: Array<{ __typename?: 'StaffId', id: string, index?: number | null }> } | null> } };

export type ScanPeriodAppointQueryVariables = Exact<{
  startDate: Scalars['AWSTimestamp'];
  endDate: Scalars['AWSTimestamp'];
  clinic_id: Scalars['ID'];
}>;


export type ScanPeriodAppointQuery = { __typename?: 'Query', scanPeriodAppoint: { __typename?: 'Appoints', Appoints: Array<{ __typename?: 'Appoint', appoint?: string | null, appointId: string, cancelTime?: any | null, confirmedEndTime?: any | null, confirmedTime?: any | null, consultationTime?: any | null, date: any, endTime: any, facilityId: string, id: string, isFirstVisiting?: boolean | null, menuId?: string | null, price?: number | null, receptionTime?: any | null, remarks?: string | null, startTime: any, type?: string | null, created_at?: any | null, updated_at?: any | null, clinic_id: string, isLate?: boolean | null, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds: Array<{ __typename?: 'StaffId', id: string, index?: number | null }> } | null> } };

export type CheckLastUpdateQueryVariables = Exact<{
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
  beforeUpdated_at: Scalars['AWSTimestamp'];
  appointId: Scalars['ID'];
}>;


export type CheckLastUpdateQuery = { __typename?: 'Query', checkLastUpdate?: { __typename?: 'AppointTimestamps', id: string, startTime: any, appointId: string, created_at?: any | null, updated_at?: any | null, isUpdated?: boolean | null } | null };

export type CheckAppointConfrictQueryVariables = Exact<{
  inputs: AppointInput;
}>;


export type CheckAppointConfrictQuery = { __typename?: 'Query', checkAppointConfrict: { __typename?: 'CheckAppointConfrictResponse', isNonAccepted: boolean, isTimeConfrict: boolean, isDoubleBooking: boolean, isStaffDoubleBooking: boolean, duplicatedStaffIdsWithFacility: Array<{ __typename?: 'DuplicatedInfo', facilityId: string, staffIds: Array<string> } | null> } };

export type AppointDetailsForAppointShiftFragmentFragment = { __typename?: 'AppointDetails', clinic_id: string, id: string, appointId: string, appoint: string, startTime: any, endTime: any, date: any, type?: string | null, patientName?: string | null, patientKana?: string | null, patientCardNumber?: string | null, menuAbbreviation?: string | null, facilityId: string, facilityName: string, isFirstVisiting?: boolean | null, receptionTime?: any | null, treatmentCompletedTime?: any | null, cancelTime?: any | null, isLate?: boolean | null, isDubbleBooking?: boolean | null, remarks?: string | null, staffNames: Array<{ __typename?: 'StaffName', index: number, name: string, color?: string | null }>, cancel?: { __typename?: 'Cancel', isCancel?: boolean | null, cancelReason?: string | null, radioCancelReason?: number | null } | null, dentalFormula?: { __typename?: 'DentalFormulaResponse', permanent?: { __typename?: 'DentalFormulaArrayResponse', leftTop?: Array<ToothStatus | null> | null, rightTop?: Array<ToothStatus | null> | null, leftBottom?: Array<ToothStatus | null> | null, rightBottom?: Array<ToothStatus | null> | null } | null, baby?: { __typename?: 'DentalFormulaArrayResponse', leftTop?: Array<ToothStatus | null> | null, rightTop?: Array<ToothStatus | null> | null, leftBottom?: Array<ToothStatus | null> | null, rightBottom?: Array<ToothStatus | null> | null } | null } | null };

export type AppointDetailsForAppointListFragmentFragment = { __typename?: 'AppointDetails', clinic_id: string, id: string, appointId: string, appoint: string, startTime: any, endTime: any, date: any, type?: string | null, patientName?: string | null, patientKana?: string | null, patientCardNumber?: string | null, patientCardNumberOptional?: string | null, menuName?: string | null, facilityName: string, isFirstVisiting?: boolean | null, receptionTime?: any | null, treatmentCompletedTime?: any | null, cancelTime?: any | null, isLate?: boolean | null, isDubbleBooking?: boolean | null, staffNames: Array<{ __typename?: 'StaffName', index: number, name: string }>, cancel?: { __typename?: 'Cancel', isCancel?: boolean | null, cancelReason?: string | null, radioCancelReason?: number | null } | null, dentalFormula?: { __typename?: 'DentalFormulaResponse', permanent?: { __typename?: 'DentalFormulaArrayResponse', leftTop?: Array<ToothStatus | null> | null, rightTop?: Array<ToothStatus | null> | null, leftBottom?: Array<ToothStatus | null> | null, rightBottom?: Array<ToothStatus | null> | null } | null, baby?: { __typename?: 'DentalFormulaArrayResponse', leftTop?: Array<ToothStatus | null> | null, rightTop?: Array<ToothStatus | null> | null, leftBottom?: Array<ToothStatus | null> | null, rightBottom?: Array<ToothStatus | null> | null } | null } | null };

export type AppointDetailsForPatientInfoFragmentFragment = { __typename?: 'AppointDetails', clinic_id: string, id: string, appointId: string, appoint: string, startTime: any, endTime: any, date: any, type?: string | null, patientName?: string | null, patientKana?: string | null, menuAbbreviation?: string | null, facilityName: string, isFirstVisiting?: boolean | null, receptionTime?: any | null, treatmentCompletedTime?: any | null, cancelTime?: any | null, isLate?: boolean | null, isDubbleBooking?: boolean | null, staffNames: Array<{ __typename?: 'StaffName', index: number, name: string }>, cancel?: { __typename?: 'Cancel', isCancel?: boolean | null, cancelReason?: string | null, radioCancelReason?: number | null } | null, dentalFormula?: { __typename?: 'DentalFormulaResponse', permanent?: { __typename?: 'DentalFormulaArrayResponse', leftTop?: Array<ToothStatus | null> | null, rightTop?: Array<ToothStatus | null> | null, leftBottom?: Array<ToothStatus | null> | null, rightBottom?: Array<ToothStatus | null> | null } | null, baby?: { __typename?: 'DentalFormulaArrayResponse', leftTop?: Array<ToothStatus | null> | null, rightTop?: Array<ToothStatus | null> | null, leftBottom?: Array<ToothStatus | null> | null, rightBottom?: Array<ToothStatus | null> | null } | null } | null };

export type ListAppointForAppointListQueryVariables = Exact<{
  inputs: ListAppointDetailsInputs;
}>;


export type ListAppointForAppointListQuery = { __typename?: 'Query', listAppointDetails: Array<{ __typename?: 'AppointDetails', clinic_id: string, id: string, appointId: string, appoint: string, startTime: any, endTime: any, date: any, type?: string | null, patientName?: string | null, patientKana?: string | null, patientCardNumber?: string | null, patientCardNumberOptional?: string | null, menuName?: string | null, facilityName: string, isFirstVisiting?: boolean | null, receptionTime?: any | null, treatmentCompletedTime?: any | null, cancelTime?: any | null, isLate?: boolean | null, isDubbleBooking?: boolean | null, staffNames: Array<{ __typename?: 'StaffName', index: number, name: string }>, cancel?: { __typename?: 'Cancel', isCancel?: boolean | null, cancelReason?: string | null, radioCancelReason?: number | null } | null, dentalFormula?: { __typename?: 'DentalFormulaResponse', permanent?: { __typename?: 'DentalFormulaArrayResponse', leftTop?: Array<ToothStatus | null> | null, rightTop?: Array<ToothStatus | null> | null, leftBottom?: Array<ToothStatus | null> | null, rightBottom?: Array<ToothStatus | null> | null } | null, baby?: { __typename?: 'DentalFormulaArrayResponse', leftTop?: Array<ToothStatus | null> | null, rightTop?: Array<ToothStatus | null> | null, leftBottom?: Array<ToothStatus | null> | null, rightBottom?: Array<ToothStatus | null> | null } | null } | null }> };

export type ListAppointForAppointShiftQueryVariables = Exact<{
  inputs: ListAppointDetailsInputs;
}>;


export type ListAppointForAppointShiftQuery = { __typename?: 'Query', listAppointDetails: Array<{ __typename?: 'AppointDetails', clinic_id: string, id: string, appointId: string, appoint: string, startTime: any, endTime: any, date: any, type?: string | null, patientName?: string | null, patientKana?: string | null, patientCardNumber?: string | null, menuAbbreviation?: string | null, facilityId: string, facilityName: string, isFirstVisiting?: boolean | null, receptionTime?: any | null, treatmentCompletedTime?: any | null, cancelTime?: any | null, isLate?: boolean | null, isDubbleBooking?: boolean | null, remarks?: string | null, staffNames: Array<{ __typename?: 'StaffName', index: number, name: string, color?: string | null }>, cancel?: { __typename?: 'Cancel', isCancel?: boolean | null, cancelReason?: string | null, radioCancelReason?: number | null } | null, dentalFormula?: { __typename?: 'DentalFormulaResponse', permanent?: { __typename?: 'DentalFormulaArrayResponse', leftTop?: Array<ToothStatus | null> | null, rightTop?: Array<ToothStatus | null> | null, leftBottom?: Array<ToothStatus | null> | null, rightBottom?: Array<ToothStatus | null> | null } | null, baby?: { __typename?: 'DentalFormulaArrayResponse', leftTop?: Array<ToothStatus | null> | null, rightTop?: Array<ToothStatus | null> | null, leftBottom?: Array<ToothStatus | null> | null, rightBottom?: Array<ToothStatus | null> | null } | null } | null }> };

export type ListAppointForPatientInfoQueryVariables = Exact<{
  inputs: ListAppointDetailsByIdInputs;
}>;


export type ListAppointForPatientInfoQuery = { __typename?: 'Query', listAppointDetailsById: Array<{ __typename?: 'AppointDetails', clinic_id: string, id: string, appointId: string, appoint: string, startTime: any, endTime: any, date: any, type?: string | null, patientName?: string | null, patientKana?: string | null, menuAbbreviation?: string | null, facilityName: string, isFirstVisiting?: boolean | null, receptionTime?: any | null, treatmentCompletedTime?: any | null, cancelTime?: any | null, isLate?: boolean | null, isDubbleBooking?: boolean | null, staffNames: Array<{ __typename?: 'StaffName', index: number, name: string }>, cancel?: { __typename?: 'Cancel', isCancel?: boolean | null, cancelReason?: string | null, radioCancelReason?: number | null } | null, dentalFormula?: { __typename?: 'DentalFormulaResponse', permanent?: { __typename?: 'DentalFormulaArrayResponse', leftTop?: Array<ToothStatus | null> | null, rightTop?: Array<ToothStatus | null> | null, leftBottom?: Array<ToothStatus | null> | null, rightBottom?: Array<ToothStatus | null> | null } | null, baby?: { __typename?: 'DentalFormulaArrayResponse', leftTop?: Array<ToothStatus | null> | null, rightTop?: Array<ToothStatus | null> | null, leftBottom?: Array<ToothStatus | null> | null, rightBottom?: Array<ToothStatus | null> | null } | null } | null }> };

export type AppointV2FieldsFragment = { __typename?: 'AppointV2', id: string, appoint?: string | null, appointId: string, startTime: any, endTime: any, secondStartTime?: any | null, secondEndTime?: any | null, thirdStartTime?: any | null, thirdEndTime?: any | null, confirmedTime?: any | null, confirmedEndTime?: any | null, remarks?: string | null, date: any, type?: string | null, menuId?: string | null, facilityId: string, price?: number | null, isFirstVisiting?: boolean | null, receptionTime?: any | null, treatmentCompletedTime?: any | null, cancelTime?: any | null, isLate?: boolean | null, consultationTime?: any | null, isDubbleBooking?: boolean | null, created_at?: any | null, updated_at?: any | null, clinic_id: string, patientName?: string | null, patientKana?: string | null, patientRemarks?: string | null, menuName?: string | null, facilityName: string, isPeriodicCheckup?: boolean | null, staffIds: Array<{ __typename?: 'StaffId', index?: number | null, id: string }>, cancel?: { __typename?: 'Cancel', isCancel?: boolean | null, cancelReason?: string | null, radioCancelReason?: number | null } | null, staffNames: Array<{ __typename?: 'StaffName', index: number, name: string }>, dentalFormula?: { __typename?: 'DentalFormulaResponse', permanent?: { __typename?: 'DentalFormulaArrayResponse', leftTop?: Array<ToothStatus | null> | null, rightTop?: Array<ToothStatus | null> | null, leftBottom?: Array<ToothStatus | null> | null, rightBottom?: Array<ToothStatus | null> | null } | null, baby?: { __typename?: 'DentalFormulaArrayResponse', leftTop?: Array<ToothStatus | null> | null, rightTop?: Array<ToothStatus | null> | null, leftBottom?: Array<ToothStatus | null> | null, rightBottom?: Array<ToothStatus | null> | null } | null } | null };

export type GetAppointByIdV2QueryVariables = Exact<{
  clinic_id: Scalars['ID'];
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
}>;


export type GetAppointByIdV2Query = { __typename?: 'Query', getAppointByIdV2: { __typename?: 'AppointV2', id: string, appoint?: string | null, appointId: string, startTime: any, endTime: any, secondStartTime?: any | null, secondEndTime?: any | null, thirdStartTime?: any | null, thirdEndTime?: any | null, confirmedTime?: any | null, confirmedEndTime?: any | null, remarks?: string | null, date: any, type?: string | null, menuId?: string | null, facilityId: string, price?: number | null, isFirstVisiting?: boolean | null, receptionTime?: any | null, treatmentCompletedTime?: any | null, cancelTime?: any | null, isLate?: boolean | null, consultationTime?: any | null, isDubbleBooking?: boolean | null, created_at?: any | null, updated_at?: any | null, clinic_id: string, patientName?: string | null, patientKana?: string | null, patientRemarks?: string | null, menuName?: string | null, facilityName: string, isPeriodicCheckup?: boolean | null, staffIds: Array<{ __typename?: 'StaffId', index?: number | null, id: string }>, cancel?: { __typename?: 'Cancel', isCancel?: boolean | null, cancelReason?: string | null, radioCancelReason?: number | null } | null, staffNames: Array<{ __typename?: 'StaffName', index: number, name: string }>, dentalFormula?: { __typename?: 'DentalFormulaResponse', permanent?: { __typename?: 'DentalFormulaArrayResponse', leftTop?: Array<ToothStatus | null> | null, rightTop?: Array<ToothStatus | null> | null, leftBottom?: Array<ToothStatus | null> | null, rightBottom?: Array<ToothStatus | null> | null } | null, baby?: { __typename?: 'DentalFormulaArrayResponse', leftTop?: Array<ToothStatus | null> | null, rightTop?: Array<ToothStatus | null> | null, leftBottom?: Array<ToothStatus | null> | null, rightBottom?: Array<ToothStatus | null> | null } | null } | null } };

export type ListAppointByIdV2QueryVariables = Exact<{
  clinic_id: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type ListAppointByIdV2Query = { __typename?: 'Query', listAppointByIdV2?: { __typename?: 'AppointsV2', Appoints: Array<{ __typename?: 'AppointV2', id: string, appoint?: string | null, appointId: string, startTime: any, endTime: any, secondStartTime?: any | null, secondEndTime?: any | null, thirdStartTime?: any | null, thirdEndTime?: any | null, confirmedTime?: any | null, confirmedEndTime?: any | null, remarks?: string | null, date: any, type?: string | null, menuId?: string | null, facilityId: string, price?: number | null, isFirstVisiting?: boolean | null, receptionTime?: any | null, treatmentCompletedTime?: any | null, cancelTime?: any | null, isLate?: boolean | null, consultationTime?: any | null, isDubbleBooking?: boolean | null, created_at?: any | null, updated_at?: any | null, clinic_id: string, patientName?: string | null, patientKana?: string | null, patientRemarks?: string | null, menuName?: string | null, facilityName: string, isPeriodicCheckup?: boolean | null, staffIds: Array<{ __typename?: 'StaffId', index?: number | null, id: string }>, cancel?: { __typename?: 'Cancel', isCancel?: boolean | null, cancelReason?: string | null, radioCancelReason?: number | null } | null, staffNames: Array<{ __typename?: 'StaffName', index: number, name: string }>, dentalFormula?: { __typename?: 'DentalFormulaResponse', permanent?: { __typename?: 'DentalFormulaArrayResponse', leftTop?: Array<ToothStatus | null> | null, rightTop?: Array<ToothStatus | null> | null, leftBottom?: Array<ToothStatus | null> | null, rightBottom?: Array<ToothStatus | null> | null } | null, baby?: { __typename?: 'DentalFormulaArrayResponse', leftTop?: Array<ToothStatus | null> | null, rightTop?: Array<ToothStatus | null> | null, leftBottom?: Array<ToothStatus | null> | null, rightBottom?: Array<ToothStatus | null> | null } | null } | null } | null> } | null };

export type GetClinicQueryVariables = Exact<{
  org_id: Scalars['ID'];
  clinic_id: Scalars['ID'];
}>;


export type GetClinicQuery = { __typename?: 'Query', getClinic: { __typename?: 'Clinic', org_id: string, clinic_id: string, clinic_label: string, clinic_name: string, isDelete: boolean, created_at: any, updated_at?: any | null } };

export type GetClinicLabelQueryVariables = Exact<{
  org_id: Scalars['ID'];
  clinic_id: Scalars['ID'];
}>;


export type GetClinicLabelQuery = { __typename?: 'Query', getClinic: { __typename?: 'Clinic', clinic_label: string } };

export type ListClinicsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListClinicsQuery = { __typename?: 'Query', listClinics: { __typename?: 'Clinics', clinics: Array<{ __typename?: 'Clinic', org_id: string, clinic_id: string, clinic_label: string, clinic_name: string, isDelete: boolean, created_at: any, updated_at?: any | null }> } };

export type GetLatestClinicConfigQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
  current_date: Scalars['AWSTimestamp'];
  config_type: Scalars['String'];
}>;


export type GetLatestClinicConfigQuery = { __typename?: 'Query', getLatestClinicConfig?: { __typename?: 'ClinicConfig', clinic_id: string, config_id: string, config_type: string, endDate?: any | null, startDate: any, created_at?: any | null, config: { __typename: 'CardWidthConfig', cardWidth: number } | { __typename: 'ClinicTimeConfig', clinicTime?: { __typename?: 'ClinicTime', endTime: { __typename?: 'ClinicHourMinutes', hours: number, minutes: number }, startTime: { __typename?: 'ClinicHourMinutes', hours: number, minutes: number } } | null } } | null };

export type ListCardWidthConfigQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
}>;


export type ListCardWidthConfigQuery = { __typename?: 'Query', listClinicConfig: Array<{ __typename?: 'ClinicConfig', clinic_id: string, config_id: string, config_type: string, endDate?: any | null, startDate: any, created_at?: any | null, updated_at?: any | null, config: { __typename: 'CardWidthConfig', cardWidth: number } | { __typename?: 'ClinicTimeConfig' } } | null> };

export type ListClinicTimeConfigQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
}>;


export type ListClinicTimeConfigQuery = { __typename?: 'Query', listClinicConfig: Array<{ __typename?: 'ClinicConfig', clinic_id: string, config_id: string, config_type: string, endDate?: any | null, startDate: any, created_at?: any | null, config: { __typename?: 'CardWidthConfig' } | { __typename: 'ClinicTimeConfig', clinicTime?: { __typename?: 'ClinicTime', endTime: { __typename?: 'ClinicHourMinutes', hours: number, minutes: number }, startTime: { __typename?: 'ClinicHourMinutes', hours: number, minutes: number } } | null } } | null> };

export type AddClinicTimeConfigMutationVariables = Exact<{
  clinic_id: Scalars['ID'];
  config: ClinicTimeConfigInput;
  startDate: Scalars['AWSTimestamp'];
  endDate?: InputMaybe<Scalars['AWSTimestamp']>;
}>;


export type AddClinicTimeConfigMutation = { __typename?: 'Mutation', addClinicTimeConfig?: { __typename?: 'ClinicConfig', clinic_id: string, config_id: string, config_type: string, endDate?: any | null, startDate: any, created_at?: any | null, config: { __typename?: 'CardWidthConfig' } | { __typename: 'ClinicTimeConfig', clinicTime?: { __typename?: 'ClinicTime', endTime: { __typename?: 'ClinicHourMinutes', hours: number, minutes: number }, startTime: { __typename?: 'ClinicHourMinutes', hours: number, minutes: number } } | null } } | null };

export type UpdateClinicTimeConfigMutationVariables = Exact<{
  clinic_id: Scalars['ID'];
  config: ClinicTimeConfigInput;
  config_id: Scalars['ID'];
  startDate: Scalars['AWSTimestamp'];
  endDate?: InputMaybe<Scalars['AWSTimestamp']>;
}>;


export type UpdateClinicTimeConfigMutation = { __typename?: 'Mutation', updateClinicTimeConfig?: { __typename?: 'ClinicConfig', clinic_id: string, config_id: string, config_type: string, endDate?: any | null, startDate: any, created_at?: any | null, updated_at?: any | null, config: { __typename?: 'CardWidthConfig' } | { __typename: 'ClinicTimeConfig', clinicTime?: { __typename?: 'ClinicTime', endTime: { __typename?: 'ClinicHourMinutes', hours: number, minutes: number }, startTime: { __typename?: 'ClinicHourMinutes', hours: number, minutes: number } } | null } } | null };

export type DeleteClinicConfigMutationVariables = Exact<{
  clinic_id: Scalars['ID'];
  config_id: Scalars['ID'];
  config_type: Scalars['String'];
}>;


export type DeleteClinicConfigMutation = { __typename?: 'Mutation', deleteClinicConfig?: { __typename?: 'ClinicConfig', clinic_id: string, config_id: string, config_type: string, endDate?: any | null, startDate: any, created_at?: any | null, config: { __typename: 'CardWidthConfig', cardWidth: number } | { __typename: 'ClinicTimeConfig', clinicTime?: { __typename?: 'ClinicTime', endTime: { __typename?: 'ClinicHourMinutes', hours: number, minutes: number }, startTime: { __typename?: 'ClinicHourMinutes', hours: number, minutes: number } } | null } } | null };

export type ValidateBookingRuleQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
  ruleStartDate: Scalars['AWSTimestamp'];
  ruleEndDate?: InputMaybe<Scalars['AWSTimestamp']>;
  clinicStartTime: ClinicHourMinutesInput;
  clinicEndTime: ClinicHourMinutesInput;
  validationType?: InputMaybe<Scalars['String']>;
}>;


export type ValidateBookingRuleQuery = { __typename?: 'Query', validateBookingRule: { __typename?: 'IsValid', isValid: boolean } };

export type AddCardWidthConfigMutationVariables = Exact<{
  clinic_id: Scalars['ID'];
  config: CardWidthConfigInput;
  startDate: Scalars['AWSTimestamp'];
  endDate?: InputMaybe<Scalars['AWSTimestamp']>;
}>;


export type AddCardWidthConfigMutation = { __typename?: 'Mutation', addCardWidthConfig?: { __typename?: 'ClinicConfig', clinic_id: string, config_id: string, config_type: string, endDate?: any | null, startDate: any, created_at?: any | null, config: { __typename: 'CardWidthConfig', cardWidth: number } | { __typename?: 'ClinicTimeConfig' } } | null };

export type UpdateCardWidthConfigMutationVariables = Exact<{
  clinic_id: Scalars['ID'];
  config: CardWidthConfigInput;
  config_id: Scalars['ID'];
  startDate: Scalars['AWSTimestamp'];
  endDate?: InputMaybe<Scalars['AWSTimestamp']>;
}>;


export type UpdateCardWidthConfigMutation = { __typename?: 'Mutation', updateCardWidthConfig?: { __typename?: 'ClinicConfig', clinic_id: string, config_id: string, config_type: string, endDate?: any | null, startDate: any, created_at?: any | null, updated_at?: any | null, config: { __typename: 'CardWidthConfig', cardWidth: number } | { __typename?: 'ClinicTimeConfig' } } | null };

export type GetClinicScheduleByClinicIdQueryVariables = Exact<{
  clinic_id: Scalars['String'];
  clinic_schedule_id: Scalars['ID'];
}>;


export type GetClinicScheduleByClinicIdQuery = { __typename?: 'Query', getClinicScheduleByClinicId?: { __typename?: 'ClinicSchedule', clinic_id: string, clinic_schedule_id: string, rule_type: ClinicScheduleType, start_date: any, end_date?: any | null, start_time?: string | null, end_time?: string | null, day_of_week?: DayOfWeek | null, week?: Week | null, service_day?: boolean | null } | null };

export type GetActiveScheduleQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
  current_date: Scalars['AWSTimestamp'];
}>;


export type GetActiveScheduleQuery = { __typename?: 'Query', getActiveSchedule?: { __typename?: 'IsHoliday', isHoliday?: boolean | null, isBeforeDay?: boolean | null } | null };

export type GetSpecificDateRuleQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
  current_date: Scalars['AWSTimestamp'];
}>;


export type GetSpecificDateRuleQuery = { __typename?: 'Query', getSpecificDateRule?: { __typename?: 'ClinicSchedule', clinic_id: string, clinic_schedule_id: string, specific_date?: any | null, service_day?: boolean | null, start_date: any, end_date?: any | null, created_at?: any | null, updated_at?: any | null } | null };

export type ValidateScheduleRuleQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
  clinic_schedule_id: Scalars['ID'];
  rule_type: ClinicScheduleType;
  day_of_week?: InputMaybe<DayOfWeek>;
  week?: InputMaybe<Week>;
  specific_date?: InputMaybe<Scalars['AWSTimestamp']>;
  day?: InputMaybe<Scalars['Int']>;
  service_day?: InputMaybe<Scalars['Boolean']>;
  start_date: Scalars['AWSTimestamp'];
  end_date?: InputMaybe<Scalars['AWSTimestamp']>;
}>;


export type ValidateScheduleRuleQuery = { __typename?: 'Query', validateScheduleRule?: { __typename?: 'IsValid', isValid: boolean } | null };

export type ListClinicSchedulesByClinicIdQueryVariables = Exact<{
  clinic_id: Scalars['String'];
}>;


export type ListClinicSchedulesByClinicIdQuery = { __typename?: 'Query', listClinicSchedulesByClinicId: { __typename?: 'ClinicSchedules', clinic_schedules: Array<{ __typename?: 'ClinicSchedule', clinic_id: string, clinic_schedule_id: string, day_of_week?: DayOfWeek | null, end_date?: any | null, end_time?: string | null, rule_type: ClinicScheduleType, service_day?: boolean | null, start_date: any, start_time?: string | null, week?: Week | null, specific_date?: any | null, day?: number | null, created_at?: any | null, updated_at?: any | null }> } };

export type AddClinicScheduleMutationVariables = Exact<{
  input: ClinicScheduleInput;
}>;


export type AddClinicScheduleMutation = { __typename?: 'Mutation', addClinicSchedule?: { __typename?: 'ClinicSchedule', clinic_id: string, clinic_schedule_id: string, day_of_week?: DayOfWeek | null, end_date?: any | null, end_time?: string | null, rule_type: ClinicScheduleType, service_day?: boolean | null, start_date: any, start_time?: string | null, week?: Week | null, specific_date?: any | null, day?: number | null, created_at?: any | null } | null };

export type UpdateClinicScheduleMutationVariables = Exact<{
  clinic_schedule_id: Scalars['ID'];
  input: ClinicScheduleInput;
}>;


export type UpdateClinicScheduleMutation = { __typename?: 'Mutation', updateClinicSchedule?: { __typename?: 'ClinicSchedule', week?: Week | null, start_time?: string | null, start_date: any, service_day?: boolean | null, rule_type: ClinicScheduleType, end_time?: string | null, end_date?: any | null, day_of_week?: DayOfWeek | null, clinic_schedule_id: string, clinic_id: string, specific_date?: any | null, day?: number | null, updated_at?: any | null } | null };

export type DeleteClinicScheduleMutationVariables = Exact<{
  clinic_id: Scalars['String'];
  clinic_schedule_id: Scalars['ID'];
}>;


export type DeleteClinicScheduleMutation = { __typename?: 'Mutation', deleteClinicSchedule: string };

export type GetCommentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCommentQuery = { __typename?: 'Query', getComment?: { __typename?: 'Comment', comment?: string | null, id: string } | null };

export type AddCommentMutationVariables = Exact<{
  id: Scalars['ID'];
  comment: Scalars['String'];
}>;


export type AddCommentMutation = { __typename?: 'Mutation', addComment?: { __typename?: 'Comment', comment?: string | null, id: string } | null };

export type GetCommentsQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
  date: Scalars['AWSTimestamp'];
}>;


export type GetCommentsQuery = { __typename?: 'Query', getComments?: { __typename?: 'Comments', clinic_id: string, date: any, comment?: string | null, commentId?: string | null } | null };

export type AddCommentsMutationVariables = Exact<{
  clinic_id: Scalars['ID'];
  date: Scalars['AWSTimestamp'];
  comment: Scalars['String'];
}>;


export type AddCommentsMutation = { __typename?: 'Mutation', addComments?: { __typename?: 'Comments', clinic_id: string, date: any, comment?: string | null, commentId?: string | null } | null };

export type ListFacilitiesQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
}>;


export type ListFacilitiesQuery = { __typename?: 'Query', listFacilities: { __typename?: 'Facilities', Facilities: Array<{ __typename?: 'facility', id: string, name: string, status?: boolean | null, isDelete?: boolean | null, index?: number | null, clinic_id?: string | null }> } };

export type ListFacilitiesByFilterQueryVariables = Exact<{
  inputs: ListFacilitiesByFilterInput;
}>;


export type ListFacilitiesByFilterQuery = { __typename?: 'Query', listFacilitiesByFilter: { __typename?: 'Facilities', Facilities: Array<{ __typename?: 'facility', clinic_id?: string | null, id: string, name: string, status?: boolean | null, isDelete?: boolean | null, index?: number | null }> } };

export type ListFacilitieNamesQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
}>;


export type ListFacilitieNamesQuery = { __typename?: 'Query', listFacilities: { __typename?: 'Facilities', Facilities: Array<{ __typename?: 'facility', id: string, name: string, isDelete?: boolean | null }> } };

export type AddFacilityMutationVariables = Exact<{
  group_ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  name: Scalars['String'];
  status: Scalars['Boolean'];
  isDelete?: InputMaybe<Scalars['Boolean']>;
  index?: InputMaybe<Scalars['Int']>;
  clinic_id: Scalars['ID'];
}>;


export type AddFacilityMutation = { __typename?: 'Mutation', addFacility: { __typename?: 'facility', id: string, name: string, status?: boolean | null, isDelete?: boolean | null, index?: number | null, clinic_id?: string | null } };

export type DeleteFacilityMutationVariables = Exact<{
  id: Scalars['ID'];
  clinic_id: Scalars['ID'];
}>;


export type DeleteFacilityMutation = { __typename?: 'Mutation', deleteFacility: { __typename?: 'facility', id: string, clinic_id?: string | null, name: string, status?: boolean | null, isDelete?: boolean | null, index?: number | null } };

export type UpdateFacilityMutationVariables = Exact<{
  group_ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  index?: InputMaybe<Scalars['Int']>;
  clinic_id: Scalars['ID'];
}>;


export type UpdateFacilityMutation = { __typename?: 'Mutation', updateFacility: { __typename?: 'facility', clinic_id?: string | null, id: string, name: string, status?: boolean | null, isDelete?: boolean | null, index?: number | null } };

export type UpdateFacilityIdxMutationVariables = Exact<{
  inputs: UpdateFacilityIdxInput;
}>;


export type UpdateFacilityIdxMutation = { __typename?: 'Mutation', updateFacilityIdx: boolean };

export type ListFacilityGroupsQueryVariables = Exact<{
  inputs: ListFacilityGroupsInput;
}>;


export type ListFacilityGroupsQuery = { __typename?: 'Query', listFacilityGroups: { __typename?: 'FacilityGroups', FacilityGroups?: Array<{ __typename?: 'FacilityGroup', clinic_id: string, created_at?: any | null, facilityIds?: Array<string | null> | null, group_id: string, index: number, isDelete?: boolean | null, name: string, updated_at?: any | null } | null> | null } };

export type AddFacilityGroupMutationVariables = Exact<{
  inputs: AddFacilityGroupInput;
}>;


export type AddFacilityGroupMutation = { __typename?: 'Mutation', addFacilityGroup: { __typename?: 'FacilityGroup', clinic_id: string, created_at?: any | null, facilityIds?: Array<string | null> | null, group_id: string, index: number, isDelete?: boolean | null, name: string, updated_at?: any | null } };

export type UpdateFacilityGroupMutationVariables = Exact<{
  inputs: UpdateFacilityGroupInput;
}>;


export type UpdateFacilityGroupMutation = { __typename?: 'Mutation', updateFacilityGroup: { __typename?: 'FacilityGroup', clinic_id: string, created_at?: any | null, facilityIds?: Array<string | null> | null, group_id: string, index: number, isDelete?: boolean | null, name: string, updated_at?: any | null } };

export type DeleteFacilityGroupMutationVariables = Exact<{
  inputs: DeleteFacilityGroupInput;
}>;


export type DeleteFacilityGroupMutation = { __typename?: 'Mutation', deleteFacilityGroup: { __typename?: 'FacilityGroup', clinic_id: string, created_at?: any | null, facilityIds?: Array<string | null> | null, group_id: string, index: number, isDelete?: boolean | null, name: string, updated_at?: any | null } };

export type TransactDeleteGroupsMutationVariables = Exact<{
  inputs: TransactDeleteGroupsInput;
}>;


export type TransactDeleteGroupsMutation = { __typename?: 'Mutation', transactDeleteGroups: { __typename?: 'TransactReturn', TransactReturn?: boolean | null } };

export type ListFacilitiesByGroupIdsQueryVariables = Exact<{
  input: ListFacilitiesByGroupIdsInput;
}>;


export type ListFacilitiesByGroupIdsQuery = { __typename?: 'Query', listFacilitiesByGroupIds: { __typename?: 'ListFacilitiesByGroupIdsReturns', ListFacilitiesByGroupIdsReturns?: Array<{ __typename?: 'ListFacilitiesByGroupIdsReturn', group_id: string, facilities?: Array<{ __typename?: 'facility', clinic_id?: string | null, id: string, index?: number | null, isDelete?: boolean | null, name: string, status?: boolean | null } | null> | null } | null> | null } };

export type ListGroupsByFacilityIdsQueryVariables = Exact<{
  input: ListGroupsByFacilityIdsInput;
}>;


export type ListGroupsByFacilityIdsQuery = { __typename?: 'Query', listGroupsByFacilityIds: { __typename?: 'ListGroupsByFacilityIdsReturns', listGroupsByFacilityIdsReturns?: Array<{ __typename?: 'ListGroupsByFacilityIdsReturn', facility_id: string, groups?: Array<{ __typename?: 'FacilityGroup', clinic_id: string, created_at?: any | null, facilityIds?: Array<string | null> | null, group_id: string, index: number, isDelete?: boolean | null, name: string, updated_at?: any | null } | null> | null } | null> | null } };

export type GetFloorQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
  floor_id: Scalars['ID'];
}>;


export type GetFloorQuery = { __typename?: 'Query', getFloor?: { __typename?: 'Floor', clinic_id: string, floorName: string, floor_id: string, index: number, isDelete: boolean } | null };

export type ListFloorsQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
}>;


export type ListFloorsQuery = { __typename?: 'Query', listFloors: Array<{ __typename?: 'Floor', clinic_id: string, floorName: string, floor_id: string, index: number, isDelete: boolean } | null> };

export type AddFloorMutationVariables = Exact<{
  clinic_id: Scalars['ID'];
  floorName: Scalars['String'];
}>;


export type AddFloorMutation = { __typename?: 'Mutation', addFloor: { __typename?: 'Floor', clinic_id: string, floorName: string, floor_id: string, index: number, isDelete: boolean } };

export type DeleteFloorMutationVariables = Exact<{
  clinic_id: Scalars['ID'];
  floor_id: Scalars['ID'];
}>;


export type DeleteFloorMutation = { __typename?: 'Mutation', deleteFloor: boolean };

export type UpdateFloorMutationVariables = Exact<{
  clinic_id: Scalars['ID'];
  floor_id: Scalars['ID'];
  floorName?: InputMaybe<Scalars['String']>;
  index?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateFloorMutation = { __typename?: 'Mutation', updateFloor: { __typename?: 'Floor', clinic_id: string, floorName: string, floor_id: string, index: number, isDelete: boolean } };

export type UpdateFloorIdxMutationVariables = Exact<{
  clinic_id: Scalars['ID'];
  direction: Scalars['Int'];
  floor_id: Scalars['ID'];
}>;


export type UpdateFloorIdxMutation = { __typename?: 'Mutation', updateFloorIdx: boolean };

export type GetManegerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetManegerQuery = { __typename?: 'Query', getManeger: { __typename?: 'Maneger', id: string, role: string, name: string, rights: string, email: string, color?: string | null, isDelete?: boolean | null, index?: number | null } };

export type ListManegerQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
}>;


export type ListManegerQuery = { __typename?: 'Query', listManeger: { __typename?: 'Manegers', Manegers: Array<{ __typename?: 'Maneger', id: string, role: string, name: string, rights: string, email: string, color?: string | null, isDelete?: boolean | null, index?: number | null, clinic_id?: string | null }> } };

export type ListManegerNameQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
}>;


export type ListManegerNameQuery = { __typename?: 'Query', listManeger: { __typename?: 'Manegers', Manegers: Array<{ __typename?: 'Maneger', id: string, name: string, isDelete?: boolean | null, index?: number | null }> } };

export type AddManegerMutationVariables = Exact<{
  role: Scalars['String'];
  name: Scalars['String'];
  rights: Scalars['String'];
  email: Scalars['String'];
  color?: InputMaybe<Scalars['String']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  index?: InputMaybe<Scalars['Int']>;
  clinic_id: Scalars['ID'];
}>;


export type AddManegerMutation = { __typename?: 'Mutation', addManeger: { __typename?: 'Maneger', id: string, role: string, name: string, rights: string, email: string, color?: string | null, isDelete?: boolean | null, index?: number | null, clinic_id?: string | null } };

export type DeleteManegerMutationVariables = Exact<{
  id: Scalars['ID'];
  clinic_id: Scalars['ID'];
}>;


export type DeleteManegerMutation = { __typename?: 'Mutation', deleteManeger: { __typename?: 'Maneger', id: string, clinic_id?: string | null, role: string, name: string, rights: string, email: string, color?: string | null, isDelete?: boolean | null, index?: number | null } };

export type UpDateManegerMutationVariables = Exact<{
  id: Scalars['ID'];
  role?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  rights?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  index?: InputMaybe<Scalars['Int']>;
}>;


export type UpDateManegerMutation = { __typename?: 'Mutation', updateManeger: { __typename?: 'Maneger', id: string, role: string, name: string, rights: string, email: string, color?: string | null, isDelete?: boolean | null, index?: number | null } };

export type UpdateManegerColorMutationVariables = Exact<{
  id: Scalars['ID'];
  color: Scalars['String'];
}>;


export type UpdateManegerColorMutation = { __typename?: 'Mutation', updateManeger: { __typename?: 'Maneger', id: string, color?: string | null } };

export type ListCategorysQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
}>;


export type ListCategorysQuery = { __typename?: 'Query', listCategorys: { __typename?: 'Categorys', Categorys: Array<{ __typename?: 'Category', id: string, isDelete: boolean, mainCategory: string, name: string, clinic_id?: string | null } | null> } };

export type AddCategoryMutationVariables = Exact<{
  mainCategory: Scalars['String'];
  name: Scalars['String'];
  clinic_id: Scalars['ID'];
}>;


export type AddCategoryMutation = { __typename?: 'Mutation', addCategory: { __typename?: 'Category', id: string, isDelete: boolean, mainCategory: string, name: string, clinic_id?: string | null } };

export type DeleteCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCategoryMutation = { __typename?: 'Mutation', deleteCategory: { __typename?: 'Category', id: string, isDelete: boolean, mainCategory: string, name: string } };

export type UpdateCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
  mainCategory?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCategoryMutation = { __typename?: 'Mutation', updateCategory: { __typename?: 'Category', id: string, isDelete: boolean, mainCategory: string, name: string } };

export type TransactDeleteCategorysMutationVariables = Exact<{
  SDK_IDs: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type TransactDeleteCategorysMutation = { __typename?: 'Mutation', transactDeleteCategorys: { __typename?: 'TransactReturn', TransactReturn?: boolean | null } };

export type GetMenuQueryVariables = Exact<{
  SDK_ID: Scalars['ID'];
}>;


export type GetMenuQuery = { __typename?: 'Query', getMenu: { __typename?: 'Menu', SDK_ID: string, amount?: number | null, courponId?: string | null, role: string, name: string, abbreviation?: string | null, subCategoryId?: string | null, parts?: string | null, status: string, time: number, type: string, isDelete?: boolean | null, index?: number | null, isPeriodicCheckup?: boolean | null, checkupFrequency?: MedicalCheckupFrequency | null, checkupIntervalDays?: number | null } };

export type GetMenuForPhrMutationVariables = Exact<{
  SDK_ID: Scalars['ID'];
}>;


export type GetMenuForPhrMutation = { __typename?: 'Mutation', getMenu: { __typename?: 'Menu', SDK_ID: string, amount?: number | null, courponId?: string | null, role: string, name: string, abbreviation?: string | null, subCategoryId?: string | null, status: string, time: number, type: string, isDelete?: boolean | null, index?: number | null, isPeriodicCheckup?: boolean | null, checkupFrequency?: MedicalCheckupFrequency | null, checkupIntervalDays?: number | null } };

export type ListMenuQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
}>;


export type ListMenuQuery = { __typename?: 'Query', listMenu: { __typename?: 'Menus', Menus: Array<{ __typename?: 'Menu', amount?: number | null, role: string, name: string, abbreviation?: string | null, subCategoryId?: string | null, parts?: string | null, status: string, time: number, type: string, courponId?: string | null, SDK_ID: string, isDelete?: boolean | null, index?: number | null, clinic_id?: string | null, isPeriodicCheckup?: boolean | null, checkupFrequency?: MedicalCheckupFrequency | null, checkupIntervalDays?: number | null }> } };

export type ListMenuNameQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
}>;


export type ListMenuNameQuery = { __typename?: 'Query', listMenu: { __typename?: 'Menus', Menus: Array<{ __typename?: 'Menu', SDK_ID: string, name: string, abbreviation?: string | null, isDelete?: boolean | null }> } };

export type AddMenuMutationVariables = Exact<{
  amount?: InputMaybe<Scalars['Int']>;
  role: Scalars['String'];
  name: Scalars['String'];
  abbreviation?: InputMaybe<Scalars['String']>;
  subCategoryId: Scalars['ID'];
  parts?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  type: Scalars['String'];
  time?: InputMaybe<Scalars['Int']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  index?: InputMaybe<Scalars['Int']>;
  clinic_id: Scalars['ID'];
  isPeriodicCheckup?: InputMaybe<Scalars['Boolean']>;
  checkupFrequency?: InputMaybe<MedicalCheckupFrequency>;
  checkupIntervalDays?: InputMaybe<Scalars['Int']>;
}>;


export type AddMenuMutation = { __typename?: 'Mutation', addMenu: { __typename?: 'Menu', SDK_ID: string, amount?: number | null, courponId?: string | null, role: string, name: string, abbreviation?: string | null, subCategoryId?: string | null, parts?: string | null, status: string, time: number, type: string, isDelete?: boolean | null, index?: number | null, clinic_id?: string | null, isPeriodicCheckup?: boolean | null, checkupFrequency?: MedicalCheckupFrequency | null, checkupIntervalDays?: number | null } };

export type DeleteMenuMutationVariables = Exact<{
  SDK_ID: Scalars['ID'];
}>;


export type DeleteMenuMutation = { __typename?: 'Mutation', deleteMenu: { __typename?: 'Menu', SDK_ID: string, amount?: number | null, courponId?: string | null, role: string, name: string, abbreviation?: string | null, subCategoryId?: string | null, parts?: string | null, status: string, time: number, type: string, isDelete?: boolean | null, index?: number | null } };

export type BatchDeleteMenuMutationVariables = Exact<{
  SDK_IDs: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type BatchDeleteMenuMutation = { __typename?: 'Mutation', batchDeleteMenu?: { __typename?: 'Menu', SDK_ID: string, amount?: number | null, courponId?: string | null, role: string, name: string, abbreviation?: string | null, subCategoryId?: string | null, parts?: string | null, status: string, time: number, type: string, isDelete?: boolean | null, index?: number | null } | null };

export type UpDateMenuMutationVariables = Exact<{
  SDK_ID: Scalars['ID'];
  amount?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  abbreviation?: InputMaybe<Scalars['String']>;
  subCategoryId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['Int']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  index?: InputMaybe<Scalars['Int']>;
  isPeriodicCheckup?: InputMaybe<Scalars['Boolean']>;
  checkupFrequency?: InputMaybe<MedicalCheckupFrequency>;
  checkupIntervalDays?: InputMaybe<Scalars['Int']>;
}>;


export type UpDateMenuMutation = { __typename?: 'Mutation', updateMenu: { __typename?: 'Menu', SDK_ID: string, amount?: number | null, role: string, name: string, abbreviation?: string | null, subCategoryId?: string | null, status: string, time: number, type: string, isDelete?: boolean | null, index?: number | null, isPeriodicCheckup?: boolean | null, checkupFrequency?: MedicalCheckupFrequency | null, checkupIntervalDays?: number | null } };

export type TransactDeleteMenusMutationVariables = Exact<{
  SDK_IDs: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type TransactDeleteMenusMutation = { __typename?: 'Mutation', transactDeleteMenus?: { __typename?: 'TransactReturn', TransactReturn?: boolean | null } | null };

export type TransactIndexMenusMutationVariables = Exact<{
  ModifyIndexMenus: Array<ModifyIndexMenus> | ModifyIndexMenus;
}>;


export type TransactIndexMenusMutation = { __typename?: 'Mutation', transactIndexMenus?: { __typename?: 'TransactReturn', TransactReturn?: boolean | null } | null };

export type ListPeriodNotificationQueryVariables = Exact<{
  access_token: Scalars['String'];
  startDate: Scalars['AWSTimestamp'];
  endDate: Scalars['AWSTimestamp'];
}>;


export type ListPeriodNotificationQuery = { __typename?: 'Query', listPeriodNotification?: { __typename?: 'Notifications', Notifications: Array<{ __typename?: 'Notification', id: string, number: string, date: any, content: string, category: string } | null> } | null };

export type GetOrgQueryVariables = Exact<{
  org_id: Scalars['ID'];
}>;


export type GetOrgQuery = { __typename?: 'Query', getOrg: { __typename?: 'Org', org_id: string, org_label: string, org_name: string, isDelete: boolean, created_at: any, updated_at?: any | null } };

export type GetOrgLabelQueryVariables = Exact<{
  org_id: Scalars['ID'];
}>;


export type GetOrgLabelQuery = { __typename?: 'Query', getOrg: { __typename?: 'Org', org_label: string } };

export type ListPatientsByNameV2QueryVariables = Exact<{
  clinic_id: Scalars['ID'];
  name: Scalars['String'];
}>;


export type ListPatientsByNameV2Query = { __typename?: 'Query', listPatientsByNameV2?: { __typename?: 'PatientsV2', Patients: Array<{ __typename?: 'PatientV2', id?: string | null, age?: number | null, birthday?: any | null, comment?: string | null, email?: string | null, gender?: string | null, group?: string | null, invitationNumber?: string | null, remarks?: string | null, tel?: string | null, clinic_id?: string | null, from_p5g?: boolean | null, DNumber?: number | null, SNumber?: number | null, searchFull?: string | null, searchKana?: string | null, status?: string | null, address?: { __typename?: 'address', house?: string | null, post?: string | null, prefectures?: string | null } | null, kana?: { __typename?: 'Name', first?: string | null, last?: string | null } | null, name?: { __typename?: 'Name', first?: string | null, last?: string | null } | null }> } | null };

export type GetPatientByIdV2QueryVariables = Exact<{
  clinic_id: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetPatientByIdV2Query = { __typename?: 'Query', getPatientByIdV2?: { __typename?: 'PatientV2', id?: string | null, age?: number | null, birthday?: any | null, comment?: string | null, email?: string | null, gender?: string | null, group?: string | null, invitationNumber?: string | null, remarks?: string | null, tel?: string | null, clinic_id?: string | null, from_p5g?: boolean | null, DNumber?: number | null, SNumber?: number | null, searchFull?: string | null, searchKana?: string | null, status?: string | null, address?: { __typename?: 'address', house?: string | null, post?: string | null, prefectures?: string | null } | null, kana?: { __typename?: 'Name', first?: string | null, last?: string | null } | null, name?: { __typename?: 'Name', first?: string | null, last?: string | null } | null } | null };

export type GetPatientNameForAddNewAppointQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetPatientNameForAddNewAppointQuery = { __typename?: 'Query', getPatientNameByIdV2?: { __typename?: 'PatientNameV2', displayName?: string | null } | null };

export type ListPatientsV2QueryVariables = Exact<{
  clinic_id: Scalars['ID'];
}>;


export type ListPatientsV2Query = { __typename?: 'Query', listPatientsV2: { __typename?: 'PatientsV2', Patients: Array<{ __typename?: 'PatientV2', id?: string | null, age?: number | null, birthday?: any | null, comment?: string | null, email?: string | null, gender?: string | null, group?: string | null, invitationNumber?: string | null, remarks?: string | null, tel?: string | null, clinic_id?: string | null, from_p5g?: boolean | null, DNumber?: number | null, SNumber?: number | null, searchFull?: string | null, searchKana?: string | null, status?: string | null, address?: { __typename?: 'address', house?: string | null, post?: string | null, prefectures?: string | null } | null, kana?: { __typename?: 'Name', first?: string | null, last?: string | null } | null, name?: { __typename?: 'Name', first?: string | null, last?: string | null } | null }> } };

export type CheckForDuplicateCardNumbersQueryVariables = Exact<{
  inputs: CheckForDuplicateCardNumbersInput;
}>;


export type CheckForDuplicateCardNumbersQuery = { __typename?: 'Query', checkForDuplicateCardNumbers: { __typename?: 'isDuplicate', isDuplicate: boolean } };

export type ListPatientsByIdPaginatedQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
  lastEvaluatedKey?: InputMaybe<InputLastEvaluatedKey>;
  orderOption?: InputMaybe<InputOrderOption>;
  filterOption?: InputMaybe<InputFilterOption>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
}>;


export type ListPatientsByIdPaginatedQuery = { __typename?: 'Query', listPatientsByIdPaginated: { __typename?: 'PatientsV2', Patients: Array<{ __typename?: 'PatientV2', id?: string | null, age?: number | null, birthday?: any | null, comment?: string | null, email?: string | null, gender?: string | null, group?: string | null, invitationNumber?: string | null, remarks?: string | null, tel?: string | null, clinic_id?: string | null, from_p5g?: boolean | null, DNumber?: number | null, SNumber?: number | null, searchFull?: string | null, searchKana?: string | null, status?: string | null, address?: { __typename?: 'address', house?: string | null, post?: string | null, prefectures?: string | null } | null, kana?: { __typename?: 'Name', first?: string | null, last?: string | null } | null, name?: { __typename?: 'Name', first?: string | null, last?: string | null } | null }>, lastEvaluatedKey?: { __typename?: 'LastEvaluatedKey', id?: string | null, clinic_id?: string | null, clinicIdWithDeleted?: string | null, kanaName?: string | null, patientCardNumber?: number | null, phoneNumber?: string | null } | null } };

export type AddPatientByIdV2MutationVariables = Exact<{
  input: PatientInputV2;
}>;


export type AddPatientByIdV2Mutation = { __typename?: 'Mutation', addPatientByIdV2?: { __typename?: 'PatientV2', id?: string | null, age?: number | null, birthday?: any | null, comment?: string | null, email?: string | null, gender?: string | null, group?: string | null, invitationNumber?: string | null, remarks?: string | null, tel?: string | null, clinic_id?: string | null, from_p5g?: boolean | null, DNumber?: number | null, SNumber?: number | null, searchFull?: string | null, searchKana?: string | null, status?: string | null, address?: { __typename?: 'address', house?: string | null, post?: string | null, prefectures?: string | null } | null, kana?: { __typename?: 'Name', first?: string | null, last?: string | null } | null, name?: { __typename?: 'Name', first?: string | null, last?: string | null } | null } | null };

export type UpdatePatientByIdV2MutationVariables = Exact<{
  id: Scalars['ID'];
  input: PatientInputV2;
}>;


export type UpdatePatientByIdV2Mutation = { __typename?: 'Mutation', updatePatientByIdV2?: { __typename?: 'PatientV2', id?: string | null, age?: number | null, birthday?: any | null, comment?: string | null, email?: string | null, gender?: string | null, group?: string | null, invitationNumber?: string | null, remarks?: string | null, tel?: string | null, clinic_id?: string | null, from_p5g?: boolean | null, DNumber?: number | null, SNumber?: number | null, searchFull?: string | null, searchKana?: string | null, status?: string | null, address?: { __typename?: 'address', house?: string | null, post?: string | null, prefectures?: string | null } | null, kana?: { __typename?: 'Name', first?: string | null, last?: string | null } | null, name?: { __typename?: 'Name', first?: string | null, last?: string | null } | null } | null };

export type DeletePatientByIdV2MutationVariables = Exact<{
  clinic_id: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type DeletePatientByIdV2Mutation = { __typename?: 'Mutation', deletePatientByIdV2: { __typename?: 'PatientV2', id?: string | null, status?: string | null } };

export type AddPatientsFromCsvMutationVariables = Exact<{
  clinic_id: Scalars['ID'];
  csv: Scalars['String'];
}>;


export type AddPatientsFromCsvMutation = { __typename?: 'Mutation', addPatientsFromCsv?: string | null };

export type PatientFieldsV2Fragment = { __typename?: 'PatientV2', id?: string | null, age?: number | null, birthday?: any | null, comment?: string | null, email?: string | null, gender?: string | null, group?: string | null, invitationNumber?: string | null, remarks?: string | null, tel?: string | null, clinic_id?: string | null, from_p5g?: boolean | null, DNumber?: number | null, SNumber?: number | null, searchFull?: string | null, searchKana?: string | null, status?: string | null, address?: { __typename?: 'address', house?: string | null, post?: string | null, prefectures?: string | null } | null, kana?: { __typename?: 'Name', first?: string | null, last?: string | null } | null, name?: { __typename?: 'Name', first?: string | null, last?: string | null } | null };

export type ListRecallItemsQueryVariables = Exact<{
  filter?: InputMaybe<RecallFilterInput>;
}>;


export type ListRecallItemsQuery = { __typename?: 'Query', listRecallItems: Array<{ __typename?: 'Recall', id: string, clinic_id: string, patientId: string, appointId: string, medicalMenuId: string, lastTreatmentDate: any, nextDueDate: any, daysUntilDue: number, status: RecallStatus, createdAt: any, updatedAt: any, patient?: { __typename?: 'Patient', id: string, SNumber?: number | null, name?: { __typename?: 'Name', first?: string | null, last?: string | null } | null } | null, medicalMenu?: { __typename?: 'MedicalMenu', SDK_ID: string, name: string } | null } | null> };

export type ListRecallItemsByClinicQueryVariables = Exact<{
  clinic_id: Scalars['String'];
}>;


export type ListRecallItemsByClinicQuery = { __typename?: 'Query', listRecallItems: Array<{ __typename?: 'Recall', id: string, clinic_id: string, patientId: string, appointId: string, medicalMenuId: string, lastTreatmentDate: any, nextDueDate: any, daysUntilDue: number, status: RecallStatus, createdAt: any, updatedAt: any, patient?: { __typename?: 'Patient', id: string, SNumber?: number | null, name?: { __typename?: 'Name', first?: string | null, last?: string | null } | null } | null, medicalMenu?: { __typename?: 'MedicalMenu', SDK_ID: string, name: string } | null } | null> };

export type ListRecallItemsByClinicAndStatusQueryVariables = Exact<{
  clinic_id: Scalars['String'];
  status?: InputMaybe<RecallStatus>;
}>;


export type ListRecallItemsByClinicAndStatusQuery = { __typename?: 'Query', listRecallItems: Array<{ __typename?: 'Recall', id: string, clinic_id: string, patientId: string, appointId: string, medicalMenuId: string, lastTreatmentDate: any, nextDueDate: any, daysUntilDue: number, status: RecallStatus, createdAt: any, updatedAt: any, patient?: { __typename?: 'Patient', id: string, SNumber?: number | null, name?: { __typename?: 'Name', first?: string | null, last?: string | null } | null } | null, medicalMenu?: { __typename?: 'MedicalMenu', SDK_ID: string, name: string } | null } | null> };

export type GetRecallItemQueryVariables = Exact<{
  id: Scalars['ID'];
  clinic_id: Scalars['String'];
}>;


export type GetRecallItemQuery = { __typename?: 'Query', getRecallItem?: { __typename?: 'Recall', id: string, clinic_id: string, patientId: string, appointId: string, medicalMenuId: string, lastTreatmentDate: any, nextDueDate: any, daysUntilDue: number, status: RecallStatus, createdAt: any, updatedAt: any, patient?: { __typename?: 'Patient', id: string, SNumber?: number | null, name?: { __typename?: 'Name', first?: string | null, last?: string | null } | null } | null, medicalMenu?: { __typename?: 'MedicalMenu', SDK_ID: string, name: string } | null } | null };

export type ListRecallItemsByPatientQueryVariables = Exact<{
  patientId: Scalars['ID'];
  clinic_id: Scalars['String'];
}>;


export type ListRecallItemsByPatientQuery = { __typename?: 'Query', listRecallItems: Array<{ __typename?: 'Recall', id: string, clinic_id: string, medicalMenuId: string, appointId: string, lastTreatmentDate: any, nextDueDate: any, daysUntilDue: number, status: RecallStatus, createdAt: any, updatedAt: any, patient?: { __typename?: 'Patient', id: string, SNumber?: number | null, name?: { __typename?: 'Name', first?: string | null, last?: string | null } | null } | null, medicalMenu?: { __typename?: 'MedicalMenu', SDK_ID: string, name: string } | null } | null> };

export type ListUpcomingRecallItemsQueryVariables = Exact<{
  clinic_id: Scalars['String'];
  daysUntilDue?: InputMaybe<Scalars['Int']>;
}>;


export type ListUpcomingRecallItemsQuery = { __typename?: 'Query', listRecallItems: Array<{ __typename?: 'Recall', id: string, clinic_id: string, patientId: string, appointId: string, medicalMenuId: string, lastTreatmentDate: any, nextDueDate: any, daysUntilDue: number, status: RecallStatus, createdAt: any, updatedAt: any, patient?: { __typename?: 'Patient', id: string, SNumber?: number | null, name?: { __typename?: 'Name', first?: string | null, last?: string | null } | null } | null, medicalMenu?: { __typename?: 'MedicalMenu', SDK_ID: string, name: string } | null } | null> };

export type AddRecallMutationVariables = Exact<{
  input: CreateRecallInput;
}>;


export type AddRecallMutation = { __typename?: 'Mutation', addRecall: { __typename?: 'Recall', id: string, clinic_id: string, patientId: string, appointId: string, medicalMenuId: string, lastTreatmentDate: any, nextDueDate: any, daysUntilDue: number, status: RecallStatus, createdAt: any, updatedAt: any } };

export type UpdateRecallStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status: RecallStatus;
  clinic_id: Scalars['String'];
}>;


export type UpdateRecallStatusMutation = { __typename?: 'Mutation', updateRecallStatus: { __typename?: 'UpdatedRecall', id: string, status: RecallStatus, updatedAt: any } };

export type DeleteRecallMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteRecallMutation = { __typename?: 'Mutation', deleteRecall: boolean };

export type RecallFieldsFragment = { __typename?: 'Recall', id: string, clinic_id: string, patientId: string, appointId: string, medicalMenuId: string, lastTreatmentDate: any, nextDueDate: any, daysUntilDue: number, status: RecallStatus, createdAt: any, updatedAt: any, patient?: { __typename?: 'Patient', id: string, SNumber?: number | null, name?: { __typename?: 'Name', first?: string | null, last?: string | null } | null } | null, medicalMenu?: { __typename?: 'MedicalMenu', SDK_ID: string, name: string } | null };

export type ListRecallItemsByClinicPatientAndMenuQueryVariables = Exact<{
  clinic_id: Scalars['String'];
  patientId?: InputMaybe<Scalars['ID']>;
  medicalMenuId?: InputMaybe<Scalars['String']>;
}>;


export type ListRecallItemsByClinicPatientAndMenuQuery = { __typename?: 'Query', listRecallItems: Array<{ __typename?: 'Recall', id: string, status: RecallStatus, nextDueDate: any, lastTreatmentDate: any } | null> };

export type GetFormQueryVariables = Exact<{
  access_token: Scalars['String'];
}>;


export type GetFormQuery = { __typename?: 'Query', getForm?: { __typename?: 'Form', common: { __typename?: 'Common', Q1?: { __typename?: 'commonQ1', answerQ1?: string | null, diseaseQ1: string, selected_clinicQ1?: string | null, selected_medicineQ1?: string | null } | null, Q2?: { __typename?: 'commonQ2', answerQ2?: string | null, commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'commonQ3', answerQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'commonQ4', answerQ4?: string | null, selectedQ4?: Array<string | null> | null, selected_optionsQ4?: string | null } | null, Q5?: { __typename?: 'commonQ5', answerQ5?: string | null } | null, Q6?: { __typename?: 'commonQ6', answerQ6?: string | null, commentQ6?: string | null, dateQ6?: string | null, selectedQ6?: Array<string | null> | null } | null }, dental?: { __typename?: 'Dental', Q1?: { __typename?: 'dentalQ1', commentQ1?: string | null, dateQ1?: any | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'dentalQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'dentalQ3', answerQ3?: string | null, selectedQ3?: Array<string | null> | null, commentQ3?: string | null } | null, Q4?: { __typename?: 'dentalQ4', selectedQ4?: Array<string | null> | null } | null, Q5?: { __typename?: 'dentalQ5', selectedQ5?: Array<string | null> | null } | null } | null, medical?: { __typename?: 'Medical', Q1?: { __typename?: 'medicalQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'medicalQ2', bodyQ2?: Array<string | null> | null, commentQ2: string, faceQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'medicalQ3', answerQ3?: string | null, clinic_anotherQ3?: string | null, clinic_otherQ3?: string | null, clinic_salonQ3?: string | null, selected_fatDissolvingQ3?: string | null, selected_laserQ3?: string | null, selected_peelingQ3?: string | null } | null, Q4?: { __typename?: 'medicalQ4', constipationQ4?: string | null, favoriteQ4: string, selectedQ4?: Array<string | null> | null, sleepQ4?: string | null, stomachQ4?: string | null, ultravioletRaysQ4?: string | null } | null, Q5?: { __typename?: 'medicalQ5', doctorsCosmeQ5?: string | null, selectedQ5?: Array<string | null> | null, skincareItemQ5?: string | null } | null, Q6?: { __typename?: 'medicalQ6', commentQ6?: string | null, selectedQ6?: Array<string | null> | null } | null } | null, orthodontics?: { __typename?: 'Orthodontics', Q1?: { __typename?: 'orthodonticsQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q10?: { __typename?: 'orthodonticsQ10', commentQ10?: string | null, selectedQ10?: Array<string | null> | null } | null, Q2?: { __typename?: 'orthodonticsQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'orthodonticsQ3', answerQ3?: string | null, commentQ3?: string | null, dateQ3?: any | null } | null, Q4?: { __typename?: 'orthodonticsQ4', answerQ4?: string | null, dateQ4?: any | null } | null, Q5?: { __typename?: 'orthodonticsQ5', commentQ5?: string | null, dateQ5?: any | null, selectedQ5?: Array<string | null> | null } | null, Q6?: { __typename?: 'orthodonticsQ6', selectedQ6?: Array<string | null> | null } | null, Q7?: { __typename?: 'orthodonticsQ7', commentQ7?: string | null, selectedQ7?: Array<string | null> | null } | null, Q8?: { __typename?: 'orthodonticsQ8', answerQ8?: string | null } | null, Q9?: { __typename?: 'orthodonticsQ9', selectedQ9?: Array<string | null> | null } | null } | null } | null };

export type GetCommonFormByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCommonFormByIdQuery = { __typename?: 'Query', getFormById?: { __typename?: 'Form', common: { __typename?: 'Common', Q1?: { __typename?: 'commonQ1', answerQ1?: string | null, diseaseQ1: string, selected_clinicQ1?: string | null, selected_medicineQ1?: string | null } | null, Q2?: { __typename?: 'commonQ2', answerQ2?: string | null, commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'commonQ3', answerQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'commonQ4', answerQ4?: string | null, selectedQ4?: Array<string | null> | null, selected_optionsQ4?: string | null } | null, Q5?: { __typename?: 'commonQ5', answerQ5?: string | null } | null, Q6?: { __typename?: 'commonQ6', answerQ6?: string | null, commentQ6?: string | null, dateQ6?: string | null, selectedQ6?: Array<string | null> | null } | null } } | null };

export type GetMedicalFormByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetMedicalFormByIdQuery = { __typename?: 'Query', getFormById?: { __typename?: 'Form', medical?: { __typename?: 'Medical', Q1?: { __typename?: 'medicalQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'medicalQ2', bodyQ2?: Array<string | null> | null, commentQ2: string, faceQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'medicalQ3', answerQ3?: string | null, clinic_anotherQ3?: string | null, clinic_otherQ3?: string | null, clinic_salonQ3?: string | null, selectedQ3?: Array<string | null> | null, selected_fatDissolvingQ3?: string | null, selected_laserQ3?: string | null, selected_peelingQ3?: string | null } | null, Q4?: { __typename?: 'medicalQ4', commentQ4?: string | null, constipationQ4?: string | null, favoriteQ4: string, selectedQ4?: Array<string | null> | null, sleepQ4?: string | null, stomachQ4?: string | null, ultravioletRaysQ4?: string | null } | null, Q5?: { __typename?: 'medicalQ5', doctorsCosmeQ5?: string | null, selectedQ5?: Array<string | null> | null, skincareItemQ5?: string | null } | null, Q6?: { __typename?: 'medicalQ6', commentQ6?: string | null, selectedQ6?: Array<string | null> | null } | null } | null } | null };

export type GetDentalFormByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetDentalFormByIdQuery = { __typename?: 'Query', getFormById?: { __typename?: 'Form', dental?: { __typename?: 'Dental', Q1?: { __typename?: 'dentalQ1', commentQ1?: string | null, dateQ1?: any | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'dentalQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'dentalQ3', answerQ3?: string | null, commentQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'dentalQ4', selectedQ4?: Array<string | null> | null } | null, Q5?: { __typename?: 'dentalQ5', selectedQ5?: Array<string | null> | null } | null } | null } | null };

export type GetOrthodonticsFormByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetOrthodonticsFormByIdQuery = { __typename?: 'Query', getFormById?: { __typename?: 'Form', orthodontics?: { __typename?: 'Orthodontics', Q1?: { __typename?: 'orthodonticsQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'orthodonticsQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'orthodonticsQ3', answerQ3?: string | null, commentQ3?: string | null, dateQ3?: any | null } | null, Q4?: { __typename?: 'orthodonticsQ4', answerQ4?: string | null, dateQ4?: any | null } | null, Q5?: { __typename?: 'orthodonticsQ5', commentQ5?: string | null, dateQ5?: any | null, selectedQ5?: Array<string | null> | null } | null, Q6?: { __typename?: 'orthodonticsQ6', selectedQ6?: Array<string | null> | null } | null, Q7?: { __typename?: 'orthodonticsQ7', commentQ7?: string | null, selectedQ7?: Array<string | null> | null } | null, Q8?: { __typename?: 'orthodonticsQ8', answerQ8?: string | null } | null, Q9?: { __typename?: 'orthodonticsQ9', selectedQ9?: Array<string | null> | null } | null, Q10?: { __typename?: 'orthodonticsQ10', commentQ10?: string | null, selectedQ10?: Array<string | null> | null } | null } | null } | null };

export type AddCommonFormMutationVariables = Exact<{
  access_token: Scalars['String'];
  common: CommonInput;
}>;


export type AddCommonFormMutation = { __typename?: 'Mutation', addForm: { __typename?: 'Form', common: { __typename?: 'Common', Q1?: { __typename?: 'commonQ1', answerQ1?: string | null, diseaseQ1: string, selected_clinicQ1?: string | null, selected_medicineQ1?: string | null } | null, Q2?: { __typename?: 'commonQ2', answerQ2?: string | null, commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'commonQ3', answerQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'commonQ4', answerQ4?: string | null, selectedQ4?: Array<string | null> | null, selected_optionsQ4?: string | null } | null, Q5?: { __typename?: 'commonQ5', answerQ5?: string | null } | null, Q6?: { __typename?: 'commonQ6', answerQ6?: string | null, dateQ6?: string | null, commentQ6?: string | null, selectedQ6?: Array<string | null> | null } | null } } };

export type AddCommonFormByIdMutationVariables = Exact<{
  id: Scalars['ID'];
  common: CommonInput;
}>;


export type AddCommonFormByIdMutation = { __typename?: 'Mutation', addFormById: { __typename?: 'Form', common: { __typename?: 'Common', Q1?: { __typename?: 'commonQ1', answerQ1?: string | null, diseaseQ1: string, selected_clinicQ1?: string | null, selected_medicineQ1?: string | null } | null, Q2?: { __typename?: 'commonQ2', answerQ2?: string | null, commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'commonQ3', answerQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'commonQ4', answerQ4?: string | null, selectedQ4?: Array<string | null> | null, selected_optionsQ4?: string | null } | null, Q5?: { __typename?: 'commonQ5', answerQ5?: string | null } | null, Q6?: { __typename?: 'commonQ6', answerQ6?: string | null, dateQ6?: string | null, commentQ6?: string | null, selectedQ6?: Array<string | null> | null } | null } } };

export type AddDentalFormMutationVariables = Exact<{
  access_token: Scalars['String'];
  dental: DentalInput;
}>;


export type AddDentalFormMutation = { __typename?: 'Mutation', addForm: { __typename?: 'Form', dental?: { __typename?: 'Dental', Q1?: { __typename?: 'dentalQ1', commentQ1?: string | null, dateQ1?: any | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'dentalQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'dentalQ3', answerQ3?: string | null, commentQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'dentalQ4', selectedQ4?: Array<string | null> | null } | null, Q5?: { __typename?: 'dentalQ5', selectedQ5?: Array<string | null> | null } | null } | null } };

export type AddDentalFormByIdMutationVariables = Exact<{
  id: Scalars['ID'];
  dental: DentalInput;
}>;


export type AddDentalFormByIdMutation = { __typename?: 'Mutation', addFormById: { __typename?: 'Form', dental?: { __typename?: 'Dental', Q1?: { __typename?: 'dentalQ1', commentQ1?: string | null, dateQ1?: any | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'dentalQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'dentalQ3', answerQ3?: string | null, commentQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'dentalQ4', selectedQ4?: Array<string | null> | null } | null, Q5?: { __typename?: 'dentalQ5', selectedQ5?: Array<string | null> | null } | null } | null } };

export type AddMedicalFormMutationVariables = Exact<{
  access_token: Scalars['String'];
  medical: MedicalInput;
}>;


export type AddMedicalFormMutation = { __typename?: 'Mutation', addForm: { __typename?: 'Form', medical?: { __typename?: 'Medical', Q1?: { __typename?: 'medicalQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'medicalQ2', bodyQ2?: Array<string | null> | null, commentQ2: string, faceQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'medicalQ3', answerQ3?: string | null, clinic_anotherQ3?: string | null, clinic_otherQ3?: string | null, clinic_salonQ3?: string | null, selected_fatDissolvingQ3?: string | null, selected_laserQ3?: string | null, selected_peelingQ3?: string | null } | null, Q4?: { __typename?: 'medicalQ4', constipationQ4?: string | null, favoriteQ4: string, selectedQ4?: Array<string | null> | null, sleepQ4?: string | null, stomachQ4?: string | null, ultravioletRaysQ4?: string | null } | null, Q5?: { __typename?: 'medicalQ5', doctorsCosmeQ5?: string | null, selectedQ5?: Array<string | null> | null, skincareItemQ5?: string | null } | null, Q6?: { __typename?: 'medicalQ6', commentQ6?: string | null, selectedQ6?: Array<string | null> | null } | null } | null } };

export type AddMedicalFormByIdMutationVariables = Exact<{
  id: Scalars['ID'];
  medical: MedicalInput;
}>;


export type AddMedicalFormByIdMutation = { __typename?: 'Mutation', addFormById: { __typename?: 'Form', medical?: { __typename?: 'Medical', Q1?: { __typename?: 'medicalQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'medicalQ2', bodyQ2?: Array<string | null> | null, commentQ2: string, faceQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'medicalQ3', answerQ3?: string | null, clinic_anotherQ3?: string | null, clinic_otherQ3?: string | null, clinic_salonQ3?: string | null, selected_fatDissolvingQ3?: string | null, selected_laserQ3?: string | null, selected_peelingQ3?: string | null } | null, Q4?: { __typename?: 'medicalQ4', constipationQ4?: string | null, favoriteQ4: string, selectedQ4?: Array<string | null> | null, sleepQ4?: string | null, stomachQ4?: string | null, ultravioletRaysQ4?: string | null } | null, Q5?: { __typename?: 'medicalQ5', doctorsCosmeQ5?: string | null, selectedQ5?: Array<string | null> | null, skincareItemQ5?: string | null } | null, Q6?: { __typename?: 'medicalQ6', commentQ6?: string | null, selectedQ6?: Array<string | null> | null } | null } | null } };

export type AddOrthodonticsFormMutationVariables = Exact<{
  access_token: Scalars['String'];
  orthodontics: OrthodonticsInput;
}>;


export type AddOrthodonticsFormMutation = { __typename?: 'Mutation', addForm: { __typename?: 'Form', orthodontics?: { __typename?: 'Orthodontics', Q1?: { __typename?: 'orthodonticsQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'orthodonticsQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'orthodonticsQ3', answerQ3?: string | null, commentQ3?: string | null, dateQ3?: any | null } | null, Q4?: { __typename?: 'orthodonticsQ4', answerQ4?: string | null, dateQ4?: any | null } | null, Q5?: { __typename?: 'orthodonticsQ5', commentQ5?: string | null, dateQ5?: any | null, selectedQ5?: Array<string | null> | null } | null, Q6?: { __typename?: 'orthodonticsQ6', selectedQ6?: Array<string | null> | null } | null, Q7?: { __typename?: 'orthodonticsQ7', commentQ7?: string | null, selectedQ7?: Array<string | null> | null } | null, Q8?: { __typename?: 'orthodonticsQ8', answerQ8?: string | null } | null, Q9?: { __typename?: 'orthodonticsQ9', selectedQ9?: Array<string | null> | null } | null, Q10?: { __typename?: 'orthodonticsQ10', commentQ10?: string | null, selectedQ10?: Array<string | null> | null } | null } | null } };

export type AddOrthodonticsFormByIdMutationVariables = Exact<{
  id: Scalars['ID'];
  orthodontics: OrthodonticsInput;
}>;


export type AddOrthodonticsFormByIdMutation = { __typename?: 'Mutation', addFormById: { __typename?: 'Form', orthodontics?: { __typename?: 'Orthodontics', Q1?: { __typename?: 'orthodonticsQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'orthodonticsQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'orthodonticsQ3', answerQ3?: string | null, commentQ3?: string | null, dateQ3?: any | null } | null, Q4?: { __typename?: 'orthodonticsQ4', answerQ4?: string | null, dateQ4?: any | null } | null, Q5?: { __typename?: 'orthodonticsQ5', commentQ5?: string | null, dateQ5?: any | null, selectedQ5?: Array<string | null> | null } | null, Q6?: { __typename?: 'orthodonticsQ6', selectedQ6?: Array<string | null> | null } | null, Q7?: { __typename?: 'orthodonticsQ7', commentQ7?: string | null, selectedQ7?: Array<string | null> | null } | null, Q8?: { __typename?: 'orthodonticsQ8', answerQ8?: string | null } | null, Q9?: { __typename?: 'orthodonticsQ9', selectedQ9?: Array<string | null> | null } | null, Q10?: { __typename?: 'orthodonticsQ10', commentQ10?: string | null, selectedQ10?: Array<string | null> | null } | null } | null } };

export type AddFormMutationVariables = Exact<{
  access_token: Scalars['String'];
  common?: InputMaybe<CommonInput>;
  dental?: InputMaybe<DentalInput>;
  medical?: InputMaybe<MedicalInput>;
  orthodontics?: InputMaybe<OrthodonticsInput>;
}>;


export type AddFormMutation = { __typename?: 'Mutation', addForm: { __typename?: 'Form', common: { __typename?: 'Common', Q1?: { __typename?: 'commonQ1', answerQ1?: string | null, diseaseQ1: string, selected_clinicQ1?: string | null, selected_medicineQ1?: string | null } | null, Q2?: { __typename?: 'commonQ2', answerQ2?: string | null, commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'commonQ3', answerQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'commonQ4', answerQ4?: string | null, selectedQ4?: Array<string | null> | null, selected_optionsQ4?: string | null } | null, Q5?: { __typename?: 'commonQ5', answerQ5?: string | null } | null, Q6?: { __typename?: 'commonQ6', answerQ6?: string | null, commentQ6?: string | null, dateQ6?: string | null, selectedQ6?: Array<string | null> | null } | null }, dental?: { __typename?: 'Dental', Q1?: { __typename?: 'dentalQ1', commentQ1?: string | null, dateQ1?: any | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'dentalQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'dentalQ3', answerQ3?: string | null, commentQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'dentalQ4', selectedQ4?: Array<string | null> | null } | null, Q5?: { __typename?: 'dentalQ5', selectedQ5?: Array<string | null> | null } | null } | null, medical?: { __typename?: 'Medical', Q1?: { __typename?: 'medicalQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'medicalQ2', bodyQ2?: Array<string | null> | null, commentQ2: string, faceQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'medicalQ3', answerQ3?: string | null, clinic_anotherQ3?: string | null, clinic_otherQ3?: string | null, clinic_salonQ3?: string | null, selected_fatDissolvingQ3?: string | null, selected_laserQ3?: string | null, selected_peelingQ3?: string | null } | null, Q4?: { __typename?: 'medicalQ4', constipationQ4?: string | null, favoriteQ4: string, selectedQ4?: Array<string | null> | null, sleepQ4?: string | null, stomachQ4?: string | null, ultravioletRaysQ4?: string | null } | null, Q5?: { __typename?: 'medicalQ5', doctorsCosmeQ5?: string | null, selectedQ5?: Array<string | null> | null, skincareItemQ5?: string | null } | null, Q6?: { __typename?: 'medicalQ6', commentQ6?: string | null, selectedQ6?: Array<string | null> | null } | null } | null, orthodontics?: { __typename?: 'Orthodontics', Q1?: { __typename?: 'orthodonticsQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q10?: { __typename?: 'orthodonticsQ10', commentQ10?: string | null, selectedQ10?: Array<string | null> | null } | null, Q2?: { __typename?: 'orthodonticsQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'orthodonticsQ3', answerQ3?: string | null, commentQ3?: string | null, dateQ3?: any | null } | null, Q4?: { __typename?: 'orthodonticsQ4', answerQ4?: string | null, dateQ4?: any | null } | null, Q5?: { __typename?: 'orthodonticsQ5', commentQ5?: string | null, dateQ5?: any | null, selectedQ5?: Array<string | null> | null } | null, Q6?: { __typename?: 'orthodonticsQ6', selectedQ6?: Array<string | null> | null } | null, Q7?: { __typename?: 'orthodonticsQ7', commentQ7?: string | null, selectedQ7?: Array<string | null> | null } | null, Q8?: { __typename?: 'orthodonticsQ8', answerQ8?: string | null } | null, Q9?: { __typename?: 'orthodonticsQ9', selectedQ9?: Array<string | null> | null } | null } | null } };

export type AddFormByIdMutationVariables = Exact<{
  id: Scalars['ID'];
  common?: InputMaybe<CommonInput>;
  dental?: InputMaybe<DentalInput>;
  medical?: InputMaybe<MedicalInput>;
  orthodontics?: InputMaybe<OrthodonticsInput>;
}>;


export type AddFormByIdMutation = { __typename?: 'Mutation', addFormById: { __typename?: 'Form', common: { __typename?: 'Common', Q1?: { __typename?: 'commonQ1', answerQ1?: string | null, diseaseQ1: string, selected_clinicQ1?: string | null, selected_medicineQ1?: string | null } | null, Q2?: { __typename?: 'commonQ2', answerQ2?: string | null, commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'commonQ3', answerQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'commonQ4', answerQ4?: string | null, selectedQ4?: Array<string | null> | null, selected_optionsQ4?: string | null } | null, Q5?: { __typename?: 'commonQ5', answerQ5?: string | null } | null, Q6?: { __typename?: 'commonQ6', answerQ6?: string | null, commentQ6?: string | null, dateQ6?: string | null, selectedQ6?: Array<string | null> | null } | null }, dental?: { __typename?: 'Dental', Q1?: { __typename?: 'dentalQ1', commentQ1?: string | null, dateQ1?: any | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'dentalQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'dentalQ3', answerQ3?: string | null, commentQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'dentalQ4', selectedQ4?: Array<string | null> | null } | null, Q5?: { __typename?: 'dentalQ5', selectedQ5?: Array<string | null> | null } | null } | null, medical?: { __typename?: 'Medical', Q1?: { __typename?: 'medicalQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'medicalQ2', bodyQ2?: Array<string | null> | null, commentQ2: string, faceQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'medicalQ3', answerQ3?: string | null, clinic_anotherQ3?: string | null, clinic_otherQ3?: string | null, clinic_salonQ3?: string | null, selected_fatDissolvingQ3?: string | null, selected_laserQ3?: string | null, selected_peelingQ3?: string | null } | null, Q4?: { __typename?: 'medicalQ4', constipationQ4?: string | null, favoriteQ4: string, selectedQ4?: Array<string | null> | null, sleepQ4?: string | null, stomachQ4?: string | null, ultravioletRaysQ4?: string | null } | null, Q5?: { __typename?: 'medicalQ5', doctorsCosmeQ5?: string | null, selectedQ5?: Array<string | null> | null, skincareItemQ5?: string | null } | null, Q6?: { __typename?: 'medicalQ6', commentQ6?: string | null, selectedQ6?: Array<string | null> | null } | null } | null, orthodontics?: { __typename?: 'Orthodontics', Q1?: { __typename?: 'orthodonticsQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q10?: { __typename?: 'orthodonticsQ10', commentQ10?: string | null, selectedQ10?: Array<string | null> | null } | null, Q2?: { __typename?: 'orthodonticsQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'orthodonticsQ3', answerQ3?: string | null, commentQ3?: string | null, dateQ3?: any | null } | null, Q4?: { __typename?: 'orthodonticsQ4', answerQ4?: string | null, dateQ4?: any | null } | null, Q5?: { __typename?: 'orthodonticsQ5', commentQ5?: string | null, dateQ5?: any | null, selectedQ5?: Array<string | null> | null } | null, Q6?: { __typename?: 'orthodonticsQ6', selectedQ6?: Array<string | null> | null } | null, Q7?: { __typename?: 'orthodonticsQ7', commentQ7?: string | null, selectedQ7?: Array<string | null> | null } | null, Q8?: { __typename?: 'orthodonticsQ8', answerQ8?: string | null } | null, Q9?: { __typename?: 'orthodonticsQ9', selectedQ9?: Array<string | null> | null } | null } | null } };

export type DeleteFormMutationVariables = Exact<{
  access_token: Scalars['String'];
}>;


export type DeleteFormMutation = { __typename?: 'Mutation', deleteForm?: { __typename?: 'Form', common: { __typename?: 'Common', Q1?: { __typename?: 'commonQ1', answerQ1?: string | null, diseaseQ1: string, selected_clinicQ1?: string | null, selected_medicineQ1?: string | null } | null, Q2?: { __typename?: 'commonQ2', answerQ2?: string | null, commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'commonQ3', answerQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'commonQ4', answerQ4?: string | null, selectedQ4?: Array<string | null> | null, selected_optionsQ4?: string | null } | null, Q5?: { __typename?: 'commonQ5', answerQ5?: string | null } | null, Q6?: { __typename?: 'commonQ6', answerQ6?: string | null, commentQ6?: string | null, dateQ6?: string | null, selectedQ6?: Array<string | null> | null } | null }, dental?: { __typename?: 'Dental', Q1?: { __typename?: 'dentalQ1', commentQ1?: string | null, dateQ1?: any | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'dentalQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'dentalQ3', answerQ3?: string | null, commentQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'dentalQ4', selectedQ4?: Array<string | null> | null } | null, Q5?: { __typename?: 'dentalQ5', selectedQ5?: Array<string | null> | null } | null } | null, medical?: { __typename?: 'Medical', Q1?: { __typename?: 'medicalQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'medicalQ2', bodyQ2?: Array<string | null> | null, commentQ2: string, faceQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'medicalQ3', answerQ3?: string | null, clinic_anotherQ3?: string | null, clinic_otherQ3?: string | null, clinic_salonQ3?: string | null, selectedQ3?: Array<string | null> | null, selected_fatDissolvingQ3?: string | null, selected_laserQ3?: string | null, selected_peelingQ3?: string | null } | null, Q4?: { __typename?: 'medicalQ4', commentQ4?: string | null, constipationQ4?: string | null, favoriteQ4: string, selectedQ4?: Array<string | null> | null, sleepQ4?: string | null, stomachQ4?: string | null, ultravioletRaysQ4?: string | null } | null, Q5?: { __typename?: 'medicalQ5', doctorsCosmeQ5?: string | null, selectedQ5?: Array<string | null> | null, skincareItemQ5?: string | null } | null, Q6?: { __typename?: 'medicalQ6', commentQ6?: string | null, selectedQ6?: Array<string | null> | null } | null } | null, orthodontics?: { __typename?: 'Orthodontics', Q1?: { __typename?: 'orthodonticsQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q10?: { __typename?: 'orthodonticsQ10', commentQ10?: string | null, selectedQ10?: Array<string | null> | null } | null, Q2?: { __typename?: 'orthodonticsQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'orthodonticsQ3', answerQ3?: string | null, commentQ3?: string | null, dateQ3?: any | null } | null, Q4?: { __typename?: 'orthodonticsQ4', answerQ4?: string | null, dateQ4?: any | null } | null, Q5?: { __typename?: 'orthodonticsQ5', commentQ5?: string | null, dateQ5?: any | null, selectedQ5?: Array<string | null> | null } | null, Q6?: { __typename?: 'orthodonticsQ6', selectedQ6?: Array<string | null> | null } | null, Q7?: { __typename?: 'orthodonticsQ7', commentQ7?: string | null, selectedQ7?: Array<string | null> | null } | null, Q8?: { __typename?: 'orthodonticsQ8', answerQ8?: string | null } | null, Q9?: { __typename?: 'orthodonticsQ9', selectedQ9?: Array<string | null> | null } | null } | null } | null };

export type DeleteFormByIdMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteFormByIdMutation = { __typename?: 'Mutation', deleteFormById?: { __typename?: 'Form', common: { __typename?: 'Common', Q1?: { __typename?: 'commonQ1', answerQ1?: string | null, diseaseQ1: string, selected_clinicQ1?: string | null, selected_medicineQ1?: string | null } | null, Q2?: { __typename?: 'commonQ2', answerQ2?: string | null, commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'commonQ3', answerQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'commonQ4', answerQ4?: string | null, selectedQ4?: Array<string | null> | null, selected_optionsQ4?: string | null } | null, Q5?: { __typename?: 'commonQ5', answerQ5?: string | null } | null, Q6?: { __typename?: 'commonQ6', answerQ6?: string | null, commentQ6?: string | null, dateQ6?: string | null, selectedQ6?: Array<string | null> | null } | null }, dental?: { __typename?: 'Dental', Q1?: { __typename?: 'dentalQ1', commentQ1?: string | null, dateQ1?: any | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'dentalQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'dentalQ3', answerQ3?: string | null, commentQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'dentalQ4', selectedQ4?: Array<string | null> | null } | null, Q5?: { __typename?: 'dentalQ5', selectedQ5?: Array<string | null> | null } | null } | null, medical?: { __typename?: 'Medical', Q1?: { __typename?: 'medicalQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'medicalQ2', bodyQ2?: Array<string | null> | null, commentQ2: string, faceQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'medicalQ3', answerQ3?: string | null, clinic_anotherQ3?: string | null, clinic_otherQ3?: string | null, clinic_salonQ3?: string | null, selectedQ3?: Array<string | null> | null, selected_fatDissolvingQ3?: string | null, selected_laserQ3?: string | null, selected_peelingQ3?: string | null } | null, Q4?: { __typename?: 'medicalQ4', commentQ4?: string | null, constipationQ4?: string | null, favoriteQ4: string, selectedQ4?: Array<string | null> | null, sleepQ4?: string | null, stomachQ4?: string | null, ultravioletRaysQ4?: string | null } | null, Q5?: { __typename?: 'medicalQ5', doctorsCosmeQ5?: string | null, selectedQ5?: Array<string | null> | null, skincareItemQ5?: string | null } | null, Q6?: { __typename?: 'medicalQ6', commentQ6?: string | null, selectedQ6?: Array<string | null> | null } | null } | null, orthodontics?: { __typename?: 'Orthodontics', Q1?: { __typename?: 'orthodonticsQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q10?: { __typename?: 'orthodonticsQ10', commentQ10?: string | null, selectedQ10?: Array<string | null> | null } | null, Q2?: { __typename?: 'orthodonticsQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'orthodonticsQ3', answerQ3?: string | null, commentQ3?: string | null, dateQ3?: any | null } | null, Q4?: { __typename?: 'orthodonticsQ4', answerQ4?: string | null, dateQ4?: any | null } | null, Q5?: { __typename?: 'orthodonticsQ5', commentQ5?: string | null, dateQ5?: any | null, selectedQ5?: Array<string | null> | null } | null, Q6?: { __typename?: 'orthodonticsQ6', selectedQ6?: Array<string | null> | null } | null, Q7?: { __typename?: 'orthodonticsQ7', selectedQ7?: Array<string | null> | null, commentQ7?: string | null } | null, Q8?: { __typename?: 'orthodonticsQ8', answerQ8?: string | null } | null, Q9?: { __typename?: 'orthodonticsQ9', selectedQ9?: Array<string | null> | null } | null } | null } | null };

export type GetRolesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetRolesQuery = { __typename?: 'Query', getRoles: { __typename?: 'Role', id: string, name: string, status?: boolean | null } };

export type ListRolesQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
}>;


export type ListRolesQuery = { __typename?: 'Query', listRoles: { __typename?: 'Roles', Roles: Array<{ __typename?: 'Role', id: string, name: string, status?: boolean | null, clinic_id?: string | null }> } };

export type AddRolesMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
  clinic_id: Scalars['ID'];
}>;


export type AddRolesMutation = { __typename?: 'Mutation', addRoles: { __typename?: 'Role', id: string, name: string, status?: boolean | null, clinic_id?: string | null } };

export type DeleteRolesMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteRolesMutation = { __typename?: 'Mutation', deleteRoles: { __typename?: 'Role', id: string, name: string, status?: boolean | null } };

export type UpdateRolesMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateRolesMutation = { __typename?: 'Mutation', updateRoles: { __typename?: 'Role', id: string, name: string, status?: boolean | null } };

export type GetShiftQueryVariables = Exact<{
  date: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
}>;


export type GetShiftQuery = { __typename?: 'Query', getShift: { __typename?: 'Shift', id: string, date: any, name: string, shifts: Array<boolean>, workingTimes: { __typename?: 'workingTimesType', am: Array<string | null>, pm: Array<string | null> } } };

export type GetTodayShiftQueryVariables = Exact<{
  date: Scalars['AWSTimestamp'];
}>;


export type GetTodayShiftQuery = { __typename?: 'Query', getTodayShift: { __typename?: 'Shifts', Shifts: Array<{ __typename?: 'Shift', date: any, id: string, name: string, shifts: Array<boolean>, workingTimes: { __typename?: 'workingTimesType', am: Array<string | null>, pm: Array<string | null> } } | null> } };

export type GetWeeklyShiftQueryVariables = Exact<{
  id: Scalars['ID'];
  weekStart: Scalars['AWSTimestamp'];
  weekEnd: Scalars['AWSTimestamp'];
}>;


export type GetWeeklyShiftQuery = { __typename?: 'Query', getWeeklyShift: { __typename?: 'Shifts', Shifts: Array<{ __typename?: 'Shift', date: any, id: string, name: string, shifts: Array<boolean>, workingTimes: { __typename?: 'workingTimesType', am: Array<string | null>, pm: Array<string | null> } } | null> } };

export type ListShiftQueryVariables = Exact<{ [key: string]: never; }>;


export type ListShiftQuery = { __typename?: 'Query', listShift: { __typename?: 'Shifts', Shifts: Array<{ __typename?: 'Shift', date: any, id: string, name: string, shifts: Array<boolean>, workingTimes: { __typename?: 'workingTimesType', am: Array<string | null>, pm: Array<string | null> } } | null> } };

export type AddShiftMutationVariables = Exact<{
  date: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  name: Scalars['String'];
  shifts: Array<Scalars['Boolean']> | Scalars['Boolean'];
  workingTimes: WorkingTimesInput;
}>;


export type AddShiftMutation = { __typename?: 'Mutation', addShift: { __typename?: 'Shift', date: any, id: string, name: string, shifts: Array<boolean>, workingTimes: { __typename?: 'workingTimesType', pm: Array<string | null>, am: Array<string | null> } } };

export type BatchWriteShiftMutationVariables = Exact<{
  dates: Array<Scalars['AWSTimestamp']> | Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  name: Scalars['String'];
  shifts: Array<Scalars['Boolean']> | Scalars['Boolean'];
  workingTimes: WorkingTimesInput;
}>;


export type BatchWriteShiftMutation = { __typename?: 'Mutation', batchWriteShift?: { __typename?: 'Shift', date: any, id: string, name: string, shifts: Array<boolean>, workingTimes: { __typename?: 'workingTimesType', am: Array<string | null>, pm: Array<string | null> } } | null };

export type DeleteShiftMutationVariables = Exact<{
  id: Scalars['ID'];
  date: Scalars['AWSTimestamp'];
}>;


export type DeleteShiftMutation = { __typename?: 'Mutation', deleteShift: { __typename?: 'Shift', date: any, id: string, name: string, shifts: Array<boolean>, workingTimes: { __typename?: 'workingTimesType', am: Array<string | null>, pm: Array<string | null> } } };

export type UpdateShiftMutationVariables = Exact<{
  id: Scalars['ID'];
  date: Scalars['AWSTimestamp'];
  name?: InputMaybe<Scalars['String']>;
  shifts?: InputMaybe<Array<Scalars['Boolean']> | Scalars['Boolean']>;
  workingTime?: InputMaybe<WorkingTimesInput>;
}>;


export type UpdateShiftMutation = { __typename?: 'Mutation', updateShift: { __typename?: 'Shift', date: any, id: string, name: string, shifts: Array<boolean>, workingTimes: { __typename?: 'workingTimesType', am: Array<string | null>, pm: Array<string | null> } } };

export const AppointDetailsForAppointShiftFragmentFragmentDoc = `
    fragment AppointDetailsForAppointShiftFragment on AppointDetails {
  clinic_id
  id
  appointId
  appoint
  startTime
  endTime
  date
  type
  patientName
  patientKana
  patientCardNumber
  menuAbbreviation
  facilityId
  facilityName
  staffNames {
    index
    name
    color
  }
  isFirstVisiting
  receptionTime
  treatmentCompletedTime
  cancelTime
  isLate
  cancel {
    isCancel
    cancelReason
    radioCancelReason
  }
  isDubbleBooking
  remarks
  dentalFormula {
    permanent {
      leftTop
      rightTop
      leftBottom
      rightBottom
    }
    baby {
      leftTop
      rightTop
      leftBottom
      rightBottom
    }
  }
}
    `;
export const AppointDetailsForAppointListFragmentFragmentDoc = `
    fragment AppointDetailsForAppointListFragment on AppointDetails {
  clinic_id
  id
  appointId
  appoint
  startTime
  endTime
  date
  type
  patientName
  patientKana
  patientCardNumber
  patientCardNumberOptional
  menuName
  facilityName
  staffNames {
    index
    name
  }
  isFirstVisiting
  receptionTime
  treatmentCompletedTime
  cancelTime
  isLate
  cancel {
    isCancel
    cancelReason
    radioCancelReason
  }
  isDubbleBooking
  dentalFormula {
    permanent {
      leftTop
      rightTop
      leftBottom
      rightBottom
    }
    baby {
      leftTop
      rightTop
      leftBottom
      rightBottom
    }
  }
}
    `;
export const AppointDetailsForPatientInfoFragmentFragmentDoc = `
    fragment AppointDetailsForPatientInfoFragment on AppointDetails {
  clinic_id
  id
  appointId
  appoint
  startTime
  endTime
  date
  type
  patientName
  patientKana
  menuAbbreviation
  facilityName
  staffNames {
    index
    name
  }
  isFirstVisiting
  receptionTime
  treatmentCompletedTime
  cancelTime
  isLate
  cancel {
    isCancel
    cancelReason
    radioCancelReason
  }
  isDubbleBooking
  dentalFormula {
    permanent {
      leftTop
      rightTop
      leftBottom
      rightBottom
    }
    baby {
      leftTop
      rightTop
      leftBottom
      rightBottom
    }
  }
}
    `;
export const AppointV2FieldsFragmentDoc = `
    fragment AppointV2Fields on AppointV2 {
  id
  appoint
  appointId
  startTime
  endTime
  secondStartTime
  secondEndTime
  thirdStartTime
  thirdEndTime
  confirmedTime
  confirmedEndTime
  remarks
  date
  type
  menuId
  facilityId
  price
  staffIds {
    index
    id
  }
  isFirstVisiting
  receptionTime
  treatmentCompletedTime
  cancelTime
  isLate
  consultationTime
  cancel {
    isCancel
    cancelReason
    radioCancelReason
  }
  isDubbleBooking
  created_at
  updated_at
  clinic_id
  patientName
  patientKana
  patientRemarks
  menuName
  facilityName
  staffNames {
    index
    name
  }
  dentalFormula {
    permanent {
      leftTop
      rightTop
      leftBottom
      rightBottom
    }
    baby {
      leftTop
      rightTop
      leftBottom
      rightBottom
    }
  }
  isPeriodicCheckup
}
    `;
export const PatientFieldsV2FragmentDoc = `
    fragment PatientFieldsV2 on PatientV2 {
  id
  DNumber: patientCardNumberOptional
  SNumber: patientCardNumber
  age
  address {
    house
    post
    prefectures
  }
  birthday
  comment
  email
  gender
  group
  invitationNumber
  kana {
    first
    last
  }
  name {
    first
    last
  }
  remarks
  searchFull: fullName
  searchKana: kanaName
  tel
  status: isDeleted
  clinic_id
  from_p5g
}
    `;
export const RecallFieldsFragmentDoc = `
    fragment RecallFields on Recall {
  id
  clinic_id
  patientId
  appointId
  medicalMenuId
  lastTreatmentDate
  nextDueDate
  daysUntilDue
  status
  createdAt
  updatedAt
  patient {
    id
    name {
      first
      last
    }
    SNumber
  }
  medicalMenu {
    SDK_ID
    name
  }
}
    `;
export const GetPhrInfoDocument = `
    query getPHRInfo($access_token: String!, $startTime: AWSTimestamp!) {
  getPHRInfo(access_token: $access_token, startTime: $startTime) {
    date
    expires_at
    buying {
      items {
        count
        name
        price
      }
    }
    confirmed {
      cancel {
        cancelReason
        isCancel
        radioCancelReason
      }
      cancelTime
      consultationTime
      endTime
      menuId
      parts
      receptionTime
      staffIds {
        id
        index
      }
      startTime
      type
    }
    payment {
      courpon
      method
      price
      ticket {
        buy_at
        counts {
          current
          max
        }
        expires_at
        id
        name
        price
      }
    }
    phr {
      complement
      links {
        name
        url
      }
      progress {
        count
        text
      }
      related
    }
  }
}
    `;
export const useGetPhrInfoQuery = <
      TData = GetPhrInfoQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPhrInfoQueryVariables,
      options?: UseQueryOptions<GetPhrInfoQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPhrInfoQuery, TError, TData>(
      ['getPHRInfo', variables],
      fetcher<GetPhrInfoQuery, GetPhrInfoQueryVariables>(client, GetPhrInfoDocument, variables, headers),
      options
    );

useGetPhrInfoQuery.getKey = (variables: GetPhrInfoQueryVariables) => ['getPHRInfo', variables];
;

useGetPhrInfoQuery.fetcher = (client: GraphQLClient, variables: GetPhrInfoQueryVariables, headers?: RequestInit['headers']) => fetcher<GetPhrInfoQuery, GetPhrInfoQueryVariables>(client, GetPhrInfoDocument, variables, headers);
export const GetPhrInfoByIdDocument = `
    query getPHRInfoById($id: ID!, $startTime: AWSTimestamp!) {
  getPHRInfoById(id: $id, startTime: $startTime) {
    date
    id
    confirmed {
      cancel {
        cancelReason
        isCancel
        radioCancelReason
      }
      cancelTime
      consultationTime
      endTime
      menuId
      parts
      receptionTime
      staffIds {
        id
        index
      }
      startTime
      type
    }
    phr {
      complement
      links {
        name
        url
      }
      progress {
        count
        text
      }
      related
    }
    payment {
      courpon
      method
      price
    }
  }
}
    `;
export const useGetPhrInfoByIdQuery = <
      TData = GetPhrInfoByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPhrInfoByIdQueryVariables,
      options?: UseQueryOptions<GetPhrInfoByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPhrInfoByIdQuery, TError, TData>(
      ['getPHRInfoById', variables],
      fetcher<GetPhrInfoByIdQuery, GetPhrInfoByIdQueryVariables>(client, GetPhrInfoByIdDocument, variables, headers),
      options
    );

useGetPhrInfoByIdQuery.getKey = (variables: GetPhrInfoByIdQueryVariables) => ['getPHRInfoById', variables];
;

useGetPhrInfoByIdQuery.fetcher = (client: GraphQLClient, variables: GetPhrInfoByIdQueryVariables, headers?: RequestInit['headers']) => fetcher<GetPhrInfoByIdQuery, GetPhrInfoByIdQueryVariables>(client, GetPhrInfoByIdDocument, variables, headers);
export const ListPeriodPhrInfoDocument = `
    query listPeriodPHRInfo($access_token: String!, $startDate: AWSTimestamp!, $endDate: AWSTimestamp!) {
  listPeriodPHRInfo(endDate: $endDate, access_token: $access_token, startDate: $startDate) {
    PHRInfos {
      buying {
        items {
          count
          name
          price
        }
      }
      confirmed {
        cancel {
          cancelReason
          isCancel
          radioCancelReason
        }
        cancelTime
        consultationTime
        endTime
        menuId
        parts
        receptionTime
        staffIds {
          id
          index
        }
        startTime
        type
      }
      date
      expires_at
      id
      payment {
        courpon
        method
        price
        ticket {
          buy_at
          counts {
            current
            max
          }
          expires_at
          id
          name
          price
        }
      }
      phr {
        complement
        links {
          name
          url
        }
        progress {
          count
          text
        }
        related
      }
    }
  }
}
    `;
export const useListPeriodPhrInfoQuery = <
      TData = ListPeriodPhrInfoQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListPeriodPhrInfoQueryVariables,
      options?: UseQueryOptions<ListPeriodPhrInfoQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListPeriodPhrInfoQuery, TError, TData>(
      ['listPeriodPHRInfo', variables],
      fetcher<ListPeriodPhrInfoQuery, ListPeriodPhrInfoQueryVariables>(client, ListPeriodPhrInfoDocument, variables, headers),
      options
    );

useListPeriodPhrInfoQuery.getKey = (variables: ListPeriodPhrInfoQueryVariables) => ['listPeriodPHRInfo', variables];
;

useListPeriodPhrInfoQuery.fetcher = (client: GraphQLClient, variables: ListPeriodPhrInfoQueryVariables, headers?: RequestInit['headers']) => fetcher<ListPeriodPhrInfoQuery, ListPeriodPhrInfoQueryVariables>(client, ListPeriodPhrInfoDocument, variables, headers);
export const ListPeriodPhrInfoByIdDocument = `
    query listPeriodPHRInfoById($id: ID!, $startDate: AWSTimestamp!, $endDate: AWSTimestamp!) {
  listPeriodPHRInfoById(endDate: $endDate, id: $id, startDate: $startDate) {
    PHRInfos {
      confirmed {
        cancel {
          cancelReason
          isCancel
          radioCancelReason
        }
        cancelTime
        consultationTime
        endTime
        menuId
        parts
        receptionTime
        staffIds {
          id
          index
        }
        startTime
        type
      }
      phr {
        progress {
          count
        }
      }
    }
  }
}
    `;
export const useListPeriodPhrInfoByIdQuery = <
      TData = ListPeriodPhrInfoByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListPeriodPhrInfoByIdQueryVariables,
      options?: UseQueryOptions<ListPeriodPhrInfoByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListPeriodPhrInfoByIdQuery, TError, TData>(
      ['listPeriodPHRInfoById', variables],
      fetcher<ListPeriodPhrInfoByIdQuery, ListPeriodPhrInfoByIdQueryVariables>(client, ListPeriodPhrInfoByIdDocument, variables, headers),
      options
    );

useListPeriodPhrInfoByIdQuery.getKey = (variables: ListPeriodPhrInfoByIdQueryVariables) => ['listPeriodPHRInfoById', variables];
;

useListPeriodPhrInfoByIdQuery.fetcher = (client: GraphQLClient, variables: ListPeriodPhrInfoByIdQueryVariables, headers?: RequestInit['headers']) => fetcher<ListPeriodPhrInfoByIdQuery, ListPeriodPhrInfoByIdQueryVariables>(client, ListPeriodPhrInfoByIdDocument, variables, headers);
export const ListPeriodPhrInfoConfirmedDocument = `
    query listPeriodPHRInfoConfirmed($access_token: String!, $startDate: AWSTimestamp!, $endDate: AWSTimestamp!) {
  listPeriodPHRInfo(endDate: $endDate, access_token: $access_token, startDate: $startDate) {
    PHRInfos {
      id
      confirmed {
        cancel {
          cancelReason
          isCancel
          radioCancelReason
        }
        cancelTime
        consultationTime
        endTime
        menuId
        parts
        receptionTime
        staffIds {
          id
          index
        }
        startTime
        type
      }
    }
  }
}
    `;
export const useListPeriodPhrInfoConfirmedQuery = <
      TData = ListPeriodPhrInfoConfirmedQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListPeriodPhrInfoConfirmedQueryVariables,
      options?: UseQueryOptions<ListPeriodPhrInfoConfirmedQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListPeriodPhrInfoConfirmedQuery, TError, TData>(
      ['listPeriodPHRInfoConfirmed', variables],
      fetcher<ListPeriodPhrInfoConfirmedQuery, ListPeriodPhrInfoConfirmedQueryVariables>(client, ListPeriodPhrInfoConfirmedDocument, variables, headers),
      options
    );

useListPeriodPhrInfoConfirmedQuery.getKey = (variables: ListPeriodPhrInfoConfirmedQueryVariables) => ['listPeriodPHRInfoConfirmed', variables];
;

useListPeriodPhrInfoConfirmedQuery.fetcher = (client: GraphQLClient, variables: ListPeriodPhrInfoConfirmedQueryVariables, headers?: RequestInit['headers']) => fetcher<ListPeriodPhrInfoConfirmedQuery, ListPeriodPhrInfoConfirmedQueryVariables>(client, ListPeriodPhrInfoConfirmedDocument, variables, headers);
export const AddPhrInfoDocument = `
    mutation addPHRInfo($PHRInfoInput: PHRInfoInput!) {
  addPHRInfo(PHRInfoInput: $PHRInfoInput) {
    buying {
      items {
        count
        name
        price
      }
    }
    confirmed {
      cancel {
        cancelReason
        isCancel
        radioCancelReason
      }
      cancelTime
      consultationTime
      endTime
      menuId
      parts
      receptionTime
      staffIds {
        id
        index
      }
      startTime
      type
    }
    date
    expires_at
    id
    payment {
      courpon
      method
      price
      ticket {
        buy_at
        counts {
          current
          max
        }
        expires_at
        id
        name
        price
      }
    }
    phr {
      complement
      links {
        name
        url
      }
      progress {
        count
        text
      }
      related
    }
  }
}
    `;
export const useAddPhrInfoMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddPhrInfoMutation, TError, AddPhrInfoMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddPhrInfoMutation, TError, AddPhrInfoMutationVariables, TContext>(
      ['addPHRInfo'],
      (variables?: AddPhrInfoMutationVariables) => fetcher<AddPhrInfoMutation, AddPhrInfoMutationVariables>(client, AddPhrInfoDocument, variables, headers)(),
      options
    );
useAddPhrInfoMutation.fetcher = (client: GraphQLClient, variables: AddPhrInfoMutationVariables, headers?: RequestInit['headers']) => fetcher<AddPhrInfoMutation, AddPhrInfoMutationVariables>(client, AddPhrInfoDocument, variables, headers);
export const GetPhrInfoConfirmedDocument = `
    query getPHRInfoConfirmed($access_token: String!, $date: AWSTimestamp!) {
  getPHRInfo(access_token: $access_token, startTime: $date) {
    confirmed {
      cancel {
        cancelReason
        isCancel
        radioCancelReason
      }
      cancelTime
      consultationTime
      endTime
      menuId
      parts
      receptionTime
      staffIds {
        id
        index
      }
      startTime
      type
    }
  }
}
    `;
export const useGetPhrInfoConfirmedQuery = <
      TData = GetPhrInfoConfirmedQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPhrInfoConfirmedQueryVariables,
      options?: UseQueryOptions<GetPhrInfoConfirmedQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPhrInfoConfirmedQuery, TError, TData>(
      ['getPHRInfoConfirmed', variables],
      fetcher<GetPhrInfoConfirmedQuery, GetPhrInfoConfirmedQueryVariables>(client, GetPhrInfoConfirmedDocument, variables, headers),
      options
    );

useGetPhrInfoConfirmedQuery.getKey = (variables: GetPhrInfoConfirmedQueryVariables) => ['getPHRInfoConfirmed', variables];
;

useGetPhrInfoConfirmedQuery.fetcher = (client: GraphQLClient, variables: GetPhrInfoConfirmedQueryVariables, headers?: RequestInit['headers']) => fetcher<GetPhrInfoConfirmedQuery, GetPhrInfoConfirmedQueryVariables>(client, GetPhrInfoConfirmedDocument, variables, headers);
export const DeletePhrInfoConfirmedDocument = `
    mutation deletePHRInfoConfirmed($id: ID!, $date: AWSTimestamp!) {
  deletePHRInfoConfirmed(date: $date, id: $id) {
    confirmed {
      cancel {
        cancelReason
        isCancel
        radioCancelReason
      }
      cancelTime
      consultationTime
      endTime
      menuId
      parts
      receptionTime
      staffIds {
        id
        index
      }
      startTime
      type
    }
  }
}
    `;
export const useDeletePhrInfoConfirmedMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeletePhrInfoConfirmedMutation, TError, DeletePhrInfoConfirmedMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeletePhrInfoConfirmedMutation, TError, DeletePhrInfoConfirmedMutationVariables, TContext>(
      ['deletePHRInfoConfirmed'],
      (variables?: DeletePhrInfoConfirmedMutationVariables) => fetcher<DeletePhrInfoConfirmedMutation, DeletePhrInfoConfirmedMutationVariables>(client, DeletePhrInfoConfirmedDocument, variables, headers)(),
      options
    );
useDeletePhrInfoConfirmedMutation.fetcher = (client: GraphQLClient, variables: DeletePhrInfoConfirmedMutationVariables, headers?: RequestInit['headers']) => fetcher<DeletePhrInfoConfirmedMutation, DeletePhrInfoConfirmedMutationVariables>(client, DeletePhrInfoConfirmedDocument, variables, headers);
export const ScanPeriodBlockDocument = `
    query scanPeriodBlock($startTime: AWSTimestamp!, $endTime: AWSTimestamp!, $clinic_id: ID!) {
  scanPeriodBlock(startTime: $startTime, endTime: $endTime, clinic_id: $clinic_id) {
    AppointBlocks {
      id
      startTime
      endTime
      facilityId
      remarks
      color
      isNonAccepted
      isDelete
      clinic_id
    }
  }
}
    `;
export const useScanPeriodBlockQuery = <
      TData = ScanPeriodBlockQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ScanPeriodBlockQueryVariables,
      options?: UseQueryOptions<ScanPeriodBlockQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ScanPeriodBlockQuery, TError, TData>(
      ['scanPeriodBlock', variables],
      fetcher<ScanPeriodBlockQuery, ScanPeriodBlockQueryVariables>(client, ScanPeriodBlockDocument, variables, headers),
      options
    );

useScanPeriodBlockQuery.getKey = (variables: ScanPeriodBlockQueryVariables) => ['scanPeriodBlock', variables];
;

useScanPeriodBlockQuery.fetcher = (client: GraphQLClient, variables: ScanPeriodBlockQueryVariables, headers?: RequestInit['headers']) => fetcher<ScanPeriodBlockQuery, ScanPeriodBlockQueryVariables>(client, ScanPeriodBlockDocument, variables, headers);
export const AddBlockDocument = `
    mutation addBlock($startTime: AWSTimestamp!, $endTime: AWSTimestamp!, $facilityId: ID!, $remarks: String, $color: String, $clinic_id: ID!) {
  addBlock(startTime: $startTime, endTime: $endTime, facilityId: $facilityId, remarks: $remarks, color: $color, clinic_id: $clinic_id) {
    id
    startTime
    endTime
    facilityId
    remarks
    isNonAccepted
    isDelete
    clinic_id
  }
}
    `;
export const useAddBlockMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddBlockMutation, TError, AddBlockMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddBlockMutation, TError, AddBlockMutationVariables, TContext>(
      ['addBlock'],
      (variables?: AddBlockMutationVariables) => fetcher<AddBlockMutation, AddBlockMutationVariables>(client, AddBlockDocument, variables, headers)(),
      options
    );
useAddBlockMutation.fetcher = (client: GraphQLClient, variables: AddBlockMutationVariables, headers?: RequestInit['headers']) => fetcher<AddBlockMutation, AddBlockMutationVariables>(client, AddBlockDocument, variables, headers);
export const UpdateBlockDocument = `
    mutation updateBlock($baseId: ID!, $baseStartTime: AWSTimestamp!, $id: ID!, $startTime: AWSTimestamp!, $endTime: AWSTimestamp!, $facilityId: ID!, $remarks: String, $color: String, $clinic_id: ID!) {
  updateBlock(baseId: $baseId, baseStartTime: $baseStartTime, id: $id, startTime: $startTime, endTime: $endTime, facilityId: $facilityId, remarks: $remarks, color: $color, clinic_id: $clinic_id) {
    id
    startTime
    endTime
    facilityId
    remarks
    isNonAccepted
    isDelete
    clinic_id
  }
}
    `;
export const useUpdateBlockMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateBlockMutation, TError, UpdateBlockMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateBlockMutation, TError, UpdateBlockMutationVariables, TContext>(
      ['updateBlock'],
      (variables?: UpdateBlockMutationVariables) => fetcher<UpdateBlockMutation, UpdateBlockMutationVariables>(client, UpdateBlockDocument, variables, headers)(),
      options
    );
useUpdateBlockMutation.fetcher = (client: GraphQLClient, variables: UpdateBlockMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateBlockMutation, UpdateBlockMutationVariables>(client, UpdateBlockDocument, variables, headers);
export const UpdateBlockStatusDocument = `
    mutation updateBlockStatus($clinic_id: ID!, $id: ID!, $startTime: AWSTimestamp!, $endTime: AWSTimestamp!, $facilityId: ID!, $remarks: String, $color: String) {
  updateBlockStatus(clinic_id: $clinic_id, id: $id, startTime: $startTime, endTime: $endTime, facilityId: $facilityId, remarks: $remarks, color: $color) {
    clinic_id
    id
    startTime
    endTime
    facilityId
    remarks
    isNonAccepted
    isDelete
  }
}
    `;
export const useUpdateBlockStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateBlockStatusMutation, TError, UpdateBlockStatusMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateBlockStatusMutation, TError, UpdateBlockStatusMutationVariables, TContext>(
      ['updateBlockStatus'],
      (variables?: UpdateBlockStatusMutationVariables) => fetcher<UpdateBlockStatusMutation, UpdateBlockStatusMutationVariables>(client, UpdateBlockStatusDocument, variables, headers)(),
      options
    );
useUpdateBlockStatusMutation.fetcher = (client: GraphQLClient, variables: UpdateBlockStatusMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateBlockStatusMutation, UpdateBlockStatusMutationVariables>(client, UpdateBlockStatusDocument, variables, headers);
export const DeleteBlockDocument = `
    mutation deleteBlock($id: ID!, $startTime: AWSTimestamp!) {
  deleteBlock(id: $id, startTime: $startTime) {
    id
    startTime
    endTime
    facilityId
    remarks
    color
    isNonAccepted
    isDelete
  }
}
    `;
export const useDeleteBlockMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteBlockMutation, TError, DeleteBlockMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteBlockMutation, TError, DeleteBlockMutationVariables, TContext>(
      ['deleteBlock'],
      (variables?: DeleteBlockMutationVariables) => fetcher<DeleteBlockMutation, DeleteBlockMutationVariables>(client, DeleteBlockDocument, variables, headers)(),
      options
    );
useDeleteBlockMutation.fetcher = (client: GraphQLClient, variables: DeleteBlockMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteBlockMutation, DeleteBlockMutationVariables>(client, DeleteBlockDocument, variables, headers);
export const GetBlockDocument = `
    query getBlock($id: ID!, $startTime: AWSTimestamp!) {
  getBlock(id: $id, startTime: $startTime) {
    id
    startTime
    endTime
    facilityId
    remarks
    color
    isNonAccepted
    isDelete
  }
}
    `;
export const useGetBlockQuery = <
      TData = GetBlockQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetBlockQueryVariables,
      options?: UseQueryOptions<GetBlockQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetBlockQuery, TError, TData>(
      ['getBlock', variables],
      fetcher<GetBlockQuery, GetBlockQueryVariables>(client, GetBlockDocument, variables, headers),
      options
    );

useGetBlockQuery.getKey = (variables: GetBlockQueryVariables) => ['getBlock', variables];
;

useGetBlockQuery.fetcher = (client: GraphQLClient, variables: GetBlockQueryVariables, headers?: RequestInit['headers']) => fetcher<GetBlockQuery, GetBlockQueryVariables>(client, GetBlockDocument, variables, headers);
export const CheckDubbleBookingDocument = `
    mutation checkDubbleBooking($id: ID!, $date: AWSTimestamp!, $startTime: AWSTimestamp!, $endTime: AWSTimestamp!) {
  checkDubbleBooking(id: $id, date: $date, startTime: $startTime, endTime: $endTime) {
    isDubbleBooking
  }
}
    `;
export const useCheckDubbleBookingMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CheckDubbleBookingMutation, TError, CheckDubbleBookingMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CheckDubbleBookingMutation, TError, CheckDubbleBookingMutationVariables, TContext>(
      ['checkDubbleBooking'],
      (variables?: CheckDubbleBookingMutationVariables) => fetcher<CheckDubbleBookingMutation, CheckDubbleBookingMutationVariables>(client, CheckDubbleBookingDocument, variables, headers)(),
      options
    );
useCheckDubbleBookingMutation.fetcher = (client: GraphQLClient, variables: CheckDubbleBookingMutationVariables, headers?: RequestInit['headers']) => fetcher<CheckDubbleBookingMutation, CheckDubbleBookingMutationVariables>(client, CheckDubbleBookingDocument, variables, headers);
export const ChangeStatusDocument = `
    mutation changeStatus($appoint: String!, $id: ID!, $startTime: AWSTimestamp!, $receptionTime: AWSTimestamp, $cancelTime: AWSTimestamp, $consultationTime: AWSTimestamp, $cancel: CancelInput, $isLate: Boolean) {
  changeStatus(appoint: $appoint, id: $id, startTime: $startTime, receptionTime: $receptionTime, consultationTime: $consultationTime, cancelTime: $cancelTime, cancel: $cancel, isLate: $isLate) {
    appoint
    id
    startTime
    receptionTime
    consultationTime
    cancelTime
    cancel {
      isCancel
      cancelReason
      radioCancelReason
    }
    created_at
    updated_at
    isLate
  }
}
    `;
export const useChangeStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ChangeStatusMutation, TError, ChangeStatusMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ChangeStatusMutation, TError, ChangeStatusMutationVariables, TContext>(
      ['changeStatus'],
      (variables?: ChangeStatusMutationVariables) => fetcher<ChangeStatusMutation, ChangeStatusMutationVariables>(client, ChangeStatusDocument, variables, headers)(),
      options
    );
useChangeStatusMutation.fetcher = (client: GraphQLClient, variables: ChangeStatusMutationVariables, headers?: RequestInit['headers']) => fetcher<ChangeStatusMutation, ChangeStatusMutationVariables>(client, ChangeStatusDocument, variables, headers);
export const AddAppointDocument = `
    mutation addAppoint($id: ID!, $startTime: AWSTimestamp!, $endTime: AWSTimestamp!, $date: AWSTimestamp!, $appoint: String, $appointId: ID, $type: String!, $menuId: String!, $facilityId: String!, $price: Int!, $staffIds: [StaffIdInput!]!, $secondStartTime: AWSTimestamp, $secondEndTime: AWSTimestamp, $thirdStartTime: AWSTimestamp, $thirdEndTime: AWSTimestamp, $confirmedTime: AWSTimestamp, $confirmedEndTime: AWSTimestamp, $remarks: String, $isFirstVisiting: Boolean, $clinic_id: ID!, $isLate: Boolean, $dentalFormula: DentalFormulaInput) {
  addAppoint(id: $id, appointId: $appointId, startTime: $startTime, endTime: $endTime, date: $date, appoint: $appoint, type: $type, menuId: $menuId, facilityId: $facilityId, price: $price, staffIds: $staffIds, secondStartTime: $secondStartTime, secondEndTime: $secondEndTime, thirdStartTime: $thirdStartTime, thirdEndTime: $thirdEndTime, confirmedTime: $confirmedTime, confirmedEndTime: $confirmedEndTime, remarks: $remarks, isFirstVisiting: $isFirstVisiting, clinic_id: $clinic_id, isLate: $isLate, dentalFormula: $dentalFormula) {
    appoint
    appointId
    cancel {
      cancelReason
      isCancel
      radioCancelReason
    }
    cancelTime
    confirmedEndTime
    confirmedTime
    consultationTime
    date
    endTime
    facilityId
    id
    isFirstVisiting
    menuId
    price
    receptionTime
    remarks
    secondEndTime
    secondStartTime
    staffIds {
      id
      index
    }
    startTime
    thirdEndTime
    thirdStartTime
    type
    isDubbleBooking
    created_at
    updated_at
    clinic_id
    isLate
    dentalFormula {
      permanent {
        leftTop
        rightTop
        leftBottom
        rightBottom
      }
      baby {
        leftTop
        rightTop
        leftBottom
        rightBottom
      }
    }
  }
}
    `;
export const useAddAppointMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddAppointMutation, TError, AddAppointMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddAppointMutation, TError, AddAppointMutationVariables, TContext>(
      ['addAppoint'],
      (variables?: AddAppointMutationVariables) => fetcher<AddAppointMutation, AddAppointMutationVariables>(client, AddAppointDocument, variables, headers)(),
      options
    );
useAddAppointMutation.fetcher = (client: GraphQLClient, variables: AddAppointMutationVariables, headers?: RequestInit['headers']) => fetcher<AddAppointMutation, AddAppointMutationVariables>(client, AddAppointDocument, variables, headers);
export const DeleteAppointDocument = `
    mutation deleteAppoint($id: ID!, $startTime: AWSTimestamp!) {
  deleteAppoint(id: $id, startTime: $startTime) {
    appoint
    appointId
    cancel {
      cancelReason
      isCancel
      radioCancelReason
    }
    cancelTime
    confirmedEndTime
    confirmedTime
    consultationTime
    date
    endTime
    facilityId
    id
    isFirstVisiting
    menuId
    price
    receptionTime
    remarks
    secondEndTime
    secondStartTime
    staffIds {
      id
      index
    }
    startTime
    thirdEndTime
    thirdStartTime
    type
    created_at
    updated_at
  }
}
    `;
export const useDeleteAppointMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteAppointMutation, TError, DeleteAppointMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteAppointMutation, TError, DeleteAppointMutationVariables, TContext>(
      ['deleteAppoint'],
      (variables?: DeleteAppointMutationVariables) => fetcher<DeleteAppointMutation, DeleteAppointMutationVariables>(client, DeleteAppointDocument, variables, headers)(),
      options
    );
useDeleteAppointMutation.fetcher = (client: GraphQLClient, variables: DeleteAppointMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteAppointMutation, DeleteAppointMutationVariables>(client, DeleteAppointDocument, variables, headers);
export const UpdateAppointDocument = `
    mutation updateAppoint($baseId: ID!, $baseStartTime: AWSTimestamp!, $id: ID!, $startTime: AWSTimestamp!, $endTime: AWSTimestamp, $appoint: String, $appointId: ID!, $type: String, $staffIds: [StaffIdInput], $menuId: String, $facilityId: String, $price: Int, $secondStartTime: AWSTimestamp, $secondEndTime: AWSTimestamp, $thirdStartTime: AWSTimestamp, $thirdEndTime: AWSTimestamp, $confirmedTime: AWSTimestamp, $confirmedEndTime: AWSTimestamp, $remarks: String, $isFirstVisiting: Boolean, $date: AWSTimestamp!, $clinic_id: ID!, $isLate: Boolean, $dentalFormula: DentalFormulaInput) {
  updateAppoint(baseId: $baseId, baseStartTime: $baseStartTime, id: $id, startTime: $startTime, endTime: $endTime, appoint: $appoint, appointId: $appointId, type: $type, staffIds: $staffIds, menuId: $menuId, facilityId: $facilityId, price: $price, secondStartTime: $secondStartTime, secondEndTime: $secondEndTime, thirdStartTime: $thirdStartTime, thirdEndTime: $thirdEndTime, confirmedTime: $confirmedTime, confirmedEndTime: $confirmedEndTime, remarks: $remarks, isFirstVisiting: $isFirstVisiting, date: $date, clinic_id: $clinic_id, isLate: $isLate, dentalFormula: $dentalFormula) {
    appoint
    appointId
    cancel {
      cancelReason
      isCancel
      radioCancelReason
    }
    cancelTime
    confirmedEndTime
    confirmedTime
    consultationTime
    date
    endTime
    facilityId
    id
    isFirstVisiting
    menuId
    price
    receptionTime
    remarks
    secondEndTime
    secondStartTime
    staffIds {
      id
      index
    }
    startTime
    thirdEndTime
    thirdStartTime
    type
    isDubbleBooking
    created_at
    updated_at
    clinic_id
    isLate
    dentalFormula {
      permanent {
        leftTop
        rightTop
        leftBottom
        rightBottom
      }
      baby {
        leftTop
        rightTop
        leftBottom
        rightBottom
      }
    }
  }
}
    `;
export const useUpdateAppointMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateAppointMutation, TError, UpdateAppointMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateAppointMutation, TError, UpdateAppointMutationVariables, TContext>(
      ['updateAppoint'],
      (variables?: UpdateAppointMutationVariables) => fetcher<UpdateAppointMutation, UpdateAppointMutationVariables>(client, UpdateAppointDocument, variables, headers)(),
      options
    );
useUpdateAppointMutation.fetcher = (client: GraphQLClient, variables: UpdateAppointMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateAppointMutation, UpdateAppointMutationVariables>(client, UpdateAppointDocument, variables, headers);
export const UpdateAppointInfoDocument = `
    mutation updateAppointInfo($id: ID!, $startTime: AWSTimestamp!, $endTime: AWSTimestamp, $appoint: String, $appointId: ID!, $type: String, $staffIds: [StaffIdInput], $menuId: String, $facilityId: String, $price: Int, $secondStartTime: AWSTimestamp, $secondEndTime: AWSTimestamp, $thirdStartTime: AWSTimestamp, $thirdEndTime: AWSTimestamp, $confirmedTime: AWSTimestamp, $confirmedEndTime: AWSTimestamp, $remarks: String!, $isFirstVisiting: Boolean, $date: AWSTimestamp!, $clinic_id: ID!, $isLate: Boolean, $dentalFormula: DentalFormulaInput) {
  updateAppointInfo(id: $id, startTime: $startTime, endTime: $endTime, appoint: $appoint, appointId: $appointId, type: $type, staffIds: $staffIds, menuId: $menuId, facilityId: $facilityId, price: $price, secondStartTime: $secondStartTime, secondEndTime: $secondEndTime, thirdStartTime: $thirdStartTime, thirdEndTime: $thirdEndTime, confirmedTime: $confirmedTime, confirmedEndTime: $confirmedEndTime, remarks: $remarks, isFirstVisiting: $isFirstVisiting, date: $date, clinic_id: $clinic_id, isLate: $isLate, dentalFormula: $dentalFormula) {
    isDubbleBooking
    clinic_id
    appoint
    appointId
    cancel {
      cancelReason
      isCancel
    }
    cancelTime
    confirmedEndTime
    confirmedTime
    consultationTime
    date
    endTime
    facilityId
    id
    isFirstVisiting
    menuId
    price
    receptionTime
    remarks
    secondEndTime
    secondStartTime
    staffIds {
      id
      index
    }
    startTime
    thirdEndTime
    thirdStartTime
    type
    created_at
    updated_at
    isLate
    dentalFormula {
      permanent {
        leftTop
        rightTop
        leftBottom
        rightBottom
      }
      baby {
        leftTop
        rightTop
        leftBottom
        rightBottom
      }
    }
  }
}
    `;
export const useUpdateAppointInfoMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateAppointInfoMutation, TError, UpdateAppointInfoMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateAppointInfoMutation, TError, UpdateAppointInfoMutationVariables, TContext>(
      ['updateAppointInfo'],
      (variables?: UpdateAppointInfoMutationVariables) => fetcher<UpdateAppointInfoMutation, UpdateAppointInfoMutationVariables>(client, UpdateAppointInfoDocument, variables, headers)(),
      options
    );
useUpdateAppointInfoMutation.fetcher = (client: GraphQLClient, variables: UpdateAppointInfoMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateAppointInfoMutation, UpdateAppointInfoMutationVariables>(client, UpdateAppointInfoDocument, variables, headers);
export const GetAppointDocument = `
    query getAppoint($id: ID!, $startTime: AWSTimestamp!) {
  getAppoint(id: $id, startTime: $startTime) {
    appoint
    appointId
    cancel {
      cancelReason
      isCancel
      radioCancelReason
    }
    cancelTime
    confirmedEndTime
    confirmedTime
    consultationTime
    date
    endTime
    facilityId
    id
    isFirstVisiting
    menuId
    price
    receptionTime
    remarks
    secondEndTime
    secondStartTime
    staffIds {
      id
      index
    }
    startTime
    thirdEndTime
    thirdStartTime
    type
    created_at
    updated_at
    isLate
  }
}
    `;
export const useGetAppointQuery = <
      TData = GetAppointQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAppointQueryVariables,
      options?: UseQueryOptions<GetAppointQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAppointQuery, TError, TData>(
      ['getAppoint', variables],
      fetcher<GetAppointQuery, GetAppointQueryVariables>(client, GetAppointDocument, variables, headers),
      options
    );

useGetAppointQuery.getKey = (variables: GetAppointQueryVariables) => ['getAppoint', variables];
;

useGetAppointQuery.fetcher = (client: GraphQLClient, variables: GetAppointQueryVariables, headers?: RequestInit['headers']) => fetcher<GetAppointQuery, GetAppointQueryVariables>(client, GetAppointDocument, variables, headers);
export const ListPeriodAppointDocument = `
    query listPeriodAppoint($access_token: String!, $startDate: AWSTimestamp!, $endDate: AWSTimestamp!) {
  listPeriodAppoint(endDate: $endDate, access_token: $access_token, startDate: $startDate) {
    Appoints {
      cancel {
        cancelReason
        isCancel
        radioCancelReason
      }
      appointId
      appoint
      cancelTime
      confirmedEndTime
      confirmedTime
      consultationTime
      date
      endTime
      facilityId
      id
      isFirstVisiting
      menuId
      price
      receptionTime
      remarks
      secondEndTime
      secondStartTime
      staffIds {
        id
        index
      }
      startTime
      thirdEndTime
      thirdStartTime
      type
      created_at
      updated_at
      isLate
    }
  }
}
    `;
export const useListPeriodAppointQuery = <
      TData = ListPeriodAppointQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListPeriodAppointQueryVariables,
      options?: UseQueryOptions<ListPeriodAppointQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListPeriodAppointQuery, TError, TData>(
      ['listPeriodAppoint', variables],
      fetcher<ListPeriodAppointQuery, ListPeriodAppointQueryVariables>(client, ListPeriodAppointDocument, variables, headers),
      options
    );

useListPeriodAppointQuery.getKey = (variables: ListPeriodAppointQueryVariables) => ['listPeriodAppoint', variables];
;

useListPeriodAppointQuery.fetcher = (client: GraphQLClient, variables: ListPeriodAppointQueryVariables, headers?: RequestInit['headers']) => fetcher<ListPeriodAppointQuery, ListPeriodAppointQueryVariables>(client, ListPeriodAppointDocument, variables, headers);
export const ListPeriodAppointByIdDocument = `
    query listPeriodAppointById($id: ID!, $startDate: AWSTimestamp!, $endDate: AWSTimestamp!) {
  listPeriodAppointById(endDate: $endDate, id: $id, startDate: $startDate) {
    Appoints {
      appoint
      appointId
      cancel {
        cancelReason
        isCancel
        radioCancelReason
      }
      cancelTime
      confirmedEndTime
      confirmedTime
      consultationTime
      date
      endTime
      facilityId
      id
      isFirstVisiting
      menuId
      price
      receptionTime
      remarks
      secondEndTime
      secondStartTime
      staffIds {
        id
        index
      }
      startTime
      thirdEndTime
      thirdStartTime
      type
      created_at
      updated_at
      isLate
    }
  }
}
    `;
export const useListPeriodAppointByIdQuery = <
      TData = ListPeriodAppointByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListPeriodAppointByIdQueryVariables,
      options?: UseQueryOptions<ListPeriodAppointByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListPeriodAppointByIdQuery, TError, TData>(
      ['listPeriodAppointById', variables],
      fetcher<ListPeriodAppointByIdQuery, ListPeriodAppointByIdQueryVariables>(client, ListPeriodAppointByIdDocument, variables, headers),
      options
    );

useListPeriodAppointByIdQuery.getKey = (variables: ListPeriodAppointByIdQueryVariables) => ['listPeriodAppointById', variables];
;

useListPeriodAppointByIdQuery.fetcher = (client: GraphQLClient, variables: ListPeriodAppointByIdQueryVariables, headers?: RequestInit['headers']) => fetcher<ListPeriodAppointByIdQuery, ListPeriodAppointByIdQueryVariables>(client, ListPeriodAppointByIdDocument, variables, headers);
export const ListAppointByIdDocument = `
    query listAppointById($id: ID!) {
  listAppointById(id: $id) {
    Appoints {
      appoint
      appointId
      cancel {
        cancelReason
        isCancel
        radioCancelReason
      }
      cancelTime
      confirmedEndTime
      confirmedTime
      consultationTime
      date
      endTime
      facilityId
      id
      isFirstVisiting
      menuId
      price
      receptionTime
      remarks
      secondEndTime
      secondStartTime
      staffIds {
        id
        index
      }
      startTime
      thirdEndTime
      thirdStartTime
      type
      created_at
      updated_at
      isLate
    }
  }
}
    `;
export const useListAppointByIdQuery = <
      TData = ListAppointByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListAppointByIdQueryVariables,
      options?: UseQueryOptions<ListAppointByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListAppointByIdQuery, TError, TData>(
      ['listAppointById', variables],
      fetcher<ListAppointByIdQuery, ListAppointByIdQueryVariables>(client, ListAppointByIdDocument, variables, headers),
      options
    );

useListAppointByIdQuery.getKey = (variables: ListAppointByIdQueryVariables) => ['listAppointById', variables];
;

useListAppointByIdQuery.fetcher = (client: GraphQLClient, variables: ListAppointByIdQueryVariables, headers?: RequestInit['headers']) => fetcher<ListAppointByIdQuery, ListAppointByIdQueryVariables>(client, ListAppointByIdDocument, variables, headers);
export const ListTodayAppointDocument = `
    query listTodayAppoint($date: AWSTimestamp!, $choice: Int) {
  listTodayAppoint(date: $date, choice: $choice) {
    Appoints {
      appoint
      appointId
      cancel {
        cancelReason
        isCancel
        radioCancelReason
      }
      cancelTime
      confirmedEndTime
      confirmedTime
      consultationTime
      date
      endTime
      facilityId
      id
      isFirstVisiting
      menuId
      price
      receptionTime
      remarks
      secondEndTime
      secondStartTime
      staffIds {
        id
        index
      }
      startTime
      thirdEndTime
      thirdStartTime
      type
      created_at
      updated_at
      isLate
    }
  }
}
    `;
export const useListTodayAppointQuery = <
      TData = ListTodayAppointQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListTodayAppointQueryVariables,
      options?: UseQueryOptions<ListTodayAppointQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListTodayAppointQuery, TError, TData>(
      ['listTodayAppoint', variables],
      fetcher<ListTodayAppointQuery, ListTodayAppointQueryVariables>(client, ListTodayAppointDocument, variables, headers),
      options
    );

useListTodayAppointQuery.getKey = (variables: ListTodayAppointQueryVariables) => ['listTodayAppoint', variables];
;

useListTodayAppointQuery.fetcher = (client: GraphQLClient, variables: ListTodayAppointQueryVariables, headers?: RequestInit['headers']) => fetcher<ListTodayAppointQuery, ListTodayAppointQueryVariables>(client, ListTodayAppointDocument, variables, headers);
export const ScanPeriodAppointDocument = `
    query scanPeriodAppoint($startDate: AWSTimestamp!, $endDate: AWSTimestamp!, $clinic_id: ID!) {
  scanPeriodAppoint(endDate: $endDate, startDate: $startDate, clinic_id: $clinic_id) {
    Appoints {
      appoint
      appointId
      cancel {
        cancelReason
        isCancel
        radioCancelReason
      }
      cancelTime
      confirmedEndTime
      confirmedTime
      consultationTime
      date
      endTime
      facilityId
      id
      isFirstVisiting
      menuId
      price
      receptionTime
      remarks
      staffIds {
        id
        index
      }
      startTime
      type
      created_at
      updated_at
      clinic_id
      isLate
    }
  }
}
    `;
export const useScanPeriodAppointQuery = <
      TData = ScanPeriodAppointQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ScanPeriodAppointQueryVariables,
      options?: UseQueryOptions<ScanPeriodAppointQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ScanPeriodAppointQuery, TError, TData>(
      ['scanPeriodAppoint', variables],
      fetcher<ScanPeriodAppointQuery, ScanPeriodAppointQueryVariables>(client, ScanPeriodAppointDocument, variables, headers),
      options
    );

useScanPeriodAppointQuery.getKey = (variables: ScanPeriodAppointQueryVariables) => ['scanPeriodAppoint', variables];
;

useScanPeriodAppointQuery.fetcher = (client: GraphQLClient, variables: ScanPeriodAppointQueryVariables, headers?: RequestInit['headers']) => fetcher<ScanPeriodAppointQuery, ScanPeriodAppointQueryVariables>(client, ScanPeriodAppointDocument, variables, headers);
export const CheckLastUpdateDocument = `
    query checkLastUpdate($id: ID!, $startTime: AWSTimestamp!, $beforeUpdated_at: AWSTimestamp!, $appointId: ID!) {
  checkLastUpdate(id: $id, startTime: $startTime, beforeUpdated_at: $beforeUpdated_at, appointId: $appointId) {
    id
    startTime
    appointId
    created_at
    updated_at
    isUpdated
  }
}
    `;
export const useCheckLastUpdateQuery = <
      TData = CheckLastUpdateQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CheckLastUpdateQueryVariables,
      options?: UseQueryOptions<CheckLastUpdateQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CheckLastUpdateQuery, TError, TData>(
      ['checkLastUpdate', variables],
      fetcher<CheckLastUpdateQuery, CheckLastUpdateQueryVariables>(client, CheckLastUpdateDocument, variables, headers),
      options
    );

useCheckLastUpdateQuery.getKey = (variables: CheckLastUpdateQueryVariables) => ['checkLastUpdate', variables];
;

useCheckLastUpdateQuery.fetcher = (client: GraphQLClient, variables: CheckLastUpdateQueryVariables, headers?: RequestInit['headers']) => fetcher<CheckLastUpdateQuery, CheckLastUpdateQueryVariables>(client, CheckLastUpdateDocument, variables, headers);
export const CheckAppointConfrictDocument = `
    query CheckAppointConfrict($inputs: AppointInput!) {
  checkAppointConfrict(inputs: $inputs) {
    isNonAccepted
    isTimeConfrict
    isDoubleBooking
    isStaffDoubleBooking
    duplicatedStaffIdsWithFacility {
      facilityId
      staffIds
    }
  }
}
    `;
export const useCheckAppointConfrictQuery = <
      TData = CheckAppointConfrictQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CheckAppointConfrictQueryVariables,
      options?: UseQueryOptions<CheckAppointConfrictQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CheckAppointConfrictQuery, TError, TData>(
      ['CheckAppointConfrict', variables],
      fetcher<CheckAppointConfrictQuery, CheckAppointConfrictQueryVariables>(client, CheckAppointConfrictDocument, variables, headers),
      options
    );

useCheckAppointConfrictQuery.getKey = (variables: CheckAppointConfrictQueryVariables) => ['CheckAppointConfrict', variables];
;

useCheckAppointConfrictQuery.fetcher = (client: GraphQLClient, variables: CheckAppointConfrictQueryVariables, headers?: RequestInit['headers']) => fetcher<CheckAppointConfrictQuery, CheckAppointConfrictQueryVariables>(client, CheckAppointConfrictDocument, variables, headers);
export const ListAppointForAppointListDocument = `
    query listAppointForAppointList($inputs: listAppointDetailsInputs!) {
  listAppointDetails(inputs: $inputs) {
    ...AppointDetailsForAppointListFragment
  }
}
    ${AppointDetailsForAppointListFragmentFragmentDoc}`;
export const useListAppointForAppointListQuery = <
      TData = ListAppointForAppointListQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListAppointForAppointListQueryVariables,
      options?: UseQueryOptions<ListAppointForAppointListQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListAppointForAppointListQuery, TError, TData>(
      ['listAppointForAppointList', variables],
      fetcher<ListAppointForAppointListQuery, ListAppointForAppointListQueryVariables>(client, ListAppointForAppointListDocument, variables, headers),
      options
    );

useListAppointForAppointListQuery.getKey = (variables: ListAppointForAppointListQueryVariables) => ['listAppointForAppointList', variables];
;

useListAppointForAppointListQuery.fetcher = (client: GraphQLClient, variables: ListAppointForAppointListQueryVariables, headers?: RequestInit['headers']) => fetcher<ListAppointForAppointListQuery, ListAppointForAppointListQueryVariables>(client, ListAppointForAppointListDocument, variables, headers);
export const ListAppointForAppointShiftDocument = `
    query listAppointForAppointShift($inputs: listAppointDetailsInputs!) {
  listAppointDetails(inputs: $inputs) {
    ...AppointDetailsForAppointShiftFragment
  }
}
    ${AppointDetailsForAppointShiftFragmentFragmentDoc}`;
export const useListAppointForAppointShiftQuery = <
      TData = ListAppointForAppointShiftQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListAppointForAppointShiftQueryVariables,
      options?: UseQueryOptions<ListAppointForAppointShiftQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListAppointForAppointShiftQuery, TError, TData>(
      ['listAppointForAppointShift', variables],
      fetcher<ListAppointForAppointShiftQuery, ListAppointForAppointShiftQueryVariables>(client, ListAppointForAppointShiftDocument, variables, headers),
      options
    );

useListAppointForAppointShiftQuery.getKey = (variables: ListAppointForAppointShiftQueryVariables) => ['listAppointForAppointShift', variables];
;

useListAppointForAppointShiftQuery.fetcher = (client: GraphQLClient, variables: ListAppointForAppointShiftQueryVariables, headers?: RequestInit['headers']) => fetcher<ListAppointForAppointShiftQuery, ListAppointForAppointShiftQueryVariables>(client, ListAppointForAppointShiftDocument, variables, headers);
export const ListAppointForPatientInfoDocument = `
    query listAppointForPatientInfo($inputs: listAppointDetailsByIdInputs!) {
  listAppointDetailsById(inputs: $inputs) {
    ...AppointDetailsForPatientInfoFragment
  }
}
    ${AppointDetailsForPatientInfoFragmentFragmentDoc}`;
export const useListAppointForPatientInfoQuery = <
      TData = ListAppointForPatientInfoQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListAppointForPatientInfoQueryVariables,
      options?: UseQueryOptions<ListAppointForPatientInfoQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListAppointForPatientInfoQuery, TError, TData>(
      ['listAppointForPatientInfo', variables],
      fetcher<ListAppointForPatientInfoQuery, ListAppointForPatientInfoQueryVariables>(client, ListAppointForPatientInfoDocument, variables, headers),
      options
    );

useListAppointForPatientInfoQuery.getKey = (variables: ListAppointForPatientInfoQueryVariables) => ['listAppointForPatientInfo', variables];
;

useListAppointForPatientInfoQuery.fetcher = (client: GraphQLClient, variables: ListAppointForPatientInfoQueryVariables, headers?: RequestInit['headers']) => fetcher<ListAppointForPatientInfoQuery, ListAppointForPatientInfoQueryVariables>(client, ListAppointForPatientInfoDocument, variables, headers);
export const GetAppointByIdV2Document = `
    query getAppointByIdV2($clinic_id: ID!, $id: ID!, $startTime: AWSTimestamp!) {
  getAppointByIdV2(clinic_id: $clinic_id, id: $id, startTime: $startTime) {
    ...AppointV2Fields
  }
}
    ${AppointV2FieldsFragmentDoc}`;
export const useGetAppointByIdV2Query = <
      TData = GetAppointByIdV2Query,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAppointByIdV2QueryVariables,
      options?: UseQueryOptions<GetAppointByIdV2Query, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAppointByIdV2Query, TError, TData>(
      ['getAppointByIdV2', variables],
      fetcher<GetAppointByIdV2Query, GetAppointByIdV2QueryVariables>(client, GetAppointByIdV2Document, variables, headers),
      options
    );

useGetAppointByIdV2Query.getKey = (variables: GetAppointByIdV2QueryVariables) => ['getAppointByIdV2', variables];
;

useGetAppointByIdV2Query.fetcher = (client: GraphQLClient, variables: GetAppointByIdV2QueryVariables, headers?: RequestInit['headers']) => fetcher<GetAppointByIdV2Query, GetAppointByIdV2QueryVariables>(client, GetAppointByIdV2Document, variables, headers);
export const ListAppointByIdV2Document = `
    query listAppointByIdV2($clinic_id: ID!, $id: ID!) {
  listAppointByIdV2(clinic_id: $clinic_id, id: $id) {
    Appoints {
      ...AppointV2Fields
    }
  }
}
    ${AppointV2FieldsFragmentDoc}`;
export const useListAppointByIdV2Query = <
      TData = ListAppointByIdV2Query,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListAppointByIdV2QueryVariables,
      options?: UseQueryOptions<ListAppointByIdV2Query, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListAppointByIdV2Query, TError, TData>(
      ['listAppointByIdV2', variables],
      fetcher<ListAppointByIdV2Query, ListAppointByIdV2QueryVariables>(client, ListAppointByIdV2Document, variables, headers),
      options
    );

useListAppointByIdV2Query.getKey = (variables: ListAppointByIdV2QueryVariables) => ['listAppointByIdV2', variables];
;

useListAppointByIdV2Query.fetcher = (client: GraphQLClient, variables: ListAppointByIdV2QueryVariables, headers?: RequestInit['headers']) => fetcher<ListAppointByIdV2Query, ListAppointByIdV2QueryVariables>(client, ListAppointByIdV2Document, variables, headers);
export const GetClinicDocument = `
    query getClinic($org_id: ID!, $clinic_id: ID!) {
  getClinic(org_id: $org_id, clinic_id: $clinic_id) {
    org_id
    clinic_id
    clinic_label
    clinic_name
    isDelete
    created_at
    updated_at
  }
}
    `;
export const useGetClinicQuery = <
      TData = GetClinicQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetClinicQueryVariables,
      options?: UseQueryOptions<GetClinicQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetClinicQuery, TError, TData>(
      ['getClinic', variables],
      fetcher<GetClinicQuery, GetClinicQueryVariables>(client, GetClinicDocument, variables, headers),
      options
    );

useGetClinicQuery.getKey = (variables: GetClinicQueryVariables) => ['getClinic', variables];
;

useGetClinicQuery.fetcher = (client: GraphQLClient, variables: GetClinicQueryVariables, headers?: RequestInit['headers']) => fetcher<GetClinicQuery, GetClinicQueryVariables>(client, GetClinicDocument, variables, headers);
export const GetClinicLabelDocument = `
    query getClinicLabel($org_id: ID!, $clinic_id: ID!) {
  getClinic(org_id: $org_id, clinic_id: $clinic_id) {
    clinic_label
  }
}
    `;
export const useGetClinicLabelQuery = <
      TData = GetClinicLabelQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetClinicLabelQueryVariables,
      options?: UseQueryOptions<GetClinicLabelQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetClinicLabelQuery, TError, TData>(
      ['getClinicLabel', variables],
      fetcher<GetClinicLabelQuery, GetClinicLabelQueryVariables>(client, GetClinicLabelDocument, variables, headers),
      options
    );

useGetClinicLabelQuery.getKey = (variables: GetClinicLabelQueryVariables) => ['getClinicLabel', variables];
;

useGetClinicLabelQuery.fetcher = (client: GraphQLClient, variables: GetClinicLabelQueryVariables, headers?: RequestInit['headers']) => fetcher<GetClinicLabelQuery, GetClinicLabelQueryVariables>(client, GetClinicLabelDocument, variables, headers);
export const ListClinicsDocument = `
    query listClinics {
  listClinics {
    clinics {
      org_id
      clinic_id
      clinic_label
      clinic_name
      isDelete
      created_at
      updated_at
    }
  }
}
    `;
export const useListClinicsQuery = <
      TData = ListClinicsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ListClinicsQueryVariables,
      options?: UseQueryOptions<ListClinicsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListClinicsQuery, TError, TData>(
      variables === undefined ? ['listClinics'] : ['listClinics', variables],
      fetcher<ListClinicsQuery, ListClinicsQueryVariables>(client, ListClinicsDocument, variables, headers),
      options
    );

useListClinicsQuery.getKey = (variables?: ListClinicsQueryVariables) => variables === undefined ? ['listClinics'] : ['listClinics', variables];
;

useListClinicsQuery.fetcher = (client: GraphQLClient, variables?: ListClinicsQueryVariables, headers?: RequestInit['headers']) => fetcher<ListClinicsQuery, ListClinicsQueryVariables>(client, ListClinicsDocument, variables, headers);
export const GetLatestClinicConfigDocument = `
    query getLatestClinicConfig($clinic_id: ID!, $current_date: AWSTimestamp!, $config_type: String!) {
  getLatestClinicConfig(clinic_id: $clinic_id, current_date: $current_date, config_type: $config_type) {
    clinic_id
    config {
      ... on ClinicTimeConfig {
        __typename
        clinicTime {
          endTime {
            hours
            minutes
          }
          startTime {
            hours
            minutes
          }
        }
      }
      ... on CardWidthConfig {
        __typename
        cardWidth
      }
    }
    config_id
    config_type
    endDate
    startDate
    created_at
  }
}
    `;
export const useGetLatestClinicConfigQuery = <
      TData = GetLatestClinicConfigQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetLatestClinicConfigQueryVariables,
      options?: UseQueryOptions<GetLatestClinicConfigQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetLatestClinicConfigQuery, TError, TData>(
      ['getLatestClinicConfig', variables],
      fetcher<GetLatestClinicConfigQuery, GetLatestClinicConfigQueryVariables>(client, GetLatestClinicConfigDocument, variables, headers),
      options
    );

useGetLatestClinicConfigQuery.getKey = (variables: GetLatestClinicConfigQueryVariables) => ['getLatestClinicConfig', variables];
;

useGetLatestClinicConfigQuery.fetcher = (client: GraphQLClient, variables: GetLatestClinicConfigQueryVariables, headers?: RequestInit['headers']) => fetcher<GetLatestClinicConfigQuery, GetLatestClinicConfigQueryVariables>(client, GetLatestClinicConfigDocument, variables, headers);
export const ListCardWidthConfigDocument = `
    query listCardWidthConfig($clinic_id: ID!) {
  listClinicConfig(clinic_id: $clinic_id, config_type: "card_width") {
    clinic_id
    config {
      ... on CardWidthConfig {
        __typename
        cardWidth
      }
    }
    config_id
    config_type
    endDate
    startDate
    created_at
    updated_at
  }
}
    `;
export const useListCardWidthConfigQuery = <
      TData = ListCardWidthConfigQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListCardWidthConfigQueryVariables,
      options?: UseQueryOptions<ListCardWidthConfigQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListCardWidthConfigQuery, TError, TData>(
      ['listCardWidthConfig', variables],
      fetcher<ListCardWidthConfigQuery, ListCardWidthConfigQueryVariables>(client, ListCardWidthConfigDocument, variables, headers),
      options
    );

useListCardWidthConfigQuery.getKey = (variables: ListCardWidthConfigQueryVariables) => ['listCardWidthConfig', variables];
;

useListCardWidthConfigQuery.fetcher = (client: GraphQLClient, variables: ListCardWidthConfigQueryVariables, headers?: RequestInit['headers']) => fetcher<ListCardWidthConfigQuery, ListCardWidthConfigQueryVariables>(client, ListCardWidthConfigDocument, variables, headers);
export const ListClinicTimeConfigDocument = `
    query listClinicTimeConfig($clinic_id: ID!) {
  listClinicConfig(clinic_id: $clinic_id, config_type: "clinic_time") {
    clinic_id
    config {
      ... on ClinicTimeConfig {
        __typename
        clinicTime {
          endTime {
            hours
            minutes
          }
          startTime {
            hours
            minutes
          }
        }
      }
    }
    config_id
    config_type
    endDate
    startDate
    created_at
  }
}
    `;
export const useListClinicTimeConfigQuery = <
      TData = ListClinicTimeConfigQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListClinicTimeConfigQueryVariables,
      options?: UseQueryOptions<ListClinicTimeConfigQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListClinicTimeConfigQuery, TError, TData>(
      ['listClinicTimeConfig', variables],
      fetcher<ListClinicTimeConfigQuery, ListClinicTimeConfigQueryVariables>(client, ListClinicTimeConfigDocument, variables, headers),
      options
    );

useListClinicTimeConfigQuery.getKey = (variables: ListClinicTimeConfigQueryVariables) => ['listClinicTimeConfig', variables];
;

useListClinicTimeConfigQuery.fetcher = (client: GraphQLClient, variables: ListClinicTimeConfigQueryVariables, headers?: RequestInit['headers']) => fetcher<ListClinicTimeConfigQuery, ListClinicTimeConfigQueryVariables>(client, ListClinicTimeConfigDocument, variables, headers);
export const AddClinicTimeConfigDocument = `
    mutation addClinicTimeConfig($clinic_id: ID!, $config: ClinicTimeConfigInput!, $startDate: AWSTimestamp!, $endDate: AWSTimestamp) {
  addClinicTimeConfig(clinic_id: $clinic_id, config: $config, config_type: "clinic_time", endDate: $endDate, startDate: $startDate) {
    clinic_id
    config {
      ... on ClinicTimeConfig {
        __typename
        clinicTime {
          endTime {
            hours
            minutes
          }
          startTime {
            hours
            minutes
          }
        }
      }
    }
    config_id
    config_type
    endDate
    startDate
    created_at
  }
}
    `;
export const useAddClinicTimeConfigMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddClinicTimeConfigMutation, TError, AddClinicTimeConfigMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddClinicTimeConfigMutation, TError, AddClinicTimeConfigMutationVariables, TContext>(
      ['addClinicTimeConfig'],
      (variables?: AddClinicTimeConfigMutationVariables) => fetcher<AddClinicTimeConfigMutation, AddClinicTimeConfigMutationVariables>(client, AddClinicTimeConfigDocument, variables, headers)(),
      options
    );
useAddClinicTimeConfigMutation.fetcher = (client: GraphQLClient, variables: AddClinicTimeConfigMutationVariables, headers?: RequestInit['headers']) => fetcher<AddClinicTimeConfigMutation, AddClinicTimeConfigMutationVariables>(client, AddClinicTimeConfigDocument, variables, headers);
export const UpdateClinicTimeConfigDocument = `
    mutation updateClinicTimeConfig($clinic_id: ID!, $config: ClinicTimeConfigInput!, $config_id: ID!, $startDate: AWSTimestamp!, $endDate: AWSTimestamp) {
  updateClinicTimeConfig(clinic_id: $clinic_id, config: $config, config_id: $config_id, config_type: "clinic_time", startDate: $startDate, endDate: $endDate) {
    clinic_id
    config {
      ... on ClinicTimeConfig {
        __typename
        clinicTime {
          endTime {
            hours
            minutes
          }
          startTime {
            hours
            minutes
          }
        }
      }
    }
    config_id
    config_type
    endDate
    startDate
    created_at
    updated_at
  }
}
    `;
export const useUpdateClinicTimeConfigMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateClinicTimeConfigMutation, TError, UpdateClinicTimeConfigMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateClinicTimeConfigMutation, TError, UpdateClinicTimeConfigMutationVariables, TContext>(
      ['updateClinicTimeConfig'],
      (variables?: UpdateClinicTimeConfigMutationVariables) => fetcher<UpdateClinicTimeConfigMutation, UpdateClinicTimeConfigMutationVariables>(client, UpdateClinicTimeConfigDocument, variables, headers)(),
      options
    );
useUpdateClinicTimeConfigMutation.fetcher = (client: GraphQLClient, variables: UpdateClinicTimeConfigMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateClinicTimeConfigMutation, UpdateClinicTimeConfigMutationVariables>(client, UpdateClinicTimeConfigDocument, variables, headers);
export const DeleteClinicConfigDocument = `
    mutation deleteClinicConfig($clinic_id: ID!, $config_id: ID!, $config_type: String!) {
  deleteClinicConfig(clinic_id: $clinic_id, config_id: $config_id, config_type: $config_type) {
    clinic_id
    config {
      ... on ClinicTimeConfig {
        __typename
        clinicTime {
          endTime {
            hours
            minutes
          }
          startTime {
            hours
            minutes
          }
        }
      }
      ... on CardWidthConfig {
        __typename
        cardWidth
      }
    }
    config_id
    config_type
    endDate
    startDate
    created_at
  }
}
    `;
export const useDeleteClinicConfigMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteClinicConfigMutation, TError, DeleteClinicConfigMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteClinicConfigMutation, TError, DeleteClinicConfigMutationVariables, TContext>(
      ['deleteClinicConfig'],
      (variables?: DeleteClinicConfigMutationVariables) => fetcher<DeleteClinicConfigMutation, DeleteClinicConfigMutationVariables>(client, DeleteClinicConfigDocument, variables, headers)(),
      options
    );
useDeleteClinicConfigMutation.fetcher = (client: GraphQLClient, variables: DeleteClinicConfigMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteClinicConfigMutation, DeleteClinicConfigMutationVariables>(client, DeleteClinicConfigDocument, variables, headers);
export const ValidateBookingRuleDocument = `
    query validateBookingRule($clinic_id: ID!, $ruleStartDate: AWSTimestamp!, $ruleEndDate: AWSTimestamp, $clinicStartTime: ClinicHourMinutesInput!, $clinicEndTime: ClinicHourMinutesInput!, $validationType: String) {
  validateBookingRule(clinic_id: $clinic_id, clinicEndTime: $clinicEndTime, clinicStartTime: $clinicStartTime, ruleStartDate: $ruleStartDate, ruleEndDate: $ruleEndDate, validationType: $validationType) {
    isValid
  }
}
    `;
export const useValidateBookingRuleQuery = <
      TData = ValidateBookingRuleQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ValidateBookingRuleQueryVariables,
      options?: UseQueryOptions<ValidateBookingRuleQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ValidateBookingRuleQuery, TError, TData>(
      ['validateBookingRule', variables],
      fetcher<ValidateBookingRuleQuery, ValidateBookingRuleQueryVariables>(client, ValidateBookingRuleDocument, variables, headers),
      options
    );

useValidateBookingRuleQuery.getKey = (variables: ValidateBookingRuleQueryVariables) => ['validateBookingRule', variables];
;

useValidateBookingRuleQuery.fetcher = (client: GraphQLClient, variables: ValidateBookingRuleQueryVariables, headers?: RequestInit['headers']) => fetcher<ValidateBookingRuleQuery, ValidateBookingRuleQueryVariables>(client, ValidateBookingRuleDocument, variables, headers);
export const AddCardWidthConfigDocument = `
    mutation addCardWidthConfig($clinic_id: ID!, $config: CardWidthConfigInput!, $startDate: AWSTimestamp!, $endDate: AWSTimestamp) {
  addCardWidthConfig(clinic_id: $clinic_id, config: $config, config_type: "card_width", endDate: $endDate, startDate: $startDate) {
    clinic_id
    config {
      ... on CardWidthConfig {
        __typename
        cardWidth
      }
    }
    config_id
    config_type
    endDate
    startDate
    created_at
  }
}
    `;
export const useAddCardWidthConfigMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddCardWidthConfigMutation, TError, AddCardWidthConfigMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddCardWidthConfigMutation, TError, AddCardWidthConfigMutationVariables, TContext>(
      ['addCardWidthConfig'],
      (variables?: AddCardWidthConfigMutationVariables) => fetcher<AddCardWidthConfigMutation, AddCardWidthConfigMutationVariables>(client, AddCardWidthConfigDocument, variables, headers)(),
      options
    );
useAddCardWidthConfigMutation.fetcher = (client: GraphQLClient, variables: AddCardWidthConfigMutationVariables, headers?: RequestInit['headers']) => fetcher<AddCardWidthConfigMutation, AddCardWidthConfigMutationVariables>(client, AddCardWidthConfigDocument, variables, headers);
export const UpdateCardWidthConfigDocument = `
    mutation updateCardWidthConfig($clinic_id: ID!, $config: CardWidthConfigInput!, $config_id: ID!, $startDate: AWSTimestamp!, $endDate: AWSTimestamp) {
  updateCardWidthConfig(clinic_id: $clinic_id, config: $config, config_id: $config_id, config_type: "card_width", startDate: $startDate, endDate: $endDate) {
    clinic_id
    config {
      ... on CardWidthConfig {
        __typename
        cardWidth
      }
    }
    config_id
    config_type
    endDate
    startDate
    created_at
    updated_at
  }
}
    `;
export const useUpdateCardWidthConfigMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateCardWidthConfigMutation, TError, UpdateCardWidthConfigMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateCardWidthConfigMutation, TError, UpdateCardWidthConfigMutationVariables, TContext>(
      ['updateCardWidthConfig'],
      (variables?: UpdateCardWidthConfigMutationVariables) => fetcher<UpdateCardWidthConfigMutation, UpdateCardWidthConfigMutationVariables>(client, UpdateCardWidthConfigDocument, variables, headers)(),
      options
    );
useUpdateCardWidthConfigMutation.fetcher = (client: GraphQLClient, variables: UpdateCardWidthConfigMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateCardWidthConfigMutation, UpdateCardWidthConfigMutationVariables>(client, UpdateCardWidthConfigDocument, variables, headers);
export const GetClinicScheduleByClinicIdDocument = `
    query getClinicScheduleByClinicId($clinic_id: String!, $clinic_schedule_id: ID!) {
  getClinicScheduleByClinicId(clinic_id: $clinic_id, clinic_schedule_id: $clinic_schedule_id) {
    clinic_id
    clinic_schedule_id
    rule_type
    start_date
    end_date
    start_time
    end_time
    day_of_week
    week
    service_day
  }
}
    `;
export const useGetClinicScheduleByClinicIdQuery = <
      TData = GetClinicScheduleByClinicIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetClinicScheduleByClinicIdQueryVariables,
      options?: UseQueryOptions<GetClinicScheduleByClinicIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetClinicScheduleByClinicIdQuery, TError, TData>(
      ['getClinicScheduleByClinicId', variables],
      fetcher<GetClinicScheduleByClinicIdQuery, GetClinicScheduleByClinicIdQueryVariables>(client, GetClinicScheduleByClinicIdDocument, variables, headers),
      options
    );

useGetClinicScheduleByClinicIdQuery.getKey = (variables: GetClinicScheduleByClinicIdQueryVariables) => ['getClinicScheduleByClinicId', variables];
;

useGetClinicScheduleByClinicIdQuery.fetcher = (client: GraphQLClient, variables: GetClinicScheduleByClinicIdQueryVariables, headers?: RequestInit['headers']) => fetcher<GetClinicScheduleByClinicIdQuery, GetClinicScheduleByClinicIdQueryVariables>(client, GetClinicScheduleByClinicIdDocument, variables, headers);
export const GetActiveScheduleDocument = `
    query getActiveSchedule($clinic_id: ID!, $current_date: AWSTimestamp!) {
  getActiveSchedule(clinic_id: $clinic_id, current_date: $current_date) {
    isHoliday
    isBeforeDay
  }
}
    `;
export const useGetActiveScheduleQuery = <
      TData = GetActiveScheduleQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetActiveScheduleQueryVariables,
      options?: UseQueryOptions<GetActiveScheduleQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetActiveScheduleQuery, TError, TData>(
      ['getActiveSchedule', variables],
      fetcher<GetActiveScheduleQuery, GetActiveScheduleQueryVariables>(client, GetActiveScheduleDocument, variables, headers),
      options
    );

useGetActiveScheduleQuery.getKey = (variables: GetActiveScheduleQueryVariables) => ['getActiveSchedule', variables];
;

useGetActiveScheduleQuery.fetcher = (client: GraphQLClient, variables: GetActiveScheduleQueryVariables, headers?: RequestInit['headers']) => fetcher<GetActiveScheduleQuery, GetActiveScheduleQueryVariables>(client, GetActiveScheduleDocument, variables, headers);
export const GetSpecificDateRuleDocument = `
    query getSpecificDateRule($clinic_id: ID!, $current_date: AWSTimestamp!) {
  getSpecificDateRule(clinic_id: $clinic_id, current_date: $current_date) {
    clinic_id
    clinic_schedule_id
    specific_date
    service_day
    start_date
    end_date
    created_at
    updated_at
  }
}
    `;
export const useGetSpecificDateRuleQuery = <
      TData = GetSpecificDateRuleQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetSpecificDateRuleQueryVariables,
      options?: UseQueryOptions<GetSpecificDateRuleQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetSpecificDateRuleQuery, TError, TData>(
      ['getSpecificDateRule', variables],
      fetcher<GetSpecificDateRuleQuery, GetSpecificDateRuleQueryVariables>(client, GetSpecificDateRuleDocument, variables, headers),
      options
    );

useGetSpecificDateRuleQuery.getKey = (variables: GetSpecificDateRuleQueryVariables) => ['getSpecificDateRule', variables];
;

useGetSpecificDateRuleQuery.fetcher = (client: GraphQLClient, variables: GetSpecificDateRuleQueryVariables, headers?: RequestInit['headers']) => fetcher<GetSpecificDateRuleQuery, GetSpecificDateRuleQueryVariables>(client, GetSpecificDateRuleDocument, variables, headers);
export const ValidateScheduleRuleDocument = `
    query validateScheduleRule($clinic_id: ID!, $clinic_schedule_id: ID!, $rule_type: ClinicScheduleType!, $day_of_week: DayOfWeek, $week: Week, $specific_date: AWSTimestamp, $day: Int, $service_day: Boolean, $start_date: AWSTimestamp!, $end_date: AWSTimestamp) {
  validateScheduleRule(clinic_id: $clinic_id, clinic_schedule_id: $clinic_schedule_id, rule_type: $rule_type, day_of_week: $day_of_week, week: $week, specific_date: $specific_date, day: $day, service_day: $service_day, start_date: $start_date, end_date: $end_date) {
    isValid
  }
}
    `;
export const useValidateScheduleRuleQuery = <
      TData = ValidateScheduleRuleQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ValidateScheduleRuleQueryVariables,
      options?: UseQueryOptions<ValidateScheduleRuleQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ValidateScheduleRuleQuery, TError, TData>(
      ['validateScheduleRule', variables],
      fetcher<ValidateScheduleRuleQuery, ValidateScheduleRuleQueryVariables>(client, ValidateScheduleRuleDocument, variables, headers),
      options
    );

useValidateScheduleRuleQuery.getKey = (variables: ValidateScheduleRuleQueryVariables) => ['validateScheduleRule', variables];
;

useValidateScheduleRuleQuery.fetcher = (client: GraphQLClient, variables: ValidateScheduleRuleQueryVariables, headers?: RequestInit['headers']) => fetcher<ValidateScheduleRuleQuery, ValidateScheduleRuleQueryVariables>(client, ValidateScheduleRuleDocument, variables, headers);
export const ListClinicSchedulesByClinicIdDocument = `
    query listClinicSchedulesByClinicId($clinic_id: String!) {
  listClinicSchedulesByClinicId(clinic_id: $clinic_id) {
    clinic_schedules {
      clinic_id
      clinic_schedule_id
      day_of_week
      end_date
      end_time
      rule_type
      service_day
      start_date
      start_time
      week
      specific_date
      day
      created_at
      updated_at
    }
  }
}
    `;
export const useListClinicSchedulesByClinicIdQuery = <
      TData = ListClinicSchedulesByClinicIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListClinicSchedulesByClinicIdQueryVariables,
      options?: UseQueryOptions<ListClinicSchedulesByClinicIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListClinicSchedulesByClinicIdQuery, TError, TData>(
      ['listClinicSchedulesByClinicId', variables],
      fetcher<ListClinicSchedulesByClinicIdQuery, ListClinicSchedulesByClinicIdQueryVariables>(client, ListClinicSchedulesByClinicIdDocument, variables, headers),
      options
    );

useListClinicSchedulesByClinicIdQuery.getKey = (variables: ListClinicSchedulesByClinicIdQueryVariables) => ['listClinicSchedulesByClinicId', variables];
;

useListClinicSchedulesByClinicIdQuery.fetcher = (client: GraphQLClient, variables: ListClinicSchedulesByClinicIdQueryVariables, headers?: RequestInit['headers']) => fetcher<ListClinicSchedulesByClinicIdQuery, ListClinicSchedulesByClinicIdQueryVariables>(client, ListClinicSchedulesByClinicIdDocument, variables, headers);
export const AddClinicScheduleDocument = `
    mutation addClinicSchedule($input: ClinicScheduleInput!) {
  addClinicSchedule(input: $input) {
    clinic_id
    clinic_schedule_id
    day_of_week
    end_date
    end_time
    rule_type
    service_day
    start_date
    start_time
    week
    specific_date
    day
    created_at
  }
}
    `;
export const useAddClinicScheduleMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddClinicScheduleMutation, TError, AddClinicScheduleMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddClinicScheduleMutation, TError, AddClinicScheduleMutationVariables, TContext>(
      ['addClinicSchedule'],
      (variables?: AddClinicScheduleMutationVariables) => fetcher<AddClinicScheduleMutation, AddClinicScheduleMutationVariables>(client, AddClinicScheduleDocument, variables, headers)(),
      options
    );
useAddClinicScheduleMutation.fetcher = (client: GraphQLClient, variables: AddClinicScheduleMutationVariables, headers?: RequestInit['headers']) => fetcher<AddClinicScheduleMutation, AddClinicScheduleMutationVariables>(client, AddClinicScheduleDocument, variables, headers);
export const UpdateClinicScheduleDocument = `
    mutation updateClinicSchedule($clinic_schedule_id: ID!, $input: ClinicScheduleInput!) {
  updateClinicSchedule(clinic_schedule_id: $clinic_schedule_id, input: $input) {
    week
    start_time
    start_date
    service_day
    rule_type
    end_time
    end_date
    day_of_week
    clinic_schedule_id
    clinic_id
    specific_date
    day
    updated_at
  }
}
    `;
export const useUpdateClinicScheduleMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateClinicScheduleMutation, TError, UpdateClinicScheduleMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateClinicScheduleMutation, TError, UpdateClinicScheduleMutationVariables, TContext>(
      ['updateClinicSchedule'],
      (variables?: UpdateClinicScheduleMutationVariables) => fetcher<UpdateClinicScheduleMutation, UpdateClinicScheduleMutationVariables>(client, UpdateClinicScheduleDocument, variables, headers)(),
      options
    );
useUpdateClinicScheduleMutation.fetcher = (client: GraphQLClient, variables: UpdateClinicScheduleMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateClinicScheduleMutation, UpdateClinicScheduleMutationVariables>(client, UpdateClinicScheduleDocument, variables, headers);
export const DeleteClinicScheduleDocument = `
    mutation deleteClinicSchedule($clinic_id: String!, $clinic_schedule_id: ID!) {
  deleteClinicSchedule(clinic_id: $clinic_id, clinic_schedule_id: $clinic_schedule_id)
}
    `;
export const useDeleteClinicScheduleMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteClinicScheduleMutation, TError, DeleteClinicScheduleMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteClinicScheduleMutation, TError, DeleteClinicScheduleMutationVariables, TContext>(
      ['deleteClinicSchedule'],
      (variables?: DeleteClinicScheduleMutationVariables) => fetcher<DeleteClinicScheduleMutation, DeleteClinicScheduleMutationVariables>(client, DeleteClinicScheduleDocument, variables, headers)(),
      options
    );
useDeleteClinicScheduleMutation.fetcher = (client: GraphQLClient, variables: DeleteClinicScheduleMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteClinicScheduleMutation, DeleteClinicScheduleMutationVariables>(client, DeleteClinicScheduleDocument, variables, headers);
export const GetCommentDocument = `
    query getComment($id: ID!) {
  getComment(id: $id) {
    comment
    id
  }
}
    `;
export const useGetCommentQuery = <
      TData = GetCommentQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetCommentQueryVariables,
      options?: UseQueryOptions<GetCommentQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCommentQuery, TError, TData>(
      ['getComment', variables],
      fetcher<GetCommentQuery, GetCommentQueryVariables>(client, GetCommentDocument, variables, headers),
      options
    );

useGetCommentQuery.getKey = (variables: GetCommentQueryVariables) => ['getComment', variables];
;

useGetCommentQuery.fetcher = (client: GraphQLClient, variables: GetCommentQueryVariables, headers?: RequestInit['headers']) => fetcher<GetCommentQuery, GetCommentQueryVariables>(client, GetCommentDocument, variables, headers);
export const AddCommentDocument = `
    mutation addComment($id: ID!, $comment: String!) {
  addComment(comment: $comment, id: $id) {
    comment
    id
  }
}
    `;
export const useAddCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddCommentMutation, TError, AddCommentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddCommentMutation, TError, AddCommentMutationVariables, TContext>(
      ['addComment'],
      (variables?: AddCommentMutationVariables) => fetcher<AddCommentMutation, AddCommentMutationVariables>(client, AddCommentDocument, variables, headers)(),
      options
    );
useAddCommentMutation.fetcher = (client: GraphQLClient, variables: AddCommentMutationVariables, headers?: RequestInit['headers']) => fetcher<AddCommentMutation, AddCommentMutationVariables>(client, AddCommentDocument, variables, headers);
export const GetCommentsDocument = `
    query getComments($clinic_id: ID!, $date: AWSTimestamp!) {
  getComments(clinic_id: $clinic_id, date: $date) {
    clinic_id
    date
    comment
    commentId
  }
}
    `;
export const useGetCommentsQuery = <
      TData = GetCommentsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetCommentsQueryVariables,
      options?: UseQueryOptions<GetCommentsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCommentsQuery, TError, TData>(
      ['getComments', variables],
      fetcher<GetCommentsQuery, GetCommentsQueryVariables>(client, GetCommentsDocument, variables, headers),
      options
    );

useGetCommentsQuery.getKey = (variables: GetCommentsQueryVariables) => ['getComments', variables];
;

useGetCommentsQuery.fetcher = (client: GraphQLClient, variables: GetCommentsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetCommentsQuery, GetCommentsQueryVariables>(client, GetCommentsDocument, variables, headers);
export const AddCommentsDocument = `
    mutation addComments($clinic_id: ID!, $date: AWSTimestamp!, $comment: String!) {
  addComments(clinic_id: $clinic_id, date: $date, comment: $comment) {
    clinic_id
    date
    comment
    commentId
  }
}
    `;
export const useAddCommentsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddCommentsMutation, TError, AddCommentsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddCommentsMutation, TError, AddCommentsMutationVariables, TContext>(
      ['addComments'],
      (variables?: AddCommentsMutationVariables) => fetcher<AddCommentsMutation, AddCommentsMutationVariables>(client, AddCommentsDocument, variables, headers)(),
      options
    );
useAddCommentsMutation.fetcher = (client: GraphQLClient, variables: AddCommentsMutationVariables, headers?: RequestInit['headers']) => fetcher<AddCommentsMutation, AddCommentsMutationVariables>(client, AddCommentsDocument, variables, headers);
export const ListFacilitiesDocument = `
    query listFacilities($clinic_id: ID!) {
  listFacilities(clinic_id: $clinic_id) {
    Facilities {
      id
      name
      status
      isDelete
      index
      clinic_id
    }
  }
}
    `;
export const useListFacilitiesQuery = <
      TData = ListFacilitiesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListFacilitiesQueryVariables,
      options?: UseQueryOptions<ListFacilitiesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListFacilitiesQuery, TError, TData>(
      ['listFacilities', variables],
      fetcher<ListFacilitiesQuery, ListFacilitiesQueryVariables>(client, ListFacilitiesDocument, variables, headers),
      options
    );

useListFacilitiesQuery.getKey = (variables: ListFacilitiesQueryVariables) => ['listFacilities', variables];
;

useListFacilitiesQuery.fetcher = (client: GraphQLClient, variables: ListFacilitiesQueryVariables, headers?: RequestInit['headers']) => fetcher<ListFacilitiesQuery, ListFacilitiesQueryVariables>(client, ListFacilitiesDocument, variables, headers);
export const ListFacilitiesByFilterDocument = `
    query listFacilitiesByFilter($inputs: ListFacilitiesByFilterInput!) {
  listFacilitiesByFilter(inputs: $inputs) {
    Facilities {
      clinic_id
      id
      name
      status
      isDelete
      index
    }
  }
}
    `;
export const useListFacilitiesByFilterQuery = <
      TData = ListFacilitiesByFilterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListFacilitiesByFilterQueryVariables,
      options?: UseQueryOptions<ListFacilitiesByFilterQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListFacilitiesByFilterQuery, TError, TData>(
      ['listFacilitiesByFilter', variables],
      fetcher<ListFacilitiesByFilterQuery, ListFacilitiesByFilterQueryVariables>(client, ListFacilitiesByFilterDocument, variables, headers),
      options
    );

useListFacilitiesByFilterQuery.getKey = (variables: ListFacilitiesByFilterQueryVariables) => ['listFacilitiesByFilter', variables];
;

useListFacilitiesByFilterQuery.fetcher = (client: GraphQLClient, variables: ListFacilitiesByFilterQueryVariables, headers?: RequestInit['headers']) => fetcher<ListFacilitiesByFilterQuery, ListFacilitiesByFilterQueryVariables>(client, ListFacilitiesByFilterDocument, variables, headers);
export const ListFacilitieNamesDocument = `
    query listFacilitieNames($clinic_id: ID!) {
  listFacilities(clinic_id: $clinic_id) {
    Facilities {
      id
      name
      isDelete
    }
  }
}
    `;
export const useListFacilitieNamesQuery = <
      TData = ListFacilitieNamesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListFacilitieNamesQueryVariables,
      options?: UseQueryOptions<ListFacilitieNamesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListFacilitieNamesQuery, TError, TData>(
      ['listFacilitieNames', variables],
      fetcher<ListFacilitieNamesQuery, ListFacilitieNamesQueryVariables>(client, ListFacilitieNamesDocument, variables, headers),
      options
    );

useListFacilitieNamesQuery.getKey = (variables: ListFacilitieNamesQueryVariables) => ['listFacilitieNames', variables];
;

useListFacilitieNamesQuery.fetcher = (client: GraphQLClient, variables: ListFacilitieNamesQueryVariables, headers?: RequestInit['headers']) => fetcher<ListFacilitieNamesQuery, ListFacilitieNamesQueryVariables>(client, ListFacilitieNamesDocument, variables, headers);
export const AddFacilityDocument = `
    mutation addFacility($group_ids: [ID!], $name: String!, $status: Boolean!, $isDelete: Boolean, $index: Int, $clinic_id: ID!) {
  addFacility(group_ids: $group_ids, name: $name, status: $status, isDelete: $isDelete, index: $index, clinic_id: $clinic_id) {
    id
    name
    status
    isDelete
    index
    clinic_id
  }
}
    `;
export const useAddFacilityMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddFacilityMutation, TError, AddFacilityMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddFacilityMutation, TError, AddFacilityMutationVariables, TContext>(
      ['addFacility'],
      (variables?: AddFacilityMutationVariables) => fetcher<AddFacilityMutation, AddFacilityMutationVariables>(client, AddFacilityDocument, variables, headers)(),
      options
    );
useAddFacilityMutation.fetcher = (client: GraphQLClient, variables: AddFacilityMutationVariables, headers?: RequestInit['headers']) => fetcher<AddFacilityMutation, AddFacilityMutationVariables>(client, AddFacilityDocument, variables, headers);
export const DeleteFacilityDocument = `
    mutation deleteFacility($id: ID!, $clinic_id: ID!) {
  deleteFacility(id: $id, clinic_id: $clinic_id) {
    id
    clinic_id
    name
    status
    isDelete
    index
  }
}
    `;
export const useDeleteFacilityMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteFacilityMutation, TError, DeleteFacilityMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteFacilityMutation, TError, DeleteFacilityMutationVariables, TContext>(
      ['deleteFacility'],
      (variables?: DeleteFacilityMutationVariables) => fetcher<DeleteFacilityMutation, DeleteFacilityMutationVariables>(client, DeleteFacilityDocument, variables, headers)(),
      options
    );
useDeleteFacilityMutation.fetcher = (client: GraphQLClient, variables: DeleteFacilityMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteFacilityMutation, DeleteFacilityMutationVariables>(client, DeleteFacilityDocument, variables, headers);
export const UpdateFacilityDocument = `
    mutation updateFacility($group_ids: [ID!], $id: ID!, $name: String, $status: Boolean, $isDelete: Boolean, $index: Int, $clinic_id: ID!) {
  updateFacility(group_ids: $group_ids, id: $id, name: $name, status: $status, isDelete: $isDelete, index: $index, clinic_id: $clinic_id) {
    clinic_id
    id
    name
    status
    isDelete
    index
  }
}
    `;
export const useUpdateFacilityMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateFacilityMutation, TError, UpdateFacilityMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateFacilityMutation, TError, UpdateFacilityMutationVariables, TContext>(
      ['updateFacility'],
      (variables?: UpdateFacilityMutationVariables) => fetcher<UpdateFacilityMutation, UpdateFacilityMutationVariables>(client, UpdateFacilityDocument, variables, headers)(),
      options
    );
useUpdateFacilityMutation.fetcher = (client: GraphQLClient, variables: UpdateFacilityMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateFacilityMutation, UpdateFacilityMutationVariables>(client, UpdateFacilityDocument, variables, headers);
export const UpdateFacilityIdxDocument = `
    mutation updateFacilityIdx($inputs: UpdateFacilityIdxInput!) {
  updateFacilityIdx(inputs: $inputs)
}
    `;
export const useUpdateFacilityIdxMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateFacilityIdxMutation, TError, UpdateFacilityIdxMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateFacilityIdxMutation, TError, UpdateFacilityIdxMutationVariables, TContext>(
      ['updateFacilityIdx'],
      (variables?: UpdateFacilityIdxMutationVariables) => fetcher<UpdateFacilityIdxMutation, UpdateFacilityIdxMutationVariables>(client, UpdateFacilityIdxDocument, variables, headers)(),
      options
    );
useUpdateFacilityIdxMutation.fetcher = (client: GraphQLClient, variables: UpdateFacilityIdxMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateFacilityIdxMutation, UpdateFacilityIdxMutationVariables>(client, UpdateFacilityIdxDocument, variables, headers);
export const ListFacilityGroupsDocument = `
    query listFacilityGroups($inputs: ListFacilityGroupsInput!) {
  listFacilityGroups(inputs: $inputs) {
    FacilityGroups {
      clinic_id
      created_at
      facilityIds
      group_id
      index
      isDelete
      name
      updated_at
    }
  }
}
    `;
export const useListFacilityGroupsQuery = <
      TData = ListFacilityGroupsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListFacilityGroupsQueryVariables,
      options?: UseQueryOptions<ListFacilityGroupsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListFacilityGroupsQuery, TError, TData>(
      ['listFacilityGroups', variables],
      fetcher<ListFacilityGroupsQuery, ListFacilityGroupsQueryVariables>(client, ListFacilityGroupsDocument, variables, headers),
      options
    );

useListFacilityGroupsQuery.getKey = (variables: ListFacilityGroupsQueryVariables) => ['listFacilityGroups', variables];
;

useListFacilityGroupsQuery.fetcher = (client: GraphQLClient, variables: ListFacilityGroupsQueryVariables, headers?: RequestInit['headers']) => fetcher<ListFacilityGroupsQuery, ListFacilityGroupsQueryVariables>(client, ListFacilityGroupsDocument, variables, headers);
export const AddFacilityGroupDocument = `
    mutation addFacilityGroup($inputs: AddFacilityGroupInput!) {
  addFacilityGroup(inputs: $inputs) {
    clinic_id
    created_at
    facilityIds
    group_id
    index
    isDelete
    name
    updated_at
  }
}
    `;
export const useAddFacilityGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddFacilityGroupMutation, TError, AddFacilityGroupMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddFacilityGroupMutation, TError, AddFacilityGroupMutationVariables, TContext>(
      ['addFacilityGroup'],
      (variables?: AddFacilityGroupMutationVariables) => fetcher<AddFacilityGroupMutation, AddFacilityGroupMutationVariables>(client, AddFacilityGroupDocument, variables, headers)(),
      options
    );
useAddFacilityGroupMutation.fetcher = (client: GraphQLClient, variables: AddFacilityGroupMutationVariables, headers?: RequestInit['headers']) => fetcher<AddFacilityGroupMutation, AddFacilityGroupMutationVariables>(client, AddFacilityGroupDocument, variables, headers);
export const UpdateFacilityGroupDocument = `
    mutation updateFacilityGroup($inputs: UpdateFacilityGroupInput!) {
  updateFacilityGroup(inputs: $inputs) {
    clinic_id
    created_at
    facilityIds
    group_id
    index
    isDelete
    name
    updated_at
  }
}
    `;
export const useUpdateFacilityGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateFacilityGroupMutation, TError, UpdateFacilityGroupMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateFacilityGroupMutation, TError, UpdateFacilityGroupMutationVariables, TContext>(
      ['updateFacilityGroup'],
      (variables?: UpdateFacilityGroupMutationVariables) => fetcher<UpdateFacilityGroupMutation, UpdateFacilityGroupMutationVariables>(client, UpdateFacilityGroupDocument, variables, headers)(),
      options
    );
useUpdateFacilityGroupMutation.fetcher = (client: GraphQLClient, variables: UpdateFacilityGroupMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateFacilityGroupMutation, UpdateFacilityGroupMutationVariables>(client, UpdateFacilityGroupDocument, variables, headers);
export const DeleteFacilityGroupDocument = `
    mutation deleteFacilityGroup($inputs: DeleteFacilityGroupInput!) {
  deleteFacilityGroup(inputs: $inputs) {
    clinic_id
    created_at
    facilityIds
    group_id
    index
    isDelete
    name
    updated_at
  }
}
    `;
export const useDeleteFacilityGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteFacilityGroupMutation, TError, DeleteFacilityGroupMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteFacilityGroupMutation, TError, DeleteFacilityGroupMutationVariables, TContext>(
      ['deleteFacilityGroup'],
      (variables?: DeleteFacilityGroupMutationVariables) => fetcher<DeleteFacilityGroupMutation, DeleteFacilityGroupMutationVariables>(client, DeleteFacilityGroupDocument, variables, headers)(),
      options
    );
useDeleteFacilityGroupMutation.fetcher = (client: GraphQLClient, variables: DeleteFacilityGroupMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteFacilityGroupMutation, DeleteFacilityGroupMutationVariables>(client, DeleteFacilityGroupDocument, variables, headers);
export const TransactDeleteGroupsDocument = `
    mutation transactDeleteGroups($inputs: TransactDeleteGroupsInput!) {
  transactDeleteGroups(inputs: $inputs) {
    TransactReturn
  }
}
    `;
export const useTransactDeleteGroupsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<TransactDeleteGroupsMutation, TError, TransactDeleteGroupsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<TransactDeleteGroupsMutation, TError, TransactDeleteGroupsMutationVariables, TContext>(
      ['transactDeleteGroups'],
      (variables?: TransactDeleteGroupsMutationVariables) => fetcher<TransactDeleteGroupsMutation, TransactDeleteGroupsMutationVariables>(client, TransactDeleteGroupsDocument, variables, headers)(),
      options
    );
useTransactDeleteGroupsMutation.fetcher = (client: GraphQLClient, variables: TransactDeleteGroupsMutationVariables, headers?: RequestInit['headers']) => fetcher<TransactDeleteGroupsMutation, TransactDeleteGroupsMutationVariables>(client, TransactDeleteGroupsDocument, variables, headers);
export const ListFacilitiesByGroupIdsDocument = `
    query listFacilitiesByGroupIds($input: ListFacilitiesByGroupIdsInput!) {
  listFacilitiesByGroupIds(input: $input) {
    ListFacilitiesByGroupIdsReturns {
      group_id
      facilities {
        clinic_id
        id
        index
        isDelete
        name
        status
      }
    }
  }
}
    `;
export const useListFacilitiesByGroupIdsQuery = <
      TData = ListFacilitiesByGroupIdsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListFacilitiesByGroupIdsQueryVariables,
      options?: UseQueryOptions<ListFacilitiesByGroupIdsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListFacilitiesByGroupIdsQuery, TError, TData>(
      ['listFacilitiesByGroupIds', variables],
      fetcher<ListFacilitiesByGroupIdsQuery, ListFacilitiesByGroupIdsQueryVariables>(client, ListFacilitiesByGroupIdsDocument, variables, headers),
      options
    );

useListFacilitiesByGroupIdsQuery.getKey = (variables: ListFacilitiesByGroupIdsQueryVariables) => ['listFacilitiesByGroupIds', variables];
;

useListFacilitiesByGroupIdsQuery.fetcher = (client: GraphQLClient, variables: ListFacilitiesByGroupIdsQueryVariables, headers?: RequestInit['headers']) => fetcher<ListFacilitiesByGroupIdsQuery, ListFacilitiesByGroupIdsQueryVariables>(client, ListFacilitiesByGroupIdsDocument, variables, headers);
export const ListGroupsByFacilityIdsDocument = `
    query listGroupsByFacilityIds($input: ListGroupsByFacilityIdsInput!) {
  listGroupsByFacilityIds(inputs: $input) {
    listGroupsByFacilityIdsReturns {
      facility_id
      groups {
        clinic_id
        created_at
        facilityIds
        group_id
        index
        isDelete
        name
        updated_at
      }
    }
  }
}
    `;
export const useListGroupsByFacilityIdsQuery = <
      TData = ListGroupsByFacilityIdsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListGroupsByFacilityIdsQueryVariables,
      options?: UseQueryOptions<ListGroupsByFacilityIdsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListGroupsByFacilityIdsQuery, TError, TData>(
      ['listGroupsByFacilityIds', variables],
      fetcher<ListGroupsByFacilityIdsQuery, ListGroupsByFacilityIdsQueryVariables>(client, ListGroupsByFacilityIdsDocument, variables, headers),
      options
    );

useListGroupsByFacilityIdsQuery.getKey = (variables: ListGroupsByFacilityIdsQueryVariables) => ['listGroupsByFacilityIds', variables];
;

useListGroupsByFacilityIdsQuery.fetcher = (client: GraphQLClient, variables: ListGroupsByFacilityIdsQueryVariables, headers?: RequestInit['headers']) => fetcher<ListGroupsByFacilityIdsQuery, ListGroupsByFacilityIdsQueryVariables>(client, ListGroupsByFacilityIdsDocument, variables, headers);
export const GetFloorDocument = `
    query getFloor($clinic_id: ID!, $floor_id: ID!) {
  getFloor(clinic_id: $clinic_id, floor_id: $floor_id) {
    clinic_id
    floorName
    floor_id
    index
    isDelete
  }
}
    `;
export const useGetFloorQuery = <
      TData = GetFloorQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetFloorQueryVariables,
      options?: UseQueryOptions<GetFloorQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetFloorQuery, TError, TData>(
      ['getFloor', variables],
      fetcher<GetFloorQuery, GetFloorQueryVariables>(client, GetFloorDocument, variables, headers),
      options
    );

useGetFloorQuery.getKey = (variables: GetFloorQueryVariables) => ['getFloor', variables];
;

useGetFloorQuery.fetcher = (client: GraphQLClient, variables: GetFloorQueryVariables, headers?: RequestInit['headers']) => fetcher<GetFloorQuery, GetFloorQueryVariables>(client, GetFloorDocument, variables, headers);
export const ListFloorsDocument = `
    query listFloors($clinic_id: ID!) {
  listFloors(clinic_id: $clinic_id) {
    clinic_id
    floorName
    floor_id
    index
    isDelete
  }
}
    `;
export const useListFloorsQuery = <
      TData = ListFloorsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListFloorsQueryVariables,
      options?: UseQueryOptions<ListFloorsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListFloorsQuery, TError, TData>(
      ['listFloors', variables],
      fetcher<ListFloorsQuery, ListFloorsQueryVariables>(client, ListFloorsDocument, variables, headers),
      options
    );

useListFloorsQuery.getKey = (variables: ListFloorsQueryVariables) => ['listFloors', variables];
;

useListFloorsQuery.fetcher = (client: GraphQLClient, variables: ListFloorsQueryVariables, headers?: RequestInit['headers']) => fetcher<ListFloorsQuery, ListFloorsQueryVariables>(client, ListFloorsDocument, variables, headers);
export const AddFloorDocument = `
    mutation addFloor($clinic_id: ID!, $floorName: String!) {
  addFloor(clinic_id: $clinic_id, floorName: $floorName) {
    clinic_id
    floorName
    floor_id
    index
    isDelete
  }
}
    `;
export const useAddFloorMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddFloorMutation, TError, AddFloorMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddFloorMutation, TError, AddFloorMutationVariables, TContext>(
      ['addFloor'],
      (variables?: AddFloorMutationVariables) => fetcher<AddFloorMutation, AddFloorMutationVariables>(client, AddFloorDocument, variables, headers)(),
      options
    );
useAddFloorMutation.fetcher = (client: GraphQLClient, variables: AddFloorMutationVariables, headers?: RequestInit['headers']) => fetcher<AddFloorMutation, AddFloorMutationVariables>(client, AddFloorDocument, variables, headers);
export const DeleteFloorDocument = `
    mutation deleteFloor($clinic_id: ID!, $floor_id: ID!) {
  deleteFloor(clinic_id: $clinic_id, floor_id: $floor_id)
}
    `;
export const useDeleteFloorMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteFloorMutation, TError, DeleteFloorMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteFloorMutation, TError, DeleteFloorMutationVariables, TContext>(
      ['deleteFloor'],
      (variables?: DeleteFloorMutationVariables) => fetcher<DeleteFloorMutation, DeleteFloorMutationVariables>(client, DeleteFloorDocument, variables, headers)(),
      options
    );
useDeleteFloorMutation.fetcher = (client: GraphQLClient, variables: DeleteFloorMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteFloorMutation, DeleteFloorMutationVariables>(client, DeleteFloorDocument, variables, headers);
export const UpdateFloorDocument = `
    mutation updateFloor($clinic_id: ID!, $floor_id: ID!, $floorName: String, $index: Int) {
  updateFloor(clinic_id: $clinic_id, floor_id: $floor_id, floorName: $floorName, index: $index) {
    clinic_id
    floorName
    floor_id
    index
    isDelete
  }
}
    `;
export const useUpdateFloorMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateFloorMutation, TError, UpdateFloorMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateFloorMutation, TError, UpdateFloorMutationVariables, TContext>(
      ['updateFloor'],
      (variables?: UpdateFloorMutationVariables) => fetcher<UpdateFloorMutation, UpdateFloorMutationVariables>(client, UpdateFloorDocument, variables, headers)(),
      options
    );
useUpdateFloorMutation.fetcher = (client: GraphQLClient, variables: UpdateFloorMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateFloorMutation, UpdateFloorMutationVariables>(client, UpdateFloorDocument, variables, headers);
export const UpdateFloorIdxDocument = `
    mutation updateFloorIdx($clinic_id: ID!, $direction: Int!, $floor_id: ID!) {
  updateFloorIdx(clinic_id: $clinic_id, direction: $direction, floor_id: $floor_id)
}
    `;
export const useUpdateFloorIdxMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateFloorIdxMutation, TError, UpdateFloorIdxMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateFloorIdxMutation, TError, UpdateFloorIdxMutationVariables, TContext>(
      ['updateFloorIdx'],
      (variables?: UpdateFloorIdxMutationVariables) => fetcher<UpdateFloorIdxMutation, UpdateFloorIdxMutationVariables>(client, UpdateFloorIdxDocument, variables, headers)(),
      options
    );
useUpdateFloorIdxMutation.fetcher = (client: GraphQLClient, variables: UpdateFloorIdxMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateFloorIdxMutation, UpdateFloorIdxMutationVariables>(client, UpdateFloorIdxDocument, variables, headers);
export const GetManegerDocument = `
    query getManeger($id: ID!) {
  getManeger(id: $id) {
    id
    role
    name
    rights
    email
    color
    isDelete
    index
  }
}
    `;
export const useGetManegerQuery = <
      TData = GetManegerQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetManegerQueryVariables,
      options?: UseQueryOptions<GetManegerQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetManegerQuery, TError, TData>(
      ['getManeger', variables],
      fetcher<GetManegerQuery, GetManegerQueryVariables>(client, GetManegerDocument, variables, headers),
      options
    );

useGetManegerQuery.getKey = (variables: GetManegerQueryVariables) => ['getManeger', variables];
;

useGetManegerQuery.fetcher = (client: GraphQLClient, variables: GetManegerQueryVariables, headers?: RequestInit['headers']) => fetcher<GetManegerQuery, GetManegerQueryVariables>(client, GetManegerDocument, variables, headers);
export const ListManegerDocument = `
    query listManeger($clinic_id: ID!) {
  listManeger(clinic_id: $clinic_id) {
    Manegers {
      id
      role
      name
      rights
      email
      color
      isDelete
      index
      clinic_id
    }
  }
}
    `;
export const useListManegerQuery = <
      TData = ListManegerQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListManegerQueryVariables,
      options?: UseQueryOptions<ListManegerQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListManegerQuery, TError, TData>(
      ['listManeger', variables],
      fetcher<ListManegerQuery, ListManegerQueryVariables>(client, ListManegerDocument, variables, headers),
      options
    );

useListManegerQuery.getKey = (variables: ListManegerQueryVariables) => ['listManeger', variables];
;

useListManegerQuery.fetcher = (client: GraphQLClient, variables: ListManegerQueryVariables, headers?: RequestInit['headers']) => fetcher<ListManegerQuery, ListManegerQueryVariables>(client, ListManegerDocument, variables, headers);
export const ListManegerNameDocument = `
    query listManegerName($clinic_id: ID!) {
  listManeger(clinic_id: $clinic_id) {
    Manegers {
      id
      name
      isDelete
      index
    }
  }
}
    `;
export const useListManegerNameQuery = <
      TData = ListManegerNameQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListManegerNameQueryVariables,
      options?: UseQueryOptions<ListManegerNameQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListManegerNameQuery, TError, TData>(
      ['listManegerName', variables],
      fetcher<ListManegerNameQuery, ListManegerNameQueryVariables>(client, ListManegerNameDocument, variables, headers),
      options
    );

useListManegerNameQuery.getKey = (variables: ListManegerNameQueryVariables) => ['listManegerName', variables];
;

useListManegerNameQuery.fetcher = (client: GraphQLClient, variables: ListManegerNameQueryVariables, headers?: RequestInit['headers']) => fetcher<ListManegerNameQuery, ListManegerNameQueryVariables>(client, ListManegerNameDocument, variables, headers);
export const AddManegerDocument = `
    mutation addManeger($role: String!, $name: String!, $rights: String!, $email: String!, $color: String, $isDelete: Boolean, $index: Int, $clinic_id: ID!) {
  addManeger(role: $role, name: $name, rights: $rights, email: $email, color: $color, isDelete: $isDelete, index: $index, clinic_id: $clinic_id) {
    id
    role
    name
    rights
    email
    color
    isDelete
    index
    clinic_id
  }
}
    `;
export const useAddManegerMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddManegerMutation, TError, AddManegerMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddManegerMutation, TError, AddManegerMutationVariables, TContext>(
      ['addManeger'],
      (variables?: AddManegerMutationVariables) => fetcher<AddManegerMutation, AddManegerMutationVariables>(client, AddManegerDocument, variables, headers)(),
      options
    );
useAddManegerMutation.fetcher = (client: GraphQLClient, variables: AddManegerMutationVariables, headers?: RequestInit['headers']) => fetcher<AddManegerMutation, AddManegerMutationVariables>(client, AddManegerDocument, variables, headers);
export const DeleteManegerDocument = `
    mutation deleteManeger($id: ID!, $clinic_id: ID!) {
  deleteManeger(id: $id, clinic_id: $clinic_id) {
    id
    clinic_id
    role
    name
    rights
    email
    color
    isDelete
    index
  }
}
    `;
export const useDeleteManegerMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteManegerMutation, TError, DeleteManegerMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteManegerMutation, TError, DeleteManegerMutationVariables, TContext>(
      ['deleteManeger'],
      (variables?: DeleteManegerMutationVariables) => fetcher<DeleteManegerMutation, DeleteManegerMutationVariables>(client, DeleteManegerDocument, variables, headers)(),
      options
    );
useDeleteManegerMutation.fetcher = (client: GraphQLClient, variables: DeleteManegerMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteManegerMutation, DeleteManegerMutationVariables>(client, DeleteManegerDocument, variables, headers);
export const UpDateManegerDocument = `
    mutation upDateManeger($id: ID!, $role: String, $name: String, $rights: String, $email: String, $color: String, $isDelete: Boolean, $index: Int) {
  updateManeger(id: $id, role: $role, name: $name, rights: $rights, email: $email, color: $color, isDelete: $isDelete, index: $index) {
    id
    role
    name
    rights
    email
    color
    isDelete
    index
  }
}
    `;
export const useUpDateManegerMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpDateManegerMutation, TError, UpDateManegerMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpDateManegerMutation, TError, UpDateManegerMutationVariables, TContext>(
      ['upDateManeger'],
      (variables?: UpDateManegerMutationVariables) => fetcher<UpDateManegerMutation, UpDateManegerMutationVariables>(client, UpDateManegerDocument, variables, headers)(),
      options
    );
useUpDateManegerMutation.fetcher = (client: GraphQLClient, variables: UpDateManegerMutationVariables, headers?: RequestInit['headers']) => fetcher<UpDateManegerMutation, UpDateManegerMutationVariables>(client, UpDateManegerDocument, variables, headers);
export const UpdateManegerColorDocument = `
    mutation updateManegerColor($id: ID!, $color: String!) {
  updateManeger(id: $id, color: $color) {
    id
    color
  }
}
    `;
export const useUpdateManegerColorMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateManegerColorMutation, TError, UpdateManegerColorMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateManegerColorMutation, TError, UpdateManegerColorMutationVariables, TContext>(
      ['updateManegerColor'],
      (variables?: UpdateManegerColorMutationVariables) => fetcher<UpdateManegerColorMutation, UpdateManegerColorMutationVariables>(client, UpdateManegerColorDocument, variables, headers)(),
      options
    );
useUpdateManegerColorMutation.fetcher = (client: GraphQLClient, variables: UpdateManegerColorMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateManegerColorMutation, UpdateManegerColorMutationVariables>(client, UpdateManegerColorDocument, variables, headers);
export const ListCategorysDocument = `
    query listCategorys($clinic_id: ID!) {
  listCategorys(clinic_id: $clinic_id) {
    Categorys {
      id
      isDelete
      mainCategory
      name
      clinic_id
    }
  }
}
    `;
export const useListCategorysQuery = <
      TData = ListCategorysQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListCategorysQueryVariables,
      options?: UseQueryOptions<ListCategorysQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListCategorysQuery, TError, TData>(
      ['listCategorys', variables],
      fetcher<ListCategorysQuery, ListCategorysQueryVariables>(client, ListCategorysDocument, variables, headers),
      options
    );

useListCategorysQuery.getKey = (variables: ListCategorysQueryVariables) => ['listCategorys', variables];
;

useListCategorysQuery.fetcher = (client: GraphQLClient, variables: ListCategorysQueryVariables, headers?: RequestInit['headers']) => fetcher<ListCategorysQuery, ListCategorysQueryVariables>(client, ListCategorysDocument, variables, headers);
export const AddCategoryDocument = `
    mutation addCategory($mainCategory: String!, $name: String!, $clinic_id: ID!) {
  addCategory(mainCategory: $mainCategory, name: $name, clinic_id: $clinic_id) {
    id
    isDelete
    mainCategory
    name
    clinic_id
  }
}
    `;
export const useAddCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddCategoryMutation, TError, AddCategoryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddCategoryMutation, TError, AddCategoryMutationVariables, TContext>(
      ['addCategory'],
      (variables?: AddCategoryMutationVariables) => fetcher<AddCategoryMutation, AddCategoryMutationVariables>(client, AddCategoryDocument, variables, headers)(),
      options
    );
useAddCategoryMutation.fetcher = (client: GraphQLClient, variables: AddCategoryMutationVariables, headers?: RequestInit['headers']) => fetcher<AddCategoryMutation, AddCategoryMutationVariables>(client, AddCategoryDocument, variables, headers);
export const DeleteCategoryDocument = `
    mutation deleteCategory($id: ID!) {
  deleteCategory(id: $id) {
    id
    isDelete
    mainCategory
    name
  }
}
    `;
export const useDeleteCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteCategoryMutation, TError, DeleteCategoryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteCategoryMutation, TError, DeleteCategoryMutationVariables, TContext>(
      ['deleteCategory'],
      (variables?: DeleteCategoryMutationVariables) => fetcher<DeleteCategoryMutation, DeleteCategoryMutationVariables>(client, DeleteCategoryDocument, variables, headers)(),
      options
    );
useDeleteCategoryMutation.fetcher = (client: GraphQLClient, variables: DeleteCategoryMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteCategoryMutation, DeleteCategoryMutationVariables>(client, DeleteCategoryDocument, variables, headers);
export const UpdateCategoryDocument = `
    mutation updateCategory($id: ID!, $mainCategory: String, $name: String) {
  updateCategory(id: $id, mainCategory: $mainCategory, name: $name) {
    id
    isDelete
    mainCategory
    name
  }
}
    `;
export const useUpdateCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateCategoryMutation, TError, UpdateCategoryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateCategoryMutation, TError, UpdateCategoryMutationVariables, TContext>(
      ['updateCategory'],
      (variables?: UpdateCategoryMutationVariables) => fetcher<UpdateCategoryMutation, UpdateCategoryMutationVariables>(client, UpdateCategoryDocument, variables, headers)(),
      options
    );
useUpdateCategoryMutation.fetcher = (client: GraphQLClient, variables: UpdateCategoryMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateCategoryMutation, UpdateCategoryMutationVariables>(client, UpdateCategoryDocument, variables, headers);
export const TransactDeleteCategorysDocument = `
    mutation transactDeleteCategorys($SDK_IDs: [ID!]!) {
  transactDeleteCategorys(SDK_IDs: $SDK_IDs) {
    TransactReturn
  }
}
    `;
export const useTransactDeleteCategorysMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<TransactDeleteCategorysMutation, TError, TransactDeleteCategorysMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<TransactDeleteCategorysMutation, TError, TransactDeleteCategorysMutationVariables, TContext>(
      ['transactDeleteCategorys'],
      (variables?: TransactDeleteCategorysMutationVariables) => fetcher<TransactDeleteCategorysMutation, TransactDeleteCategorysMutationVariables>(client, TransactDeleteCategorysDocument, variables, headers)(),
      options
    );
useTransactDeleteCategorysMutation.fetcher = (client: GraphQLClient, variables: TransactDeleteCategorysMutationVariables, headers?: RequestInit['headers']) => fetcher<TransactDeleteCategorysMutation, TransactDeleteCategorysMutationVariables>(client, TransactDeleteCategorysDocument, variables, headers);
export const GetMenuDocument = `
    query getMenu($SDK_ID: ID!) {
  getMenu(SDK_ID: $SDK_ID) {
    SDK_ID
    amount
    courponId
    role
    name
    abbreviation
    subCategoryId
    parts
    status
    time
    type
    isDelete
    index
    isPeriodicCheckup
    checkupFrequency
    checkupIntervalDays
  }
}
    `;
export const useGetMenuQuery = <
      TData = GetMenuQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetMenuQueryVariables,
      options?: UseQueryOptions<GetMenuQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetMenuQuery, TError, TData>(
      ['getMenu', variables],
      fetcher<GetMenuQuery, GetMenuQueryVariables>(client, GetMenuDocument, variables, headers),
      options
    );

useGetMenuQuery.getKey = (variables: GetMenuQueryVariables) => ['getMenu', variables];
;

useGetMenuQuery.fetcher = (client: GraphQLClient, variables: GetMenuQueryVariables, headers?: RequestInit['headers']) => fetcher<GetMenuQuery, GetMenuQueryVariables>(client, GetMenuDocument, variables, headers);
export const GetMenuForPhrDocument = `
    mutation getMenuForPHR($SDK_ID: ID!) {
  getMenu(SDK_ID: $SDK_ID) {
    SDK_ID
    amount
    courponId
    role
    name
    abbreviation
    subCategoryId
    status
    time
    type
    isDelete
    index
    isPeriodicCheckup
    checkupFrequency
    checkupIntervalDays
  }
}
    `;
export const useGetMenuForPhrMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GetMenuForPhrMutation, TError, GetMenuForPhrMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GetMenuForPhrMutation, TError, GetMenuForPhrMutationVariables, TContext>(
      ['getMenuForPHR'],
      (variables?: GetMenuForPhrMutationVariables) => fetcher<GetMenuForPhrMutation, GetMenuForPhrMutationVariables>(client, GetMenuForPhrDocument, variables, headers)(),
      options
    );
useGetMenuForPhrMutation.fetcher = (client: GraphQLClient, variables: GetMenuForPhrMutationVariables, headers?: RequestInit['headers']) => fetcher<GetMenuForPhrMutation, GetMenuForPhrMutationVariables>(client, GetMenuForPhrDocument, variables, headers);
export const ListMenuDocument = `
    query listMenu($clinic_id: ID!) {
  listMenu(clinic_id: $clinic_id) {
    Menus {
      amount
      role
      name
      abbreviation
      subCategoryId
      parts
      status
      time
      type
      courponId
      SDK_ID
      isDelete
      index
      clinic_id
      isPeriodicCheckup
      checkupFrequency
      checkupIntervalDays
    }
  }
}
    `;
export const useListMenuQuery = <
      TData = ListMenuQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListMenuQueryVariables,
      options?: UseQueryOptions<ListMenuQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListMenuQuery, TError, TData>(
      ['listMenu', variables],
      fetcher<ListMenuQuery, ListMenuQueryVariables>(client, ListMenuDocument, variables, headers),
      options
    );

useListMenuQuery.getKey = (variables: ListMenuQueryVariables) => ['listMenu', variables];
;

useListMenuQuery.fetcher = (client: GraphQLClient, variables: ListMenuQueryVariables, headers?: RequestInit['headers']) => fetcher<ListMenuQuery, ListMenuQueryVariables>(client, ListMenuDocument, variables, headers);
export const ListMenuNameDocument = `
    query listMenuName($clinic_id: ID!) {
  listMenu(clinic_id: $clinic_id) {
    Menus {
      SDK_ID
      name
      abbreviation
      isDelete
    }
  }
}
    `;
export const useListMenuNameQuery = <
      TData = ListMenuNameQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListMenuNameQueryVariables,
      options?: UseQueryOptions<ListMenuNameQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListMenuNameQuery, TError, TData>(
      ['listMenuName', variables],
      fetcher<ListMenuNameQuery, ListMenuNameQueryVariables>(client, ListMenuNameDocument, variables, headers),
      options
    );

useListMenuNameQuery.getKey = (variables: ListMenuNameQueryVariables) => ['listMenuName', variables];
;

useListMenuNameQuery.fetcher = (client: GraphQLClient, variables: ListMenuNameQueryVariables, headers?: RequestInit['headers']) => fetcher<ListMenuNameQuery, ListMenuNameQueryVariables>(client, ListMenuNameDocument, variables, headers);
export const AddMenuDocument = `
    mutation addMenu($amount: Int, $role: String!, $name: String!, $abbreviation: String, $subCategoryId: ID!, $parts: String, $status: String!, $type: String!, $time: Int, $isDelete: Boolean, $index: Int, $clinic_id: ID!, $isPeriodicCheckup: Boolean, $checkupFrequency: MedicalCheckupFrequency, $checkupIntervalDays: Int) {
  addMenu(amount: $amount, role: $role, name: $name, abbreviation: $abbreviation, subCategoryId: $subCategoryId, parts: $parts, status: $status, time: $time, type: $type, isDelete: $isDelete, index: $index, clinic_id: $clinic_id, isPeriodicCheckup: $isPeriodicCheckup, checkupFrequency: $checkupFrequency, checkupIntervalDays: $checkupIntervalDays) {
    SDK_ID
    amount
    courponId
    role
    name
    abbreviation
    subCategoryId
    parts
    status
    time
    type
    isDelete
    index
    clinic_id
    isPeriodicCheckup
    checkupFrequency
    checkupIntervalDays
  }
}
    `;
export const useAddMenuMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddMenuMutation, TError, AddMenuMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddMenuMutation, TError, AddMenuMutationVariables, TContext>(
      ['addMenu'],
      (variables?: AddMenuMutationVariables) => fetcher<AddMenuMutation, AddMenuMutationVariables>(client, AddMenuDocument, variables, headers)(),
      options
    );
useAddMenuMutation.fetcher = (client: GraphQLClient, variables: AddMenuMutationVariables, headers?: RequestInit['headers']) => fetcher<AddMenuMutation, AddMenuMutationVariables>(client, AddMenuDocument, variables, headers);
export const DeleteMenuDocument = `
    mutation deleteMenu($SDK_ID: ID!) {
  deleteMenu(SDK_ID: $SDK_ID) {
    SDK_ID
    amount
    courponId
    role
    name
    abbreviation
    subCategoryId
    parts
    status
    time
    type
    isDelete
    index
  }
}
    `;
export const useDeleteMenuMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteMenuMutation, TError, DeleteMenuMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteMenuMutation, TError, DeleteMenuMutationVariables, TContext>(
      ['deleteMenu'],
      (variables?: DeleteMenuMutationVariables) => fetcher<DeleteMenuMutation, DeleteMenuMutationVariables>(client, DeleteMenuDocument, variables, headers)(),
      options
    );
useDeleteMenuMutation.fetcher = (client: GraphQLClient, variables: DeleteMenuMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteMenuMutation, DeleteMenuMutationVariables>(client, DeleteMenuDocument, variables, headers);
export const BatchDeleteMenuDocument = `
    mutation batchDeleteMenu($SDK_IDs: [ID!]!) {
  batchDeleteMenu(SDK_IDs: $SDK_IDs) {
    SDK_ID
    amount
    courponId
    role
    name
    abbreviation
    subCategoryId
    parts
    status
    time
    type
    isDelete
    index
  }
}
    `;
export const useBatchDeleteMenuMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<BatchDeleteMenuMutation, TError, BatchDeleteMenuMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<BatchDeleteMenuMutation, TError, BatchDeleteMenuMutationVariables, TContext>(
      ['batchDeleteMenu'],
      (variables?: BatchDeleteMenuMutationVariables) => fetcher<BatchDeleteMenuMutation, BatchDeleteMenuMutationVariables>(client, BatchDeleteMenuDocument, variables, headers)(),
      options
    );
useBatchDeleteMenuMutation.fetcher = (client: GraphQLClient, variables: BatchDeleteMenuMutationVariables, headers?: RequestInit['headers']) => fetcher<BatchDeleteMenuMutation, BatchDeleteMenuMutationVariables>(client, BatchDeleteMenuDocument, variables, headers);
export const UpDateMenuDocument = `
    mutation upDateMenu($SDK_ID: ID!, $amount: Int, $role: String, $name: String, $abbreviation: String, $subCategoryId: ID, $status: String, $type: String, $time: Int, $isDelete: Boolean, $index: Int, $isPeriodicCheckup: Boolean, $checkupFrequency: MedicalCheckupFrequency, $checkupIntervalDays: Int) {
  updateMenu(SDK_ID: $SDK_ID, amount: $amount, role: $role, name: $name, abbreviation: $abbreviation, subCategoryId: $subCategoryId, status: $status, time: $time, type: $type, isDelete: $isDelete, index: $index, isPeriodicCheckup: $isPeriodicCheckup, checkupFrequency: $checkupFrequency, checkupIntervalDays: $checkupIntervalDays) {
    SDK_ID
    amount
    role
    name
    abbreviation
    subCategoryId
    status
    time
    type
    isDelete
    index
    isPeriodicCheckup
    checkupFrequency
    checkupIntervalDays
  }
}
    `;
export const useUpDateMenuMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpDateMenuMutation, TError, UpDateMenuMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpDateMenuMutation, TError, UpDateMenuMutationVariables, TContext>(
      ['upDateMenu'],
      (variables?: UpDateMenuMutationVariables) => fetcher<UpDateMenuMutation, UpDateMenuMutationVariables>(client, UpDateMenuDocument, variables, headers)(),
      options
    );
useUpDateMenuMutation.fetcher = (client: GraphQLClient, variables: UpDateMenuMutationVariables, headers?: RequestInit['headers']) => fetcher<UpDateMenuMutation, UpDateMenuMutationVariables>(client, UpDateMenuDocument, variables, headers);
export const TransactDeleteMenusDocument = `
    mutation transactDeleteMenus($SDK_IDs: [ID!]!) {
  transactDeleteMenus(SDK_IDs: $SDK_IDs) {
    TransactReturn
  }
}
    `;
export const useTransactDeleteMenusMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<TransactDeleteMenusMutation, TError, TransactDeleteMenusMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<TransactDeleteMenusMutation, TError, TransactDeleteMenusMutationVariables, TContext>(
      ['transactDeleteMenus'],
      (variables?: TransactDeleteMenusMutationVariables) => fetcher<TransactDeleteMenusMutation, TransactDeleteMenusMutationVariables>(client, TransactDeleteMenusDocument, variables, headers)(),
      options
    );
useTransactDeleteMenusMutation.fetcher = (client: GraphQLClient, variables: TransactDeleteMenusMutationVariables, headers?: RequestInit['headers']) => fetcher<TransactDeleteMenusMutation, TransactDeleteMenusMutationVariables>(client, TransactDeleteMenusDocument, variables, headers);
export const TransactIndexMenusDocument = `
    mutation transactIndexMenus($ModifyIndexMenus: [ModifyIndexMenus!]!) {
  transactIndexMenus(ModifyIndexMenus: $ModifyIndexMenus) {
    TransactReturn
  }
}
    `;
export const useTransactIndexMenusMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<TransactIndexMenusMutation, TError, TransactIndexMenusMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<TransactIndexMenusMutation, TError, TransactIndexMenusMutationVariables, TContext>(
      ['transactIndexMenus'],
      (variables?: TransactIndexMenusMutationVariables) => fetcher<TransactIndexMenusMutation, TransactIndexMenusMutationVariables>(client, TransactIndexMenusDocument, variables, headers)(),
      options
    );
useTransactIndexMenusMutation.fetcher = (client: GraphQLClient, variables: TransactIndexMenusMutationVariables, headers?: RequestInit['headers']) => fetcher<TransactIndexMenusMutation, TransactIndexMenusMutationVariables>(client, TransactIndexMenusDocument, variables, headers);
export const ListPeriodNotificationDocument = `
    query listPeriodNotification($access_token: String!, $startDate: AWSTimestamp!, $endDate: AWSTimestamp!) {
  listPeriodNotification(endDate: $endDate, access_token: $access_token, startDate: $startDate) {
    Notifications {
      id
      number
      date
      content
      category
    }
  }
}
    `;
export const useListPeriodNotificationQuery = <
      TData = ListPeriodNotificationQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListPeriodNotificationQueryVariables,
      options?: UseQueryOptions<ListPeriodNotificationQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListPeriodNotificationQuery, TError, TData>(
      ['listPeriodNotification', variables],
      fetcher<ListPeriodNotificationQuery, ListPeriodNotificationQueryVariables>(client, ListPeriodNotificationDocument, variables, headers),
      options
    );

useListPeriodNotificationQuery.getKey = (variables: ListPeriodNotificationQueryVariables) => ['listPeriodNotification', variables];
;

useListPeriodNotificationQuery.fetcher = (client: GraphQLClient, variables: ListPeriodNotificationQueryVariables, headers?: RequestInit['headers']) => fetcher<ListPeriodNotificationQuery, ListPeriodNotificationQueryVariables>(client, ListPeriodNotificationDocument, variables, headers);
export const GetOrgDocument = `
    query getOrg($org_id: ID!) {
  getOrg(org_id: $org_id) {
    org_id
    org_label
    org_name
    isDelete
    created_at
    updated_at
  }
}
    `;
export const useGetOrgQuery = <
      TData = GetOrgQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetOrgQueryVariables,
      options?: UseQueryOptions<GetOrgQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetOrgQuery, TError, TData>(
      ['getOrg', variables],
      fetcher<GetOrgQuery, GetOrgQueryVariables>(client, GetOrgDocument, variables, headers),
      options
    );

useGetOrgQuery.getKey = (variables: GetOrgQueryVariables) => ['getOrg', variables];
;

useGetOrgQuery.fetcher = (client: GraphQLClient, variables: GetOrgQueryVariables, headers?: RequestInit['headers']) => fetcher<GetOrgQuery, GetOrgQueryVariables>(client, GetOrgDocument, variables, headers);
export const GetOrgLabelDocument = `
    query getOrgLabel($org_id: ID!) {
  getOrg(org_id: $org_id) {
    org_label
  }
}
    `;
export const useGetOrgLabelQuery = <
      TData = GetOrgLabelQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetOrgLabelQueryVariables,
      options?: UseQueryOptions<GetOrgLabelQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetOrgLabelQuery, TError, TData>(
      ['getOrgLabel', variables],
      fetcher<GetOrgLabelQuery, GetOrgLabelQueryVariables>(client, GetOrgLabelDocument, variables, headers),
      options
    );

useGetOrgLabelQuery.getKey = (variables: GetOrgLabelQueryVariables) => ['getOrgLabel', variables];
;

useGetOrgLabelQuery.fetcher = (client: GraphQLClient, variables: GetOrgLabelQueryVariables, headers?: RequestInit['headers']) => fetcher<GetOrgLabelQuery, GetOrgLabelQueryVariables>(client, GetOrgLabelDocument, variables, headers);
export const ListPatientsByNameV2Document = `
    query listPatientsByNameV2($clinic_id: ID!, $name: String!) {
  listPatientsByNameV2(clinic_id: $clinic_id, name: $name) {
    Patients {
      ...PatientFieldsV2
    }
  }
}
    ${PatientFieldsV2FragmentDoc}`;
export const useListPatientsByNameV2Query = <
      TData = ListPatientsByNameV2Query,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListPatientsByNameV2QueryVariables,
      options?: UseQueryOptions<ListPatientsByNameV2Query, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListPatientsByNameV2Query, TError, TData>(
      ['listPatientsByNameV2', variables],
      fetcher<ListPatientsByNameV2Query, ListPatientsByNameV2QueryVariables>(client, ListPatientsByNameV2Document, variables, headers),
      options
    );

useListPatientsByNameV2Query.getKey = (variables: ListPatientsByNameV2QueryVariables) => ['listPatientsByNameV2', variables];
;

useListPatientsByNameV2Query.fetcher = (client: GraphQLClient, variables: ListPatientsByNameV2QueryVariables, headers?: RequestInit['headers']) => fetcher<ListPatientsByNameV2Query, ListPatientsByNameV2QueryVariables>(client, ListPatientsByNameV2Document, variables, headers);
export const GetPatientByIdV2Document = `
    query getPatientByIdV2($clinic_id: ID!, $id: ID!) {
  getPatientByIdV2(clinic_id: $clinic_id, id: $id) {
    ...PatientFieldsV2
  }
}
    ${PatientFieldsV2FragmentDoc}`;
export const useGetPatientByIdV2Query = <
      TData = GetPatientByIdV2Query,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPatientByIdV2QueryVariables,
      options?: UseQueryOptions<GetPatientByIdV2Query, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPatientByIdV2Query, TError, TData>(
      ['getPatientByIdV2', variables],
      fetcher<GetPatientByIdV2Query, GetPatientByIdV2QueryVariables>(client, GetPatientByIdV2Document, variables, headers),
      options
    );

useGetPatientByIdV2Query.getKey = (variables: GetPatientByIdV2QueryVariables) => ['getPatientByIdV2', variables];
;

useGetPatientByIdV2Query.fetcher = (client: GraphQLClient, variables: GetPatientByIdV2QueryVariables, headers?: RequestInit['headers']) => fetcher<GetPatientByIdV2Query, GetPatientByIdV2QueryVariables>(client, GetPatientByIdV2Document, variables, headers);
export const GetPatientNameForAddNewAppointDocument = `
    query getPatientNameForAddNewAppoint($clinic_id: ID!, $id: ID!) {
  getPatientNameByIdV2(clinic_id: $clinic_id, id: $id) {
    displayName
  }
}
    `;
export const useGetPatientNameForAddNewAppointQuery = <
      TData = GetPatientNameForAddNewAppointQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPatientNameForAddNewAppointQueryVariables,
      options?: UseQueryOptions<GetPatientNameForAddNewAppointQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPatientNameForAddNewAppointQuery, TError, TData>(
      ['getPatientNameForAddNewAppoint', variables],
      fetcher<GetPatientNameForAddNewAppointQuery, GetPatientNameForAddNewAppointQueryVariables>(client, GetPatientNameForAddNewAppointDocument, variables, headers),
      options
    );

useGetPatientNameForAddNewAppointQuery.getKey = (variables: GetPatientNameForAddNewAppointQueryVariables) => ['getPatientNameForAddNewAppoint', variables];
;

useGetPatientNameForAddNewAppointQuery.fetcher = (client: GraphQLClient, variables: GetPatientNameForAddNewAppointQueryVariables, headers?: RequestInit['headers']) => fetcher<GetPatientNameForAddNewAppointQuery, GetPatientNameForAddNewAppointQueryVariables>(client, GetPatientNameForAddNewAppointDocument, variables, headers);
export const ListPatientsV2Document = `
    query listPatientsV2($clinic_id: ID!) {
  listPatientsV2(clinic_id: $clinic_id) {
    Patients {
      ...PatientFieldsV2
    }
  }
}
    ${PatientFieldsV2FragmentDoc}`;
export const useListPatientsV2Query = <
      TData = ListPatientsV2Query,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListPatientsV2QueryVariables,
      options?: UseQueryOptions<ListPatientsV2Query, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListPatientsV2Query, TError, TData>(
      ['listPatientsV2', variables],
      fetcher<ListPatientsV2Query, ListPatientsV2QueryVariables>(client, ListPatientsV2Document, variables, headers),
      options
    );

useListPatientsV2Query.getKey = (variables: ListPatientsV2QueryVariables) => ['listPatientsV2', variables];
;

useListPatientsV2Query.fetcher = (client: GraphQLClient, variables: ListPatientsV2QueryVariables, headers?: RequestInit['headers']) => fetcher<ListPatientsV2Query, ListPatientsV2QueryVariables>(client, ListPatientsV2Document, variables, headers);
export const CheckForDuplicateCardNumbersDocument = `
    query CheckForDuplicateCardNumbers($inputs: checkForDuplicateCardNumbersInput!) {
  checkForDuplicateCardNumbers(inputs: $inputs) {
    isDuplicate
  }
}
    `;
export const useCheckForDuplicateCardNumbersQuery = <
      TData = CheckForDuplicateCardNumbersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CheckForDuplicateCardNumbersQueryVariables,
      options?: UseQueryOptions<CheckForDuplicateCardNumbersQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CheckForDuplicateCardNumbersQuery, TError, TData>(
      ['CheckForDuplicateCardNumbers', variables],
      fetcher<CheckForDuplicateCardNumbersQuery, CheckForDuplicateCardNumbersQueryVariables>(client, CheckForDuplicateCardNumbersDocument, variables, headers),
      options
    );

useCheckForDuplicateCardNumbersQuery.getKey = (variables: CheckForDuplicateCardNumbersQueryVariables) => ['CheckForDuplicateCardNumbers', variables];
;

useCheckForDuplicateCardNumbersQuery.fetcher = (client: GraphQLClient, variables: CheckForDuplicateCardNumbersQueryVariables, headers?: RequestInit['headers']) => fetcher<CheckForDuplicateCardNumbersQuery, CheckForDuplicateCardNumbersQueryVariables>(client, CheckForDuplicateCardNumbersDocument, variables, headers);
export const ListPatientsByIdPaginatedDocument = `
    query listPatientsByIdPaginated($clinic_id: ID!, $lastEvaluatedKey: InputLastEvaluatedKey, $orderOption: InputOrderOption, $filterOption: InputFilterOption, $withDeleted: Boolean) {
  listPatientsByIdPaginated(clinic_id: $clinic_id, lastEvaluatedKey: $lastEvaluatedKey, orderOption: $orderOption, filterOption: $filterOption, withDeleted: $withDeleted) {
    Patients {
      ...PatientFieldsV2
    }
    lastEvaluatedKey {
      id
      clinic_id
      clinicIdWithDeleted
      kanaName
      patientCardNumber
      phoneNumber
    }
  }
}
    ${PatientFieldsV2FragmentDoc}`;
export const useListPatientsByIdPaginatedQuery = <
      TData = ListPatientsByIdPaginatedQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListPatientsByIdPaginatedQueryVariables,
      options?: UseQueryOptions<ListPatientsByIdPaginatedQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListPatientsByIdPaginatedQuery, TError, TData>(
      ['listPatientsByIdPaginated', variables],
      fetcher<ListPatientsByIdPaginatedQuery, ListPatientsByIdPaginatedQueryVariables>(client, ListPatientsByIdPaginatedDocument, variables, headers),
      options
    );

useListPatientsByIdPaginatedQuery.getKey = (variables: ListPatientsByIdPaginatedQueryVariables) => ['listPatientsByIdPaginated', variables];
;

useListPatientsByIdPaginatedQuery.fetcher = (client: GraphQLClient, variables: ListPatientsByIdPaginatedQueryVariables, headers?: RequestInit['headers']) => fetcher<ListPatientsByIdPaginatedQuery, ListPatientsByIdPaginatedQueryVariables>(client, ListPatientsByIdPaginatedDocument, variables, headers);
export const AddPatientByIdV2Document = `
    mutation addPatientByIdV2($input: PatientInputV2!) {
  addPatientByIdV2(input: $input) {
    ...PatientFieldsV2
  }
}
    ${PatientFieldsV2FragmentDoc}`;
export const useAddPatientByIdV2Mutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddPatientByIdV2Mutation, TError, AddPatientByIdV2MutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddPatientByIdV2Mutation, TError, AddPatientByIdV2MutationVariables, TContext>(
      ['addPatientByIdV2'],
      (variables?: AddPatientByIdV2MutationVariables) => fetcher<AddPatientByIdV2Mutation, AddPatientByIdV2MutationVariables>(client, AddPatientByIdV2Document, variables, headers)(),
      options
    );
useAddPatientByIdV2Mutation.fetcher = (client: GraphQLClient, variables: AddPatientByIdV2MutationVariables, headers?: RequestInit['headers']) => fetcher<AddPatientByIdV2Mutation, AddPatientByIdV2MutationVariables>(client, AddPatientByIdV2Document, variables, headers);
export const UpdatePatientByIdV2Document = `
    mutation updatePatientByIdV2($id: ID!, $input: PatientInputV2!) {
  updatePatientByIdV2(id: $id, input: $input) {
    ...PatientFieldsV2
  }
}
    ${PatientFieldsV2FragmentDoc}`;
export const useUpdatePatientByIdV2Mutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdatePatientByIdV2Mutation, TError, UpdatePatientByIdV2MutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdatePatientByIdV2Mutation, TError, UpdatePatientByIdV2MutationVariables, TContext>(
      ['updatePatientByIdV2'],
      (variables?: UpdatePatientByIdV2MutationVariables) => fetcher<UpdatePatientByIdV2Mutation, UpdatePatientByIdV2MutationVariables>(client, UpdatePatientByIdV2Document, variables, headers)(),
      options
    );
useUpdatePatientByIdV2Mutation.fetcher = (client: GraphQLClient, variables: UpdatePatientByIdV2MutationVariables, headers?: RequestInit['headers']) => fetcher<UpdatePatientByIdV2Mutation, UpdatePatientByIdV2MutationVariables>(client, UpdatePatientByIdV2Document, variables, headers);
export const DeletePatientByIdV2Document = `
    mutation deletePatientByIdV2($clinic_id: ID!, $id: ID!) {
  deletePatientByIdV2(clinic_id: $clinic_id, id: $id) {
    id
    status: isDeleted
  }
}
    `;
export const useDeletePatientByIdV2Mutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeletePatientByIdV2Mutation, TError, DeletePatientByIdV2MutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeletePatientByIdV2Mutation, TError, DeletePatientByIdV2MutationVariables, TContext>(
      ['deletePatientByIdV2'],
      (variables?: DeletePatientByIdV2MutationVariables) => fetcher<DeletePatientByIdV2Mutation, DeletePatientByIdV2MutationVariables>(client, DeletePatientByIdV2Document, variables, headers)(),
      options
    );
useDeletePatientByIdV2Mutation.fetcher = (client: GraphQLClient, variables: DeletePatientByIdV2MutationVariables, headers?: RequestInit['headers']) => fetcher<DeletePatientByIdV2Mutation, DeletePatientByIdV2MutationVariables>(client, DeletePatientByIdV2Document, variables, headers);
export const AddPatientsFromCsvDocument = `
    mutation addPatientsFromCsv($clinic_id: ID!, $csv: String!) {
  addPatientsFromCsv(clinic_id: $clinic_id, csv: $csv)
}
    `;
export const useAddPatientsFromCsvMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddPatientsFromCsvMutation, TError, AddPatientsFromCsvMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddPatientsFromCsvMutation, TError, AddPatientsFromCsvMutationVariables, TContext>(
      ['addPatientsFromCsv'],
      (variables?: AddPatientsFromCsvMutationVariables) => fetcher<AddPatientsFromCsvMutation, AddPatientsFromCsvMutationVariables>(client, AddPatientsFromCsvDocument, variables, headers)(),
      options
    );
useAddPatientsFromCsvMutation.fetcher = (client: GraphQLClient, variables: AddPatientsFromCsvMutationVariables, headers?: RequestInit['headers']) => fetcher<AddPatientsFromCsvMutation, AddPatientsFromCsvMutationVariables>(client, AddPatientsFromCsvDocument, variables, headers);
export const ListRecallItemsDocument = `
    query listRecallItems($filter: RecallFilterInput) {
  listRecallItems(filter: $filter) {
    id
    clinic_id
    patientId
    appointId
    medicalMenuId
    lastTreatmentDate
    nextDueDate
    daysUntilDue
    status
    createdAt
    updatedAt
    patient {
      id
      name {
        first
        last
      }
      SNumber
    }
    medicalMenu {
      SDK_ID
      name
    }
  }
}
    `;
export const useListRecallItemsQuery = <
      TData = ListRecallItemsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ListRecallItemsQueryVariables,
      options?: UseQueryOptions<ListRecallItemsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListRecallItemsQuery, TError, TData>(
      variables === undefined ? ['listRecallItems'] : ['listRecallItems', variables],
      fetcher<ListRecallItemsQuery, ListRecallItemsQueryVariables>(client, ListRecallItemsDocument, variables, headers),
      options
    );

useListRecallItemsQuery.getKey = (variables?: ListRecallItemsQueryVariables) => variables === undefined ? ['listRecallItems'] : ['listRecallItems', variables];
;

useListRecallItemsQuery.fetcher = (client: GraphQLClient, variables?: ListRecallItemsQueryVariables, headers?: RequestInit['headers']) => fetcher<ListRecallItemsQuery, ListRecallItemsQueryVariables>(client, ListRecallItemsDocument, variables, headers);
export const ListRecallItemsByClinicDocument = `
    query listRecallItemsByClinic($clinic_id: String!) {
  listRecallItems(filter: {clinic_id: $clinic_id}) {
    id
    clinic_id
    patientId
    appointId
    medicalMenuId
    lastTreatmentDate
    nextDueDate
    daysUntilDue
    status
    createdAt
    updatedAt
    patient {
      id
      name {
        first
        last
      }
      SNumber
    }
    medicalMenu {
      SDK_ID
      name
    }
  }
}
    `;
export const useListRecallItemsByClinicQuery = <
      TData = ListRecallItemsByClinicQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListRecallItemsByClinicQueryVariables,
      options?: UseQueryOptions<ListRecallItemsByClinicQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListRecallItemsByClinicQuery, TError, TData>(
      ['listRecallItemsByClinic', variables],
      fetcher<ListRecallItemsByClinicQuery, ListRecallItemsByClinicQueryVariables>(client, ListRecallItemsByClinicDocument, variables, headers),
      options
    );

useListRecallItemsByClinicQuery.getKey = (variables: ListRecallItemsByClinicQueryVariables) => ['listRecallItemsByClinic', variables];
;

useListRecallItemsByClinicQuery.fetcher = (client: GraphQLClient, variables: ListRecallItemsByClinicQueryVariables, headers?: RequestInit['headers']) => fetcher<ListRecallItemsByClinicQuery, ListRecallItemsByClinicQueryVariables>(client, ListRecallItemsByClinicDocument, variables, headers);
export const ListRecallItemsByClinicAndStatusDocument = `
    query listRecallItemsByClinicAndStatus($clinic_id: String!, $status: RecallStatus) {
  listRecallItems(filter: {clinic_id: $clinic_id, status: $status}) {
    id
    clinic_id
    patientId
    appointId
    medicalMenuId
    lastTreatmentDate
    nextDueDate
    daysUntilDue
    status
    createdAt
    updatedAt
    patient {
      id
      name {
        first
        last
      }
      SNumber
    }
    medicalMenu {
      SDK_ID
      name
    }
  }
}
    `;
export const useListRecallItemsByClinicAndStatusQuery = <
      TData = ListRecallItemsByClinicAndStatusQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListRecallItemsByClinicAndStatusQueryVariables,
      options?: UseQueryOptions<ListRecallItemsByClinicAndStatusQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListRecallItemsByClinicAndStatusQuery, TError, TData>(
      ['listRecallItemsByClinicAndStatus', variables],
      fetcher<ListRecallItemsByClinicAndStatusQuery, ListRecallItemsByClinicAndStatusQueryVariables>(client, ListRecallItemsByClinicAndStatusDocument, variables, headers),
      options
    );

useListRecallItemsByClinicAndStatusQuery.getKey = (variables: ListRecallItemsByClinicAndStatusQueryVariables) => ['listRecallItemsByClinicAndStatus', variables];
;

useListRecallItemsByClinicAndStatusQuery.fetcher = (client: GraphQLClient, variables: ListRecallItemsByClinicAndStatusQueryVariables, headers?: RequestInit['headers']) => fetcher<ListRecallItemsByClinicAndStatusQuery, ListRecallItemsByClinicAndStatusQueryVariables>(client, ListRecallItemsByClinicAndStatusDocument, variables, headers);
export const GetRecallItemDocument = `
    query getRecallItem($id: ID!, $clinic_id: String!) {
  getRecallItem(id: $id, clinic_id: $clinic_id) {
    id
    clinic_id
    patientId
    appointId
    medicalMenuId
    lastTreatmentDate
    nextDueDate
    daysUntilDue
    status
    createdAt
    updatedAt
    patient {
      id
      name {
        first
        last
      }
      SNumber
    }
    medicalMenu {
      SDK_ID
      name
    }
  }
}
    `;
export const useGetRecallItemQuery = <
      TData = GetRecallItemQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetRecallItemQueryVariables,
      options?: UseQueryOptions<GetRecallItemQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetRecallItemQuery, TError, TData>(
      ['getRecallItem', variables],
      fetcher<GetRecallItemQuery, GetRecallItemQueryVariables>(client, GetRecallItemDocument, variables, headers),
      options
    );

useGetRecallItemQuery.getKey = (variables: GetRecallItemQueryVariables) => ['getRecallItem', variables];
;

useGetRecallItemQuery.fetcher = (client: GraphQLClient, variables: GetRecallItemQueryVariables, headers?: RequestInit['headers']) => fetcher<GetRecallItemQuery, GetRecallItemQueryVariables>(client, GetRecallItemDocument, variables, headers);
export const ListRecallItemsByPatientDocument = `
    query listRecallItemsByPatient($patientId: ID!, $clinic_id: String!) {
  listRecallItems(filter: {patientId: $patientId, clinic_id: $clinic_id}) {
    id
    clinic_id
    medicalMenuId
    appointId
    lastTreatmentDate
    nextDueDate
    daysUntilDue
    status
    createdAt
    updatedAt
    patient {
      id
      name {
        first
        last
      }
      SNumber
    }
    medicalMenu {
      SDK_ID
      name
    }
  }
}
    `;
export const useListRecallItemsByPatientQuery = <
      TData = ListRecallItemsByPatientQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListRecallItemsByPatientQueryVariables,
      options?: UseQueryOptions<ListRecallItemsByPatientQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListRecallItemsByPatientQuery, TError, TData>(
      ['listRecallItemsByPatient', variables],
      fetcher<ListRecallItemsByPatientQuery, ListRecallItemsByPatientQueryVariables>(client, ListRecallItemsByPatientDocument, variables, headers),
      options
    );

useListRecallItemsByPatientQuery.getKey = (variables: ListRecallItemsByPatientQueryVariables) => ['listRecallItemsByPatient', variables];
;

useListRecallItemsByPatientQuery.fetcher = (client: GraphQLClient, variables: ListRecallItemsByPatientQueryVariables, headers?: RequestInit['headers']) => fetcher<ListRecallItemsByPatientQuery, ListRecallItemsByPatientQueryVariables>(client, ListRecallItemsByPatientDocument, variables, headers);
export const ListUpcomingRecallItemsDocument = `
    query listUpcomingRecallItems($clinic_id: String!, $daysUntilDue: Int) {
  listRecallItems(filter: {clinic_id: $clinic_id, daysUntilDue: $daysUntilDue, status: PENDING}) {
    id
    clinic_id
    patientId
    appointId
    medicalMenuId
    lastTreatmentDate
    nextDueDate
    daysUntilDue
    status
    createdAt
    updatedAt
    patient {
      id
      name {
        first
        last
      }
      SNumber
    }
    medicalMenu {
      SDK_ID
      name
    }
  }
}
    `;
export const useListUpcomingRecallItemsQuery = <
      TData = ListUpcomingRecallItemsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListUpcomingRecallItemsQueryVariables,
      options?: UseQueryOptions<ListUpcomingRecallItemsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListUpcomingRecallItemsQuery, TError, TData>(
      ['listUpcomingRecallItems', variables],
      fetcher<ListUpcomingRecallItemsQuery, ListUpcomingRecallItemsQueryVariables>(client, ListUpcomingRecallItemsDocument, variables, headers),
      options
    );

useListUpcomingRecallItemsQuery.getKey = (variables: ListUpcomingRecallItemsQueryVariables) => ['listUpcomingRecallItems', variables];
;

useListUpcomingRecallItemsQuery.fetcher = (client: GraphQLClient, variables: ListUpcomingRecallItemsQueryVariables, headers?: RequestInit['headers']) => fetcher<ListUpcomingRecallItemsQuery, ListUpcomingRecallItemsQueryVariables>(client, ListUpcomingRecallItemsDocument, variables, headers);
export const AddRecallDocument = `
    mutation addRecall($input: CreateRecallInput!) {
  addRecall(input: $input) {
    id
    clinic_id
    patientId
    appointId
    medicalMenuId
    lastTreatmentDate
    nextDueDate
    daysUntilDue
    status
    createdAt
    updatedAt
  }
}
    `;
export const useAddRecallMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddRecallMutation, TError, AddRecallMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddRecallMutation, TError, AddRecallMutationVariables, TContext>(
      ['addRecall'],
      (variables?: AddRecallMutationVariables) => fetcher<AddRecallMutation, AddRecallMutationVariables>(client, AddRecallDocument, variables, headers)(),
      options
    );
useAddRecallMutation.fetcher = (client: GraphQLClient, variables: AddRecallMutationVariables, headers?: RequestInit['headers']) => fetcher<AddRecallMutation, AddRecallMutationVariables>(client, AddRecallDocument, variables, headers);
export const UpdateRecallStatusDocument = `
    mutation updateRecallStatus($id: ID!, $status: RecallStatus!, $clinic_id: String!) {
  updateRecallStatus(id: $id, status: $status, clinic_id: $clinic_id) {
    id
    status
    updatedAt
  }
}
    `;
export const useUpdateRecallStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateRecallStatusMutation, TError, UpdateRecallStatusMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateRecallStatusMutation, TError, UpdateRecallStatusMutationVariables, TContext>(
      ['updateRecallStatus'],
      (variables?: UpdateRecallStatusMutationVariables) => fetcher<UpdateRecallStatusMutation, UpdateRecallStatusMutationVariables>(client, UpdateRecallStatusDocument, variables, headers)(),
      options
    );
useUpdateRecallStatusMutation.fetcher = (client: GraphQLClient, variables: UpdateRecallStatusMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateRecallStatusMutation, UpdateRecallStatusMutationVariables>(client, UpdateRecallStatusDocument, variables, headers);
export const DeleteRecallDocument = `
    mutation deleteRecall($id: ID!) {
  deleteRecall(id: $id)
}
    `;
export const useDeleteRecallMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteRecallMutation, TError, DeleteRecallMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteRecallMutation, TError, DeleteRecallMutationVariables, TContext>(
      ['deleteRecall'],
      (variables?: DeleteRecallMutationVariables) => fetcher<DeleteRecallMutation, DeleteRecallMutationVariables>(client, DeleteRecallDocument, variables, headers)(),
      options
    );
useDeleteRecallMutation.fetcher = (client: GraphQLClient, variables: DeleteRecallMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteRecallMutation, DeleteRecallMutationVariables>(client, DeleteRecallDocument, variables, headers);
export const ListRecallItemsByClinicPatientAndMenuDocument = `
    query listRecallItemsByClinicPatientAndMenu($clinic_id: String!, $patientId: ID, $medicalMenuId: String) {
  listRecallItems(filter: {clinic_id: $clinic_id, patientId: $patientId, medicalMenuId: $medicalMenuId}) {
    id
    status
    nextDueDate
    lastTreatmentDate
  }
}
    `;
export const useListRecallItemsByClinicPatientAndMenuQuery = <
      TData = ListRecallItemsByClinicPatientAndMenuQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListRecallItemsByClinicPatientAndMenuQueryVariables,
      options?: UseQueryOptions<ListRecallItemsByClinicPatientAndMenuQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListRecallItemsByClinicPatientAndMenuQuery, TError, TData>(
      ['listRecallItemsByClinicPatientAndMenu', variables],
      fetcher<ListRecallItemsByClinicPatientAndMenuQuery, ListRecallItemsByClinicPatientAndMenuQueryVariables>(client, ListRecallItemsByClinicPatientAndMenuDocument, variables, headers),
      options
    );

useListRecallItemsByClinicPatientAndMenuQuery.getKey = (variables: ListRecallItemsByClinicPatientAndMenuQueryVariables) => ['listRecallItemsByClinicPatientAndMenu', variables];
;

useListRecallItemsByClinicPatientAndMenuQuery.fetcher = (client: GraphQLClient, variables: ListRecallItemsByClinicPatientAndMenuQueryVariables, headers?: RequestInit['headers']) => fetcher<ListRecallItemsByClinicPatientAndMenuQuery, ListRecallItemsByClinicPatientAndMenuQueryVariables>(client, ListRecallItemsByClinicPatientAndMenuDocument, variables, headers);
export const GetFormDocument = `
    query getForm($access_token: String!) {
  getForm(access_token: $access_token) {
    common {
      Q1 {
        answerQ1
        diseaseQ1
        selected_clinicQ1
        selected_medicineQ1
      }
      Q2 {
        answerQ2
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        selectedQ3
      }
      Q4 {
        answerQ4
        selectedQ4
        selected_optionsQ4
      }
      Q5 {
        answerQ5
      }
      Q6 {
        answerQ6
        commentQ6
        dateQ6
        selectedQ6
      }
    }
    dental {
      Q1 {
        commentQ1
        dateQ1
        selectedQ1
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        selectedQ3
        commentQ3
      }
      Q4 {
        selectedQ4
      }
      Q5 {
        selectedQ5
      }
    }
    medical {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q2 {
        bodyQ2
        commentQ2
        faceQ2
      }
      Q3 {
        answerQ3
        clinic_anotherQ3
        clinic_otherQ3
        clinic_salonQ3
        selected_fatDissolvingQ3
        selected_laserQ3
        selected_peelingQ3
      }
      Q4 {
        constipationQ4
        favoriteQ4
        selectedQ4
        sleepQ4
        stomachQ4
        ultravioletRaysQ4
      }
      Q5 {
        doctorsCosmeQ5
        selectedQ5
        skincareItemQ5
      }
      Q6 {
        commentQ6
        selectedQ6
      }
    }
    orthodontics {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q10 {
        commentQ10
        selectedQ10
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        dateQ3
      }
      Q4 {
        answerQ4
        dateQ4
      }
      Q5 {
        commentQ5
        dateQ5
        selectedQ5
      }
      Q6 {
        selectedQ6
      }
      Q7 {
        commentQ7
        selectedQ7
      }
      Q8 {
        answerQ8
      }
      Q9 {
        selectedQ9
      }
    }
  }
}
    `;
export const useGetFormQuery = <
      TData = GetFormQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetFormQueryVariables,
      options?: UseQueryOptions<GetFormQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetFormQuery, TError, TData>(
      ['getForm', variables],
      fetcher<GetFormQuery, GetFormQueryVariables>(client, GetFormDocument, variables, headers),
      options
    );

useGetFormQuery.getKey = (variables: GetFormQueryVariables) => ['getForm', variables];
;

useGetFormQuery.fetcher = (client: GraphQLClient, variables: GetFormQueryVariables, headers?: RequestInit['headers']) => fetcher<GetFormQuery, GetFormQueryVariables>(client, GetFormDocument, variables, headers);
export const GetCommonFormByIdDocument = `
    query getCommonFormById($id: ID!) {
  getFormById(id: $id) {
    common {
      Q1 {
        answerQ1
        diseaseQ1
        selected_clinicQ1
        selected_medicineQ1
      }
      Q2 {
        answerQ2
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        selectedQ3
      }
      Q4 {
        answerQ4
        selectedQ4
        selected_optionsQ4
      }
      Q5 {
        answerQ5
      }
      Q6 {
        answerQ6
        commentQ6
        dateQ6
        selectedQ6
      }
    }
  }
}
    `;
export const useGetCommonFormByIdQuery = <
      TData = GetCommonFormByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetCommonFormByIdQueryVariables,
      options?: UseQueryOptions<GetCommonFormByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCommonFormByIdQuery, TError, TData>(
      ['getCommonFormById', variables],
      fetcher<GetCommonFormByIdQuery, GetCommonFormByIdQueryVariables>(client, GetCommonFormByIdDocument, variables, headers),
      options
    );

useGetCommonFormByIdQuery.getKey = (variables: GetCommonFormByIdQueryVariables) => ['getCommonFormById', variables];
;

useGetCommonFormByIdQuery.fetcher = (client: GraphQLClient, variables: GetCommonFormByIdQueryVariables, headers?: RequestInit['headers']) => fetcher<GetCommonFormByIdQuery, GetCommonFormByIdQueryVariables>(client, GetCommonFormByIdDocument, variables, headers);
export const GetMedicalFormByIdDocument = `
    query getMedicalFormById($id: ID!) {
  getFormById(id: $id) {
    medical {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q2 {
        bodyQ2
        commentQ2
        faceQ2
      }
      Q3 {
        answerQ3
        clinic_anotherQ3
        clinic_otherQ3
        clinic_salonQ3
        selectedQ3
        selected_fatDissolvingQ3
        selected_laserQ3
        selected_peelingQ3
      }
      Q4 {
        commentQ4
        constipationQ4
        favoriteQ4
        selectedQ4
        sleepQ4
        stomachQ4
        ultravioletRaysQ4
      }
      Q5 {
        doctorsCosmeQ5
        selectedQ5
        skincareItemQ5
      }
      Q6 {
        commentQ6
        selectedQ6
      }
    }
  }
}
    `;
export const useGetMedicalFormByIdQuery = <
      TData = GetMedicalFormByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetMedicalFormByIdQueryVariables,
      options?: UseQueryOptions<GetMedicalFormByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetMedicalFormByIdQuery, TError, TData>(
      ['getMedicalFormById', variables],
      fetcher<GetMedicalFormByIdQuery, GetMedicalFormByIdQueryVariables>(client, GetMedicalFormByIdDocument, variables, headers),
      options
    );

useGetMedicalFormByIdQuery.getKey = (variables: GetMedicalFormByIdQueryVariables) => ['getMedicalFormById', variables];
;

useGetMedicalFormByIdQuery.fetcher = (client: GraphQLClient, variables: GetMedicalFormByIdQueryVariables, headers?: RequestInit['headers']) => fetcher<GetMedicalFormByIdQuery, GetMedicalFormByIdQueryVariables>(client, GetMedicalFormByIdDocument, variables, headers);
export const GetDentalFormByIdDocument = `
    query getDentalFormById($id: ID!) {
  getFormById(id: $id) {
    dental {
      Q1 {
        commentQ1
        dateQ1
        selectedQ1
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        selectedQ3
      }
      Q4 {
        selectedQ4
      }
      Q5 {
        selectedQ5
      }
    }
  }
}
    `;
export const useGetDentalFormByIdQuery = <
      TData = GetDentalFormByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetDentalFormByIdQueryVariables,
      options?: UseQueryOptions<GetDentalFormByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetDentalFormByIdQuery, TError, TData>(
      ['getDentalFormById', variables],
      fetcher<GetDentalFormByIdQuery, GetDentalFormByIdQueryVariables>(client, GetDentalFormByIdDocument, variables, headers),
      options
    );

useGetDentalFormByIdQuery.getKey = (variables: GetDentalFormByIdQueryVariables) => ['getDentalFormById', variables];
;

useGetDentalFormByIdQuery.fetcher = (client: GraphQLClient, variables: GetDentalFormByIdQueryVariables, headers?: RequestInit['headers']) => fetcher<GetDentalFormByIdQuery, GetDentalFormByIdQueryVariables>(client, GetDentalFormByIdDocument, variables, headers);
export const GetOrthodonticsFormByIdDocument = `
    query getOrthodonticsFormById($id: ID!) {
  getFormById(id: $id) {
    orthodontics {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        dateQ3
      }
      Q4 {
        answerQ4
        dateQ4
      }
      Q5 {
        commentQ5
        dateQ5
        selectedQ5
      }
      Q6 {
        selectedQ6
      }
      Q7 {
        commentQ7
        selectedQ7
      }
      Q8 {
        answerQ8
      }
      Q9 {
        selectedQ9
      }
      Q10 {
        commentQ10
        selectedQ10
      }
    }
  }
}
    `;
export const useGetOrthodonticsFormByIdQuery = <
      TData = GetOrthodonticsFormByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetOrthodonticsFormByIdQueryVariables,
      options?: UseQueryOptions<GetOrthodonticsFormByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetOrthodonticsFormByIdQuery, TError, TData>(
      ['getOrthodonticsFormById', variables],
      fetcher<GetOrthodonticsFormByIdQuery, GetOrthodonticsFormByIdQueryVariables>(client, GetOrthodonticsFormByIdDocument, variables, headers),
      options
    );

useGetOrthodonticsFormByIdQuery.getKey = (variables: GetOrthodonticsFormByIdQueryVariables) => ['getOrthodonticsFormById', variables];
;

useGetOrthodonticsFormByIdQuery.fetcher = (client: GraphQLClient, variables: GetOrthodonticsFormByIdQueryVariables, headers?: RequestInit['headers']) => fetcher<GetOrthodonticsFormByIdQuery, GetOrthodonticsFormByIdQueryVariables>(client, GetOrthodonticsFormByIdDocument, variables, headers);
export const AddCommonFormDocument = `
    mutation addCommonForm($access_token: String!, $common: CommonInput!) {
  addForm(access_token: $access_token, common: $common) {
    common {
      Q1 {
        answerQ1
        diseaseQ1
        selected_clinicQ1
        selected_medicineQ1
      }
      Q2 {
        answerQ2
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        selectedQ3
      }
      Q4 {
        answerQ4
        selectedQ4
        selected_optionsQ4
      }
      Q5 {
        answerQ5
      }
      Q6 {
        answerQ6
        dateQ6
        commentQ6
        selectedQ6
      }
    }
  }
}
    `;
export const useAddCommonFormMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddCommonFormMutation, TError, AddCommonFormMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddCommonFormMutation, TError, AddCommonFormMutationVariables, TContext>(
      ['addCommonForm'],
      (variables?: AddCommonFormMutationVariables) => fetcher<AddCommonFormMutation, AddCommonFormMutationVariables>(client, AddCommonFormDocument, variables, headers)(),
      options
    );
useAddCommonFormMutation.fetcher = (client: GraphQLClient, variables: AddCommonFormMutationVariables, headers?: RequestInit['headers']) => fetcher<AddCommonFormMutation, AddCommonFormMutationVariables>(client, AddCommonFormDocument, variables, headers);
export const AddCommonFormByIdDocument = `
    mutation addCommonFormById($id: ID!, $common: CommonInput!) {
  addFormById(id: $id, common: $common) {
    common {
      Q1 {
        answerQ1
        diseaseQ1
        selected_clinicQ1
        selected_medicineQ1
      }
      Q2 {
        answerQ2
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        selectedQ3
      }
      Q4 {
        answerQ4
        selectedQ4
        selected_optionsQ4
      }
      Q5 {
        answerQ5
      }
      Q6 {
        answerQ6
        dateQ6
        commentQ6
        selectedQ6
      }
    }
  }
}
    `;
export const useAddCommonFormByIdMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddCommonFormByIdMutation, TError, AddCommonFormByIdMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddCommonFormByIdMutation, TError, AddCommonFormByIdMutationVariables, TContext>(
      ['addCommonFormById'],
      (variables?: AddCommonFormByIdMutationVariables) => fetcher<AddCommonFormByIdMutation, AddCommonFormByIdMutationVariables>(client, AddCommonFormByIdDocument, variables, headers)(),
      options
    );
useAddCommonFormByIdMutation.fetcher = (client: GraphQLClient, variables: AddCommonFormByIdMutationVariables, headers?: RequestInit['headers']) => fetcher<AddCommonFormByIdMutation, AddCommonFormByIdMutationVariables>(client, AddCommonFormByIdDocument, variables, headers);
export const AddDentalFormDocument = `
    mutation addDentalForm($access_token: String!, $dental: DentalInput!) {
  addForm(access_token: $access_token, dental: $dental) {
    dental {
      Q1 {
        commentQ1
        dateQ1
        selectedQ1
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        selectedQ3
      }
      Q4 {
        selectedQ4
      }
      Q5 {
        selectedQ5
      }
    }
  }
}
    `;
export const useAddDentalFormMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddDentalFormMutation, TError, AddDentalFormMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddDentalFormMutation, TError, AddDentalFormMutationVariables, TContext>(
      ['addDentalForm'],
      (variables?: AddDentalFormMutationVariables) => fetcher<AddDentalFormMutation, AddDentalFormMutationVariables>(client, AddDentalFormDocument, variables, headers)(),
      options
    );
useAddDentalFormMutation.fetcher = (client: GraphQLClient, variables: AddDentalFormMutationVariables, headers?: RequestInit['headers']) => fetcher<AddDentalFormMutation, AddDentalFormMutationVariables>(client, AddDentalFormDocument, variables, headers);
export const AddDentalFormByIdDocument = `
    mutation addDentalFormById($id: ID!, $dental: DentalInput!) {
  addFormById(id: $id, dental: $dental) {
    dental {
      Q1 {
        commentQ1
        dateQ1
        selectedQ1
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        selectedQ3
      }
      Q4 {
        selectedQ4
      }
      Q5 {
        selectedQ5
      }
    }
  }
}
    `;
export const useAddDentalFormByIdMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddDentalFormByIdMutation, TError, AddDentalFormByIdMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddDentalFormByIdMutation, TError, AddDentalFormByIdMutationVariables, TContext>(
      ['addDentalFormById'],
      (variables?: AddDentalFormByIdMutationVariables) => fetcher<AddDentalFormByIdMutation, AddDentalFormByIdMutationVariables>(client, AddDentalFormByIdDocument, variables, headers)(),
      options
    );
useAddDentalFormByIdMutation.fetcher = (client: GraphQLClient, variables: AddDentalFormByIdMutationVariables, headers?: RequestInit['headers']) => fetcher<AddDentalFormByIdMutation, AddDentalFormByIdMutationVariables>(client, AddDentalFormByIdDocument, variables, headers);
export const AddMedicalFormDocument = `
    mutation addMedicalForm($access_token: String!, $medical: MedicalInput!) {
  addForm(access_token: $access_token, medical: $medical) {
    medical {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q2 {
        bodyQ2
        commentQ2
        faceQ2
      }
      Q3 {
        answerQ3
        clinic_anotherQ3
        clinic_otherQ3
        clinic_salonQ3
        selected_fatDissolvingQ3
        selected_laserQ3
        selected_peelingQ3
      }
      Q4 {
        constipationQ4
        favoriteQ4
        selectedQ4
        sleepQ4
        stomachQ4
        ultravioletRaysQ4
      }
      Q5 {
        doctorsCosmeQ5
        selectedQ5
        skincareItemQ5
      }
      Q6 {
        commentQ6
        selectedQ6
      }
    }
  }
}
    `;
export const useAddMedicalFormMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddMedicalFormMutation, TError, AddMedicalFormMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddMedicalFormMutation, TError, AddMedicalFormMutationVariables, TContext>(
      ['addMedicalForm'],
      (variables?: AddMedicalFormMutationVariables) => fetcher<AddMedicalFormMutation, AddMedicalFormMutationVariables>(client, AddMedicalFormDocument, variables, headers)(),
      options
    );
useAddMedicalFormMutation.fetcher = (client: GraphQLClient, variables: AddMedicalFormMutationVariables, headers?: RequestInit['headers']) => fetcher<AddMedicalFormMutation, AddMedicalFormMutationVariables>(client, AddMedicalFormDocument, variables, headers);
export const AddMedicalFormByIdDocument = `
    mutation addMedicalFormById($id: ID!, $medical: MedicalInput!) {
  addFormById(id: $id, medical: $medical) {
    medical {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q2 {
        bodyQ2
        commentQ2
        faceQ2
      }
      Q3 {
        answerQ3
        clinic_anotherQ3
        clinic_otherQ3
        clinic_salonQ3
        selected_fatDissolvingQ3
        selected_laserQ3
        selected_peelingQ3
      }
      Q4 {
        constipationQ4
        favoriteQ4
        selectedQ4
        sleepQ4
        stomachQ4
        ultravioletRaysQ4
      }
      Q5 {
        doctorsCosmeQ5
        selectedQ5
        skincareItemQ5
      }
      Q6 {
        commentQ6
        selectedQ6
      }
    }
  }
}
    `;
export const useAddMedicalFormByIdMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddMedicalFormByIdMutation, TError, AddMedicalFormByIdMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddMedicalFormByIdMutation, TError, AddMedicalFormByIdMutationVariables, TContext>(
      ['addMedicalFormById'],
      (variables?: AddMedicalFormByIdMutationVariables) => fetcher<AddMedicalFormByIdMutation, AddMedicalFormByIdMutationVariables>(client, AddMedicalFormByIdDocument, variables, headers)(),
      options
    );
useAddMedicalFormByIdMutation.fetcher = (client: GraphQLClient, variables: AddMedicalFormByIdMutationVariables, headers?: RequestInit['headers']) => fetcher<AddMedicalFormByIdMutation, AddMedicalFormByIdMutationVariables>(client, AddMedicalFormByIdDocument, variables, headers);
export const AddOrthodonticsFormDocument = `
    mutation addOrthodonticsForm($access_token: String!, $orthodontics: OrthodonticsInput!) {
  addForm(access_token: $access_token, orthodontics: $orthodontics) {
    orthodontics {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        dateQ3
      }
      Q4 {
        answerQ4
        dateQ4
      }
      Q5 {
        commentQ5
        dateQ5
        selectedQ5
      }
      Q6 {
        selectedQ6
      }
      Q7 {
        commentQ7
        selectedQ7
      }
      Q8 {
        answerQ8
      }
      Q9 {
        selectedQ9
      }
      Q10 {
        commentQ10
        selectedQ10
      }
    }
  }
}
    `;
export const useAddOrthodonticsFormMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddOrthodonticsFormMutation, TError, AddOrthodonticsFormMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddOrthodonticsFormMutation, TError, AddOrthodonticsFormMutationVariables, TContext>(
      ['addOrthodonticsForm'],
      (variables?: AddOrthodonticsFormMutationVariables) => fetcher<AddOrthodonticsFormMutation, AddOrthodonticsFormMutationVariables>(client, AddOrthodonticsFormDocument, variables, headers)(),
      options
    );
useAddOrthodonticsFormMutation.fetcher = (client: GraphQLClient, variables: AddOrthodonticsFormMutationVariables, headers?: RequestInit['headers']) => fetcher<AddOrthodonticsFormMutation, AddOrthodonticsFormMutationVariables>(client, AddOrthodonticsFormDocument, variables, headers);
export const AddOrthodonticsFormByIdDocument = `
    mutation addOrthodonticsFormById($id: ID!, $orthodontics: OrthodonticsInput!) {
  addFormById(id: $id, orthodontics: $orthodontics) {
    orthodontics {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        dateQ3
      }
      Q4 {
        answerQ4
        dateQ4
      }
      Q5 {
        commentQ5
        dateQ5
        selectedQ5
      }
      Q6 {
        selectedQ6
      }
      Q7 {
        commentQ7
        selectedQ7
      }
      Q8 {
        answerQ8
      }
      Q9 {
        selectedQ9
      }
      Q10 {
        commentQ10
        selectedQ10
      }
    }
  }
}
    `;
export const useAddOrthodonticsFormByIdMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddOrthodonticsFormByIdMutation, TError, AddOrthodonticsFormByIdMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddOrthodonticsFormByIdMutation, TError, AddOrthodonticsFormByIdMutationVariables, TContext>(
      ['addOrthodonticsFormById'],
      (variables?: AddOrthodonticsFormByIdMutationVariables) => fetcher<AddOrthodonticsFormByIdMutation, AddOrthodonticsFormByIdMutationVariables>(client, AddOrthodonticsFormByIdDocument, variables, headers)(),
      options
    );
useAddOrthodonticsFormByIdMutation.fetcher = (client: GraphQLClient, variables: AddOrthodonticsFormByIdMutationVariables, headers?: RequestInit['headers']) => fetcher<AddOrthodonticsFormByIdMutation, AddOrthodonticsFormByIdMutationVariables>(client, AddOrthodonticsFormByIdDocument, variables, headers);
export const AddFormDocument = `
    mutation addForm($access_token: String!, $common: CommonInput, $dental: DentalInput, $medical: MedicalInput, $orthodontics: OrthodonticsInput) {
  addForm(access_token: $access_token, common: $common, dental: $dental, medical: $medical, orthodontics: $orthodontics) {
    common {
      Q1 {
        answerQ1
        diseaseQ1
        selected_clinicQ1
        selected_medicineQ1
      }
      Q2 {
        answerQ2
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        selectedQ3
      }
      Q4 {
        answerQ4
        selectedQ4
        selected_optionsQ4
      }
      Q5 {
        answerQ5
      }
      Q6 {
        answerQ6
        commentQ6
        dateQ6
        selectedQ6
      }
    }
    dental {
      Q1 {
        commentQ1
        dateQ1
        selectedQ1
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        selectedQ3
      }
      Q4 {
        selectedQ4
      }
      Q5 {
        selectedQ5
      }
    }
    medical {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q2 {
        bodyQ2
        commentQ2
        faceQ2
      }
      Q3 {
        answerQ3
        clinic_anotherQ3
        clinic_otherQ3
        clinic_salonQ3
        selected_fatDissolvingQ3
        selected_laserQ3
        selected_peelingQ3
      }
      Q4 {
        constipationQ4
        favoriteQ4
        selectedQ4
        sleepQ4
        stomachQ4
        ultravioletRaysQ4
      }
      Q5 {
        doctorsCosmeQ5
        selectedQ5
        skincareItemQ5
      }
      Q6 {
        commentQ6
        selectedQ6
      }
    }
    orthodontics {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q10 {
        commentQ10
        selectedQ10
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        dateQ3
      }
      Q4 {
        answerQ4
        dateQ4
      }
      Q5 {
        commentQ5
        dateQ5
        selectedQ5
      }
      Q6 {
        selectedQ6
      }
      Q7 {
        commentQ7
        selectedQ7
      }
      Q8 {
        answerQ8
      }
      Q9 {
        selectedQ9
      }
    }
  }
}
    `;
export const useAddFormMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddFormMutation, TError, AddFormMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddFormMutation, TError, AddFormMutationVariables, TContext>(
      ['addForm'],
      (variables?: AddFormMutationVariables) => fetcher<AddFormMutation, AddFormMutationVariables>(client, AddFormDocument, variables, headers)(),
      options
    );
useAddFormMutation.fetcher = (client: GraphQLClient, variables: AddFormMutationVariables, headers?: RequestInit['headers']) => fetcher<AddFormMutation, AddFormMutationVariables>(client, AddFormDocument, variables, headers);
export const AddFormByIdDocument = `
    mutation addFormById($id: ID!, $common: CommonInput, $dental: DentalInput, $medical: MedicalInput, $orthodontics: OrthodonticsInput) {
  addFormById(id: $id, common: $common, dental: $dental, medical: $medical, orthodontics: $orthodontics) {
    common {
      Q1 {
        answerQ1
        diseaseQ1
        selected_clinicQ1
        selected_medicineQ1
      }
      Q2 {
        answerQ2
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        selectedQ3
      }
      Q4 {
        answerQ4
        selectedQ4
        selected_optionsQ4
      }
      Q5 {
        answerQ5
      }
      Q6 {
        answerQ6
        commentQ6
        dateQ6
        selectedQ6
      }
    }
    dental {
      Q1 {
        commentQ1
        dateQ1
        selectedQ1
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        selectedQ3
      }
      Q4 {
        selectedQ4
      }
      Q5 {
        selectedQ5
      }
    }
    medical {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q2 {
        bodyQ2
        commentQ2
        faceQ2
      }
      Q3 {
        answerQ3
        clinic_anotherQ3
        clinic_otherQ3
        clinic_salonQ3
        selected_fatDissolvingQ3
        selected_laserQ3
        selected_peelingQ3
      }
      Q4 {
        constipationQ4
        favoriteQ4
        selectedQ4
        sleepQ4
        stomachQ4
        ultravioletRaysQ4
      }
      Q5 {
        doctorsCosmeQ5
        selectedQ5
        skincareItemQ5
      }
      Q6 {
        commentQ6
        selectedQ6
      }
    }
    orthodontics {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q10 {
        commentQ10
        selectedQ10
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        dateQ3
      }
      Q4 {
        answerQ4
        dateQ4
      }
      Q5 {
        commentQ5
        dateQ5
        selectedQ5
      }
      Q6 {
        selectedQ6
      }
      Q7 {
        commentQ7
        selectedQ7
      }
      Q8 {
        answerQ8
      }
      Q9 {
        selectedQ9
      }
    }
  }
}
    `;
export const useAddFormByIdMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddFormByIdMutation, TError, AddFormByIdMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddFormByIdMutation, TError, AddFormByIdMutationVariables, TContext>(
      ['addFormById'],
      (variables?: AddFormByIdMutationVariables) => fetcher<AddFormByIdMutation, AddFormByIdMutationVariables>(client, AddFormByIdDocument, variables, headers)(),
      options
    );
useAddFormByIdMutation.fetcher = (client: GraphQLClient, variables: AddFormByIdMutationVariables, headers?: RequestInit['headers']) => fetcher<AddFormByIdMutation, AddFormByIdMutationVariables>(client, AddFormByIdDocument, variables, headers);
export const DeleteFormDocument = `
    mutation deleteForm($access_token: String!) {
  deleteForm(access_token: $access_token) {
    common {
      Q1 {
        answerQ1
        diseaseQ1
        selected_clinicQ1
        selected_medicineQ1
      }
      Q2 {
        answerQ2
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        selectedQ3
      }
      Q4 {
        answerQ4
        selectedQ4
        selected_optionsQ4
      }
      Q5 {
        answerQ5
      }
      Q6 {
        answerQ6
        commentQ6
        dateQ6
        selectedQ6
      }
    }
    dental {
      Q1 {
        commentQ1
        dateQ1
        selectedQ1
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        selectedQ3
      }
      Q4 {
        selectedQ4
      }
      Q5 {
        selectedQ5
      }
    }
    medical {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q2 {
        bodyQ2
        commentQ2
        faceQ2
      }
      Q3 {
        answerQ3
        clinic_anotherQ3
        clinic_otherQ3
        clinic_salonQ3
        selectedQ3
        selected_fatDissolvingQ3
        selected_laserQ3
        selected_peelingQ3
      }
      Q4 {
        commentQ4
        constipationQ4
        favoriteQ4
        selectedQ4
        sleepQ4
        stomachQ4
        ultravioletRaysQ4
      }
      Q5 {
        doctorsCosmeQ5
        selectedQ5
        skincareItemQ5
      }
      Q6 {
        commentQ6
        selectedQ6
      }
    }
    orthodontics {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q10 {
        commentQ10
        selectedQ10
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        dateQ3
      }
      Q4 {
        answerQ4
        dateQ4
      }
      Q5 {
        commentQ5
        dateQ5
        selectedQ5
      }
      Q6 {
        selectedQ6
      }
      Q7 {
        commentQ7
        selectedQ7
      }
      Q8 {
        answerQ8
      }
      Q9 {
        selectedQ9
      }
    }
  }
}
    `;
export const useDeleteFormMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteFormMutation, TError, DeleteFormMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteFormMutation, TError, DeleteFormMutationVariables, TContext>(
      ['deleteForm'],
      (variables?: DeleteFormMutationVariables) => fetcher<DeleteFormMutation, DeleteFormMutationVariables>(client, DeleteFormDocument, variables, headers)(),
      options
    );
useDeleteFormMutation.fetcher = (client: GraphQLClient, variables: DeleteFormMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteFormMutation, DeleteFormMutationVariables>(client, DeleteFormDocument, variables, headers);
export const DeleteFormByIdDocument = `
    mutation deleteFormById($id: ID!) {
  deleteFormById(id: $id) {
    common {
      Q1 {
        answerQ1
        diseaseQ1
        selected_clinicQ1
        selected_medicineQ1
      }
      Q2 {
        answerQ2
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        selectedQ3
      }
      Q4 {
        answerQ4
        selectedQ4
        selected_optionsQ4
      }
      Q5 {
        answerQ5
      }
      Q6 {
        answerQ6
        commentQ6
        dateQ6
        selectedQ6
      }
    }
    dental {
      Q1 {
        commentQ1
        dateQ1
        selectedQ1
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        selectedQ3
      }
      Q4 {
        selectedQ4
      }
      Q5 {
        selectedQ5
      }
    }
    medical {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q2 {
        bodyQ2
        commentQ2
        faceQ2
      }
      Q3 {
        answerQ3
        clinic_anotherQ3
        clinic_otherQ3
        clinic_salonQ3
        selectedQ3
        selected_fatDissolvingQ3
        selected_laserQ3
        selected_peelingQ3
      }
      Q4 {
        commentQ4
        constipationQ4
        favoriteQ4
        selectedQ4
        sleepQ4
        stomachQ4
        ultravioletRaysQ4
      }
      Q5 {
        doctorsCosmeQ5
        selectedQ5
        skincareItemQ5
      }
      Q6 {
        commentQ6
        selectedQ6
      }
    }
    orthodontics {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q10 {
        commentQ10
        selectedQ10
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        dateQ3
      }
      Q4 {
        answerQ4
        dateQ4
      }
      Q5 {
        commentQ5
        dateQ5
        selectedQ5
      }
      Q6 {
        selectedQ6
      }
      Q7 {
        selectedQ7
        commentQ7
      }
      Q8 {
        answerQ8
      }
      Q9 {
        selectedQ9
      }
    }
  }
}
    `;
export const useDeleteFormByIdMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteFormByIdMutation, TError, DeleteFormByIdMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteFormByIdMutation, TError, DeleteFormByIdMutationVariables, TContext>(
      ['deleteFormById'],
      (variables?: DeleteFormByIdMutationVariables) => fetcher<DeleteFormByIdMutation, DeleteFormByIdMutationVariables>(client, DeleteFormByIdDocument, variables, headers)(),
      options
    );
useDeleteFormByIdMutation.fetcher = (client: GraphQLClient, variables: DeleteFormByIdMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteFormByIdMutation, DeleteFormByIdMutationVariables>(client, DeleteFormByIdDocument, variables, headers);
export const GetRolesDocument = `
    query getRoles($id: ID!) {
  getRoles(id: $id) {
    id
    name
    status
  }
}
    `;
export const useGetRolesQuery = <
      TData = GetRolesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetRolesQueryVariables,
      options?: UseQueryOptions<GetRolesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetRolesQuery, TError, TData>(
      ['getRoles', variables],
      fetcher<GetRolesQuery, GetRolesQueryVariables>(client, GetRolesDocument, variables, headers),
      options
    );

useGetRolesQuery.getKey = (variables: GetRolesQueryVariables) => ['getRoles', variables];
;

useGetRolesQuery.fetcher = (client: GraphQLClient, variables: GetRolesQueryVariables, headers?: RequestInit['headers']) => fetcher<GetRolesQuery, GetRolesQueryVariables>(client, GetRolesDocument, variables, headers);
export const ListRolesDocument = `
    query listRoles($clinic_id: ID!) {
  listRoles(clinic_id: $clinic_id) {
    Roles {
      id
      name
      status
      clinic_id
    }
  }
}
    `;
export const useListRolesQuery = <
      TData = ListRolesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListRolesQueryVariables,
      options?: UseQueryOptions<ListRolesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListRolesQuery, TError, TData>(
      ['listRoles', variables],
      fetcher<ListRolesQuery, ListRolesQueryVariables>(client, ListRolesDocument, variables, headers),
      options
    );

useListRolesQuery.getKey = (variables: ListRolesQueryVariables) => ['listRoles', variables];
;

useListRolesQuery.fetcher = (client: GraphQLClient, variables: ListRolesQueryVariables, headers?: RequestInit['headers']) => fetcher<ListRolesQuery, ListRolesQueryVariables>(client, ListRolesDocument, variables, headers);
export const AddRolesDocument = `
    mutation addRoles($name: String, $status: Boolean, $clinic_id: ID!) {
  addRoles(name: $name, status: $status, clinic_id: $clinic_id) {
    id
    name
    status
    clinic_id
  }
}
    `;
export const useAddRolesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddRolesMutation, TError, AddRolesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddRolesMutation, TError, AddRolesMutationVariables, TContext>(
      ['addRoles'],
      (variables?: AddRolesMutationVariables) => fetcher<AddRolesMutation, AddRolesMutationVariables>(client, AddRolesDocument, variables, headers)(),
      options
    );
useAddRolesMutation.fetcher = (client: GraphQLClient, variables: AddRolesMutationVariables, headers?: RequestInit['headers']) => fetcher<AddRolesMutation, AddRolesMutationVariables>(client, AddRolesDocument, variables, headers);
export const DeleteRolesDocument = `
    mutation deleteRoles($id: ID!) {
  deleteRoles(id: $id) {
    id
    name
    status
  }
}
    `;
export const useDeleteRolesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteRolesMutation, TError, DeleteRolesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteRolesMutation, TError, DeleteRolesMutationVariables, TContext>(
      ['deleteRoles'],
      (variables?: DeleteRolesMutationVariables) => fetcher<DeleteRolesMutation, DeleteRolesMutationVariables>(client, DeleteRolesDocument, variables, headers)(),
      options
    );
useDeleteRolesMutation.fetcher = (client: GraphQLClient, variables: DeleteRolesMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteRolesMutation, DeleteRolesMutationVariables>(client, DeleteRolesDocument, variables, headers);
export const UpdateRolesDocument = `
    mutation updateRoles($id: ID!, $name: String, $status: Boolean) {
  updateRoles(id: $id, name: $name, status: $status) {
    id
    name
    status
  }
}
    `;
export const useUpdateRolesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateRolesMutation, TError, UpdateRolesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateRolesMutation, TError, UpdateRolesMutationVariables, TContext>(
      ['updateRoles'],
      (variables?: UpdateRolesMutationVariables) => fetcher<UpdateRolesMutation, UpdateRolesMutationVariables>(client, UpdateRolesDocument, variables, headers)(),
      options
    );
useUpdateRolesMutation.fetcher = (client: GraphQLClient, variables: UpdateRolesMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateRolesMutation, UpdateRolesMutationVariables>(client, UpdateRolesDocument, variables, headers);
export const GetShiftDocument = `
    query getShift($date: AWSTimestamp!, $id: ID!) {
  getShift(date: $date, id: $id) {
    id
    date
    name
    shifts
    workingTimes {
      am
      pm
    }
  }
}
    `;
export const useGetShiftQuery = <
      TData = GetShiftQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetShiftQueryVariables,
      options?: UseQueryOptions<GetShiftQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetShiftQuery, TError, TData>(
      ['getShift', variables],
      fetcher<GetShiftQuery, GetShiftQueryVariables>(client, GetShiftDocument, variables, headers),
      options
    );

useGetShiftQuery.getKey = (variables: GetShiftQueryVariables) => ['getShift', variables];
;

useGetShiftQuery.fetcher = (client: GraphQLClient, variables: GetShiftQueryVariables, headers?: RequestInit['headers']) => fetcher<GetShiftQuery, GetShiftQueryVariables>(client, GetShiftDocument, variables, headers);
export const GetTodayShiftDocument = `
    query getTodayShift($date: AWSTimestamp!) {
  getTodayShift(date: $date) {
    Shifts {
      date
      id
      name
      shifts
      workingTimes {
        am
        pm
      }
    }
  }
}
    `;
export const useGetTodayShiftQuery = <
      TData = GetTodayShiftQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetTodayShiftQueryVariables,
      options?: UseQueryOptions<GetTodayShiftQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetTodayShiftQuery, TError, TData>(
      ['getTodayShift', variables],
      fetcher<GetTodayShiftQuery, GetTodayShiftQueryVariables>(client, GetTodayShiftDocument, variables, headers),
      options
    );

useGetTodayShiftQuery.getKey = (variables: GetTodayShiftQueryVariables) => ['getTodayShift', variables];
;

useGetTodayShiftQuery.fetcher = (client: GraphQLClient, variables: GetTodayShiftQueryVariables, headers?: RequestInit['headers']) => fetcher<GetTodayShiftQuery, GetTodayShiftQueryVariables>(client, GetTodayShiftDocument, variables, headers);
export const GetWeeklyShiftDocument = `
    query getWeeklyShift($id: ID!, $weekStart: AWSTimestamp!, $weekEnd: AWSTimestamp!) {
  getWeeklyShift(id: $id, weekEnd: $weekEnd, weekStart: $weekStart) {
    Shifts {
      date
      id
      name
      shifts
      workingTimes {
        am
        pm
      }
    }
  }
}
    `;
export const useGetWeeklyShiftQuery = <
      TData = GetWeeklyShiftQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetWeeklyShiftQueryVariables,
      options?: UseQueryOptions<GetWeeklyShiftQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetWeeklyShiftQuery, TError, TData>(
      ['getWeeklyShift', variables],
      fetcher<GetWeeklyShiftQuery, GetWeeklyShiftQueryVariables>(client, GetWeeklyShiftDocument, variables, headers),
      options
    );

useGetWeeklyShiftQuery.getKey = (variables: GetWeeklyShiftQueryVariables) => ['getWeeklyShift', variables];
;

useGetWeeklyShiftQuery.fetcher = (client: GraphQLClient, variables: GetWeeklyShiftQueryVariables, headers?: RequestInit['headers']) => fetcher<GetWeeklyShiftQuery, GetWeeklyShiftQueryVariables>(client, GetWeeklyShiftDocument, variables, headers);
export const ListShiftDocument = `
    query listShift {
  listShift {
    Shifts {
      date
      id
      name
      shifts
      workingTimes {
        am
        pm
      }
    }
  }
}
    `;
export const useListShiftQuery = <
      TData = ListShiftQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ListShiftQueryVariables,
      options?: UseQueryOptions<ListShiftQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListShiftQuery, TError, TData>(
      variables === undefined ? ['listShift'] : ['listShift', variables],
      fetcher<ListShiftQuery, ListShiftQueryVariables>(client, ListShiftDocument, variables, headers),
      options
    );

useListShiftQuery.getKey = (variables?: ListShiftQueryVariables) => variables === undefined ? ['listShift'] : ['listShift', variables];
;

useListShiftQuery.fetcher = (client: GraphQLClient, variables?: ListShiftQueryVariables, headers?: RequestInit['headers']) => fetcher<ListShiftQuery, ListShiftQueryVariables>(client, ListShiftDocument, variables, headers);
export const AddShiftDocument = `
    mutation addShift($date: AWSTimestamp!, $id: ID!, $name: String!, $shifts: [Boolean!]!, $workingTimes: workingTimesInput!) {
  addShift(date: $date, id: $id, name: $name, shifts: $shifts, workingTimes: $workingTimes) {
    date
    id
    name
    shifts
    workingTimes {
      pm
      am
    }
  }
}
    `;
export const useAddShiftMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddShiftMutation, TError, AddShiftMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddShiftMutation, TError, AddShiftMutationVariables, TContext>(
      ['addShift'],
      (variables?: AddShiftMutationVariables) => fetcher<AddShiftMutation, AddShiftMutationVariables>(client, AddShiftDocument, variables, headers)(),
      options
    );
useAddShiftMutation.fetcher = (client: GraphQLClient, variables: AddShiftMutationVariables, headers?: RequestInit['headers']) => fetcher<AddShiftMutation, AddShiftMutationVariables>(client, AddShiftDocument, variables, headers);
export const BatchWriteShiftDocument = `
    mutation batchWriteShift($dates: [AWSTimestamp!]!, $id: ID!, $name: String!, $shifts: [Boolean!]!, $workingTimes: workingTimesInput!) {
  batchWriteShift(dates: $dates, id: $id, name: $name, shifts: $shifts, workingTimes: $workingTimes) {
    date
    id
    name
    shifts
    workingTimes {
      am
      pm
    }
  }
}
    `;
export const useBatchWriteShiftMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<BatchWriteShiftMutation, TError, BatchWriteShiftMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<BatchWriteShiftMutation, TError, BatchWriteShiftMutationVariables, TContext>(
      ['batchWriteShift'],
      (variables?: BatchWriteShiftMutationVariables) => fetcher<BatchWriteShiftMutation, BatchWriteShiftMutationVariables>(client, BatchWriteShiftDocument, variables, headers)(),
      options
    );
useBatchWriteShiftMutation.fetcher = (client: GraphQLClient, variables: BatchWriteShiftMutationVariables, headers?: RequestInit['headers']) => fetcher<BatchWriteShiftMutation, BatchWriteShiftMutationVariables>(client, BatchWriteShiftDocument, variables, headers);
export const DeleteShiftDocument = `
    mutation deleteShift($id: ID!, $date: AWSTimestamp!) {
  deleteShift(id: $id, date: $date) {
    date
    id
    name
    shifts
    workingTimes {
      am
      pm
    }
  }
}
    `;
export const useDeleteShiftMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteShiftMutation, TError, DeleteShiftMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteShiftMutation, TError, DeleteShiftMutationVariables, TContext>(
      ['deleteShift'],
      (variables?: DeleteShiftMutationVariables) => fetcher<DeleteShiftMutation, DeleteShiftMutationVariables>(client, DeleteShiftDocument, variables, headers)(),
      options
    );
useDeleteShiftMutation.fetcher = (client: GraphQLClient, variables: DeleteShiftMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteShiftMutation, DeleteShiftMutationVariables>(client, DeleteShiftDocument, variables, headers);
export const UpdateShiftDocument = `
    mutation updateShift($id: ID!, $date: AWSTimestamp!, $name: String, $shifts: [Boolean!], $workingTime: workingTimesInput) {
  updateShift(id: $id, date: $date, name: $name, shifts: $shifts, workingTimes: $workingTime) {
    date
    id
    name
    shifts
    workingTimes {
      am
      pm
    }
  }
}
    `;
export const useUpdateShiftMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateShiftMutation, TError, UpdateShiftMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateShiftMutation, TError, UpdateShiftMutationVariables, TContext>(
      ['updateShift'],
      (variables?: UpdateShiftMutationVariables) => fetcher<UpdateShiftMutation, UpdateShiftMutationVariables>(client, UpdateShiftDocument, variables, headers)(),
      options
    );
useUpdateShiftMutation.fetcher = (client: GraphQLClient, variables: UpdateShiftMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateShiftMutation, UpdateShiftMutationVariables>(client, UpdateShiftDocument, variables, headers);